<template>
  <div id="permissions-simple" class="content-wrapper sm:block">
    <div class="sm:fixed sm:h-[calc(100vh-50px)] top-12 left-4 overflow-y-auto">
      <!-------------------------

        SIDEBAR

        ----------------------------->
      <bly-sidebar-item
        v-bind="{
          item: inputs,
          contextName: 'input',
          active: listType === 'input',
          select,
          add: showAddForm,
          addType: 'input',
          icon: 'input',
        }"
      ></bly-sidebar-item>

      <bly-sidebar-item
        v-bind="{
          item: outputs,
          contextName: 'output',
          active: listType === 'output',
          select,
          add: showAddForm,
          addType: 'output',
          icon: 'output',
        }"
      ></bly-sidebar-item>

      <bly-sidebar-item
        v-bind="{
          item: outputProfiles,
          contextName: 'outputProfile',
          active: listType === 'outputProfile',
          select,
          add: showAddForm,
          addType: 'outputProfile',
          icon: 'folder',
        }"
      ></bly-sidebar-item>

      <bly-sidebar-item
        v-bind="{
          item: inputProfiles,
          contextName: 'inputProfile',
          displayName: 'Input Profiles',
          active: listType === 'inputProfile',
          select,
          add: showAddForm,
          addType: 'inputProfile',
          icon: 'folder',
        }"
      ></bly-sidebar-item>

      <bly-sidebar-item
        v-bind="{
          item: providers,
          contextName: 'provider',
          displayName: 'Providers',
          active: listType === 'provider',
          select,
          add: showAddForm,
          addType: 'provider',
          icon: 'folder',
        }"
      ></bly-sidebar-item>

      <bly-sidebar-item
        v-if="isSysAdmin"
        v-bind="{
          item: locations,
          contextName: 'locations',
          displayName: 'Locations',
          active: listType === 'locations',
          select,
          add: showAddForm,
          addType: 'location',
          icon: 'folder',
        }"
      ></bly-sidebar-item>

      <!-- <bly-sidebar-item
        v-bind="{
          item: routers,
          contextName: 'routers',
          active: listType === 'routers',
          select,
          add: showAddForm,
          addType: 'router',
          icon: 'share',
        }"
      ></bly-sidebar-item> -->

      <!-- <bly-sidebar-item
        v-bind="{
          item: routerGroups,
          contextName: 'routerGroups',
          active: listType === 'routerGroups',
          select,
          add: showAddForm,
          addType: 'routerGroup',
          icon: 'output',
        }"
      ></bly-sidebar-item> -->

      <!-- <bly-sidebar-item
        v-bind="{
          item: multiviewers,
          contextName: 'multiviewer',
          active: listType === 'multiviewer',
          select,
          add: showAddForm,
          addType: 'multiviewer',
          icon: 'folder',
        }"
      ></bly-sidebar-item>

      <bly-sidebar-item
        v-bind="{
          item: routerSources,
          contextName: 'sources',
          active: listType === 'sources',
          select,
          add: showAddForm,
          addType: 'routerSource',
          icon: 'folder',
        }"
      ></bly-sidebar-item> -->

      <!-- <bly-sidebar-item
        v-bind="{
          item: routerDestinations,
          contextName: 'destinations',
          active: listType === 'destinations',
          select,
          add: showAddForm,
          addType: 'routerDestination',
          icon: 'folder',
        }"
      ></bly-sidebar-item> -->

      <!-- <bly-sidebar-item
        v-bind="{
          item: streamSources,
          contextName: 'streamSources',
          active: listType === 'streamSources',
          select,
          add: showAddForm,
          addType: 'streamSource',
          icon: 'folder',
        }"
      ></bly-sidebar-item> -->

      <!-- <bly-sidebar-item
        v-bind="{
          item: streamDestinations,
          contextName: 'streamDestinations',
          active: listType === 'streamDestinations',
          select,
          add: showAddForm,
          addType: 'streamDestination',
          icon: 'folder',
        }"
      >
      </bly-sidebar-item> -->
      <!-- <bly-sidebar-item
        v-bind="{
          item: transcoderProfiles,
          contextName: 'transcoderProfiles',
          active: listType === 'transcoderProfiles',
          select,
          add: showAddForm,
          addType: 'transcoderProfile',
          icon: 'folder',
        }"
      >
      </bly-sidebar-item> -->

      <bly-sidebar-item
        v-bind="{
          item: transcodingProfiles,
          contextName: 'transcodingProfile',
          displayName: 'Transcoding Channel',
          active: listType === 'transcodingProfile',
          select,
          add: showAddForm,
          addType: 'transcodingProfile',
          icon: 'folder',
        }"
      ></bly-sidebar-item>

      <bly-sidebar-item
        v-bind="{
          item: transcodingOutputs,
          contextName: 'transcodingOutput',
          active: listType === 'transcodingOutput',
          select,
          add: showAddForm,
          addType: 'transcodingOutput',
          icon: 'folder',
        }"
      ></bly-sidebar-item>
    </div>

    <!-------------------------

        CONTENT LIST

      ----------------------------->
    <div
      class="data-content sm:ml-56"
      v-loading="loading"
      element-loading-text="Loading data"
      element-loading-background="rgba(19, 25, 29, 1)"
    >
      <div
        class="flex justify-between items-center fixed top-12 sm:left-56 right-4 bg-[#13191d] z-10 py-2 px-4 shadow-md"
      >
        <div class="data-header-name">
          {{ listName }} <span class="opacity-50">({{ totalCount }} items)</span>
        </div>
        <div class="flex items-center gap-4">
          <div v-if="listType === 'input'" class="">
            <select
              v-model="selectedInputTypeFilter"
              class="h-8 w-44 rounded border border-white/15 bg-[#13191d] px-2 text-xs text-white outline-none transition focus:border-[#FFAA00] focus:ring-1 focus:ring-[#FFAA00]"
            >
              <option value="">All input types</option>
              <option v-for="type in availableInputTypeFilters" :key="type" :value="type">
                {{ type }}
              </option>
            </select>
          </div>
          <div v-if="listType === 'output'" class="">
            <select
              v-model="selectedOutputTypeFilter"
              class="h-8 w-44 rounded border border-white/15 bg-[#13191d] px-2 text-xs text-white outline-none transition focus:border-[#FFAA00] focus:ring-1 focus:ring-[#FFAA00]"
            >
              <option value="">All output types</option>
              <option v-for="type in availableOutputTypeFilters" :key="type" :value="type">
                {{ type }}
              </option>
            </select>
          </div>
          <div class="">
            <input
              type="search"
              name=""
              id=""
              v-model="searchQuery"
              placeholder="Search"
              class="h-8 rounded border border-white/15 bg-[#13191d] px-3 py-1 text-sm text-white outline-none transition placeholder:text-white/60 focus:border-[#FFAA00] focus:ring-1 focus:ring-[#FFAA00]"
            />
          </div>
          <el-tooltip content="Toggle compact list">
            <ma-list class="icon-btn bly-list ma-btn"
              :class="{ active: listCompactStyle }"
              @click="listCompactStyle = !listCompactStyle"></ma-list>
          </el-tooltip>
        </div>
      </div>
      <div class="items" :class="{ compact: listCompactStyle }">
        <transition-group name="list" tag="div">
          <div
            class="data-list-item w-full"
            v-for="(item, index) in displayList"
            :key="item.id + 'xxx' + index"
            :class="{ disabled: !item || item.id === 'missing' }"
            @click="selectItem(item)"
          >
            <div class="data-list-item-name">
              <span v-show="!item.editing"
                >{{ item.name }}
                <span class="text-gray-500 ml-1" @click="copy(item.id)">{{ item.id }}</span>
                <span
                  v-if="listType === 'output'"
                  class="text-xs py-0.5 px-1 rounded-sm inline-block bg-red-100 text-red-500 ml-2 -mt-1 relative -top-0.5"
                  >{{ item.status }}</span
                >
              </span>
              <span class="data-list-item-description" v-show="!item.editing">{{
                item.description | defaultValue("----")
              }}</span>
              <el-input v-show="item.editing" v-model="item.name" size="mini" />
            </div>
            <div class="data-list-item-actions">
              <ma-edit v-if="listType !== 'locations'" v-show="!item.editing"
                class="bly-edit icon-btn ma-btn"
                @click.stop="
                  usesPermissionModal(listType)
                    ? openPermissionModal('edit', listType, item)
                    : (editItem(item), (item.editing = true))
                "></ma-edit>
              <ma-delete v-if="usesPermissionModal(listType)"
                v-show="!item.editing"
                class="bly-delete icon-btn ma-btn"
                @click.stop="confirmDelete(item, index, listType)"></ma-delete>
              <el-popconfirm
                v-else
                confirmButtonText="OK"
                cancelButtonText="Cancel"
                @confirm="deleteItem(item, index, listType)"
                title="Are you sure to delete this?"
              >
                <ma-delete slot="reference" v-show="!item.editing" class="bly-delete icon-btn ma-btn"></ma-delete>
              </el-popconfirm>
              <el-button
                size="mini"
                v-show="item.editing"
                @click.native="
                  cancelEdit(item, item.index);
                  item.editing = false;
                "
                type="primary"
                >Cancel</el-button
              >
              <el-button
                size="mini"
                v-loading="item.saving"
                v-show="item.editing"
                @click.native="save(item, item.index)"
                type="primary"
                >Save</el-button
              >
            </div>
            <div class="claim-cascade" v-if="listType !== 'locations'" v-show="!listCompactStyle || item.editing">
              <div><ma-permissions class="bly-permissions"></ma-permissions> Access Claims</div>
              <div class="claim-cascade-input">
                <div v-if="!item.editing">
                  <el-tag
                    size="mini"
                    effect="dark"
                    type="info"
                    v-for="(c, index) in item.claimsCanAccess"
                    :key="index + c"
                  >
                    {{ claimsNames[c] }}
                  </el-tag>
                </div>
                <el-cascader
                  v-if="item.editing"
                  size="mini"
                  v-model="item.access"
                  :options="claimsTree"
                  :props="{ multiple: true, checkStrictly: true }"
                  :show-all-levels="false"
                  clearable
                ></el-cascader>
              </div>
            </div>
            <div class="claim-cascade" v-if="listType !== 'locations'" v-show="!listCompactStyle || item.editing">
              <div><ma-edit class="bly-edit"></ma-edit> Editing Claims</div>
              <div class="claim-cascade-input">
                <div v-if="!item.editing">
                  <el-tag
                    size="mini"
                    effect="dark"
                    v-for="(c, index) in item.claimsCanEdit"
                    :key="index + c"
                  >
                    {{ claimsNames[c] }}
                  </el-tag>
                </div>
                <el-cascader
                  size="mini"
                  v-if="item.editing"
                  v-model="item.edit"
                  :options="claimsTree"
                  :props="{ multiple: true, checkStrictly: true }"
                  :show-all-levels="false"
                  clearable
                ></el-cascader>
              </div>
            </div>
            <el-collapse-transition>
              <div class="extra-fields" v-if="item.editing">
                <el-row :gutter="12">
                  <bly-permission-form-item label="Description:" v-if="listType !== 'routerGroups'">
                    <el-input v-model="item.description" size="mini" />
                  </bly-permission-form-item>
                  <!-- ROUTER SPECIFIC DATA -->
                  <!-- ROUTER SPECIFIC DATA -->
                  <bly-permission-form-item label="Account:" v-if="listType === 'routers'">
                    <el-select
                      v-model="item.account"
                      placeholder="Select account"
                      value-key="id"
                      size="small"
                    >
                      <el-option
                        :key="account.id"
                        :value="account"
                        :label="account.client.name + ' > ' + account.name"
                        v-for="account in accounts"
                      >
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <!-- transcoding Channel/OUTPUT FIELDS -->
                  <div
                    v-if="listType === 'transcodingProfile' || listType === 'transcodingOutput'"
                    class="w-full"
                  >
                    <el-row :gutter="12">
                      <el-col :span="24">
                        <bly-permission-form-item label="Type:">
                          <el-select v-model="item.type" placeholder="Select type" size="mini" class="w-full">
                            <el-option label="MediaLive" value="MEDIA_LIVE"></el-option>
                          </el-select>
                        </bly-permission-form-item>
                      </el-col>
                      <el-col :span="24">
                        <bly-permission-form-item label="Config (JSON):" :span="{ sm: 24, md: 24, lg: 24 }">
                          <TranscodingConfigEditor v-if="listType === 'transcodingProfile'" v-model="item.config" />
                          <TranscodingOutputConfigEditor
                            v-else-if="listType === 'transcodingOutput'"
                            v-model="item.config"
                            @validation-change="transcodingOutputValid = $event.isValid; transcodingOutputErrors = $event.errors"
                          />
                        </bly-permission-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <!-- MULTIVIEWER SPECIFIC DATA -->
                  <bly-permission-form-item label="MV Type:" v-if="listType === 'multiviewer'">
                    <el-select v-model="item.type" placeholder="Multiviewer type" size="mini">
                      <el-option v-for="item in ['OTT', 'ROUTABLE']" :key="item" :value="item">
                        <span>{{ item }}</span>
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>
                  <bly-permission-form-item label="Grid Size:" v-if="listType === 'multiviewer'">
                    <el-input v-model="item.grid" placeholder="Grid size" required size="small">
                    </el-input>
                  </bly-permission-form-item>
                  <bly-permission-form-item
                    label="Audio Control ID:"
                    v-if="listType === 'multiviewer'"
                  >
                    <el-input
                      v-model="item.audioControlId"
                      placeholder="Audio control id"
                      required
                      size="small"
                    >
                    </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Destination ID:"
                    v-if="listType === 'multiviewer'"
                  >
                    <el-input
                      v-model="item.routableDestinationId"
                      placeholder="Destination ID"
                      required
                      size="small"
                    >
                    </el-input>
                  </bly-permission-form-item>
                  <bly-permission-form-item
                    label="Sources:"
                    :span="{ sm: 24, md: 24, lg: 24 }"
                    v-if="listType === 'multiviewer'"
                  >
                    <el-select
                      v-model="item.streamSources"
                      placeholder="Select stream sources"
                      value-key="id"
                      multiple
                      filterable
                      size="small"
                    >
                      <el-option
                        :key="source.id + item.id"
                        :value="source"
                        :label="source.name"
                        v-for="source in mvStreamSources"
                      >
                        <span>{{ source.name }}</span>
                        <small style="margin-left: 10px; opacity: 0.75; float: right">
                          {{ source.description }}
                        </small>
                      </el-option>
                    </el-select>
                    <draggable
                      tag="ul"
                      draggable=".item"
                      v-model="item.streamSources"
                      class="list-group mt-2"
                      handle=".leading-5"
                    >
                      <li
                        class="item list-group mb-1 p-0 px-2 bg-transparent h-8 leading-5"
                        v-for="source in item.streamSources"
                        :key="source.id"
                      >
                        <i class="handle far fa-bars"></i> {{ source.name }}
                      </li>
                    </draggable>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Router Group:"
                    :span="{ sm: 24, md: 24, lg: 24 }"
                    v-if="listType === 'routers'"
                  >
                    <el-select
                      v-model="item.routerGroups"
                      placeholder="Select"
                      value-key="id"
                      multiple
                      disabled
                      size="small"
                    >
                      <el-option
                        :key="el.id"
                        :value="el"
                        :label="el.name"
                        v-for="el in routerGroupList"
                      >
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Transcoder Profile:"
                    v-if="listType === 'transcoderProfiles'"
                  >
                    <el-input
                      v-model="item.transcoderProfile"
                      placeholder="Transcoder Profile"
                      required
                      size="small"
                    >
                    </el-input>
                  </bly-permission-form-item>

                  <!-- ROUTER SOURCE SPECIFIC DATA -->
                  <!-- ROUTER SOURCE SPECIFIC DATA -->
                  <bly-permission-form-item
                    label="Origin router group:"
                    v-if="listType === 'sources'"
                  >
                    <el-input
                      v-model="item.originRouterGroup"
                      placeholder="Origin router group"
                      required
                      size="small"
                    >
                    </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Origin router ID:" v-if="listType === 'sources'">
                    <el-input
                      v-model="item.originRouterId"
                      placeholder="Origin router ID"
                      required
                      size="small"
                    >
                    </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Origin router source ID:"
                    v-if="listType === 'sources'"
                  >
                    <el-input
                      v-model="item.originRouterSourceId"
                      placeholder="Origin router source ID"
                      required
                      size="small"
                    >
                    </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Inputs:"
                    :span="{ sm: 24, md: 24, lg: 24 }"
                    v-if="listType === 'sources'"
                  >
                    <el-select
                      v-model="item.mappedInputs"
                      placeholder="Select inputs"
                      value-key="id"
                      multiple
                      filterable
                      size="small"
                    >
                      <el-option
                        :key="el.id"
                        :value="el"
                        :label="el.name"
                        v-for="el in sortedInputs"
                      >
                        <span>{{ el.name }}</span>
                        <small style="margin-left: 10px; opacity: 0.75; float: right">
                          {{ el.description }}
                        </small>
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Router Groups:"
                    :span="{ sm: 24, md: 24, lg: 24 }"
                    v-if="listType === 'sources'"
                  >
                    <el-select
                      v-model="item.routerGroups"
                      placeholder="Select"
                      value-key="id"
                      multiple
                      disabled
                      size="small"
                    >
                      <el-option
                        :key="el.id"
                        :value="el"
                        :label="el.name"
                        v-for="el in routerGroupList"
                      >
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <!-- INPUT SPECIFIC DATA -->
                  <!-- INPUT SPECIFIC DATA -->
                  <bly-permission-form-item label="Input type:" v-if="listType === 'input'">
                    <el-select v-model="item.type" placeholder="Select input type" size="mini">
                      <el-option :key="type" v-for="type in inputTypes" :value="type"> </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="File base name:" v-if="listType === 'input'">
                    <el-input v-model="item.streamFileBaseName" size="mini" />
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Url:" v-if="listType === 'input'">
                    <el-input v-model="item.url" size="mini" />
                  </bly-permission-form-item>

                  <bly-permission-form-item label="FRC Available" v-if="listType === 'input'">
                    <el-switch v-model="item.frcAvailable" size="mini" />
                  </bly-permission-form-item>
                  <bly-permission-form-item label="Probe:" v-if="listType === 'input'">
                    <el-select
                      v-model="item.probe"
                      placeholder="Select Probe"
                      filterable
                      value-key="key"
                      size="mini"
                    >
                      <el-option-group v-for="probe in probes" :key="probe.id" :label="probe.name">
                        <el-option
                          v-for="item in probe.tasks"
                          :key="item.id"
                          :label="`${item.name} [${item.appId}]`"
                          :value="{ ...probe, task: item, key: item.id }"
                        >
                        </el-option>
                      </el-option-group>
                      <el-option :key="probe.id" v-for="probe in probes" :value="probe">
                        {{ probe.name }}
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Require Details" v-if="listType === 'input'">
                    <el-switch v-model="item.requireDetails" size="mini" />
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Location:" v-if="listType === 'input'">
                    <el-select
                      v-model="item.locationArray"
                      placeholder="Select locations"
                      size="mini"
                      multiple
                      clearable
                      @change="onLocationArrayChange(item)"
                    >
                      <el-option
                        :key="location.id + 'editItem'"
                        :value="location.code"
                        :label="location.name"
                        v-for="location in locations"
                      >
                        <span>{{ location.name }} ({{ location.code }})</span>
                        <small style="margin-left: 10px; opacity: 0.75; float: right">
                          {{ location.description }}
                        </small>
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <!-- MediaConnect ARN fields (read-only) -->
                  <bly-permission-form-item label="Router Input ARN:" v-if="listType === 'input' && item.type === 'MEDIA_CONNECT' && item.routerInputArn">
                    <el-input v-model="item.routerInputArn" size="mini" readonly />
                  </bly-permission-form-item>
                  <bly-permission-form-item label="Input ARN:" v-if="listType === 'input' && item.type === 'MEDIA_CONNECT' && item.inputArn">
                    <el-input v-model="item.inputArn" size="mini" readonly />
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Downlink Config:"
                    v-if="listType === 'input' && item.type === 'DOWNLINK'"
                  >
                    <div class="warning" v-if="!item.downlinkConfig">
                      <ma-warning class="bly-warning"></ma-warning>
                      Downlink config is missing
                    </div>
                    <div class="item-downlink-config" v-if="item.downlinkConfig">
                      <div>
                        Satellite Name:
                        <strong>{{ item.downlinkConfig.satelliteName }}</strong>
                      </div>
                      <div>
                        Frequency:
                        <strong>{{ item.downlinkConfig.satelliteFrequency }}</strong>
                      </div>
                      <div>
                        Polarization:
                        <strong>{{ item.downlinkConfig.satellitePolarization }}</strong>
                      </div>
                      <div>
                        BISS:
                        <strong>
                          {{ item.downlinkConfig.BISS | defaultValue("----") }}
                        </strong>
                      </div>
                      <div>
                        Symbol Rate:
                        <strong>
                          {{ item.downlinkConfig.symbolRate | defaultValue("----") }}
                        </strong>
                      </div>
                      <div>
                        Service:
                        <strong>
                          {{ item.downlinkConfig.service | defaultValue("----") }}
                        </strong>
                      </div>
                    </div>
                  </bly-permission-form-item>

                  <!-- OUTPUT SPECIFIC DATA -->
                  <!-- OUTPUT SPECIFIC DATA -->
                  <bly-permission-form-item label="Display name:" v-if="listType === 'output'">
                    <el-input v-model="item.displayName" size="mini" />
                  </bly-permission-form-item>
                  <bly-permission-form-item label="Output type:" v-if="listType === 'output'">
                    <el-select
                      v-model="item.outputType"
                      placeholder="Select output type"
                      size="mini"
                    >
                      <el-option
                        :key="outputTypeItem"
                        v-for="outputTypeItem in getOutputTypeOptions(item.outputType)"
                        :value="outputTypeItem"
                      >
                        {{ outputTypeItem.replace("_", " ") }}
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Output status:" v-if="listType === 'output'">
                    <el-select v-model="item.status" placeholder="Output Status" size="small">
                      <el-option
                        :key="outputTypeItem"
                        v-for="outputTypeItem in status"
                        :value="outputTypeItem"
                      >
                        {{ outputTypeItem.replace("_", " ") }}
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Allow External:" v-if="listType === 'output' && isEventEditor">
                    <el-switch v-model="item.allowExternalConfigUpdate" size="mini"></el-switch>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="OTT Platform:" v-if="listType === 'output' && item.outputType === 'OTT'">
                    <el-select
                      v-model="item.ottPlatform"
                      placeholder="Select output type"
                      size="mini"
                    >
                      <el-option
                        :key="platformType"
                        v-for="platformType in getOttPlatformOptions(item.ottPlatform)"
                        :value="platformType"
                      >
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="OTT Server:" v-if="listType === 'output' && item.outputType === 'OTT'">
                    <el-select
                      v-model="item.wowzaServerId"
                      size="mini"
                      placeholder="Select Wowza server"
                      @change="onEditWowzaServerChange(item)"
                    >
                      <el-option
                        v-for="server in availableWowzaServers"
                        :key="server.id"
                        :value="server.id"
                        :label="server.name"
                      ></el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="OTT Application:" v-if="listType === 'output' && item.outputType === 'OTT'">
                    <el-select
                      v-model="item.wowzaApplicationId"
                      size="mini"
                      placeholder="Select Wowza application"
                      @change="onEditWowzaApplicationChange(item)"
                    >
                      <el-option
                        v-for="app in wowzaApplicationsFromStore"
                        :key="app.id"
                        :value="app.id"
                        :label="app.name"
                      ></el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="" v-if="listType === 'output' && item.outputType === 'OTT'">
                    <el-checkbox v-model="item.ottNoStremKeyRequired">
                      No stream key required
                    </el-checkbox>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="OTT Default Transcoder Profile:" v-if="listType === 'output' && item.outputType === 'OTT'">
                    <el-select v-model="item.ottDefaultTranscoderProfile" size="mini">
                      <el-option
                        v-for="template in transcoderTemplatesFromStore"
                        :key="template.id"
                        :value="template.id"
                        :label="template.name"
                      ></el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <!-- Stream Router fields for ROUTE type in inline editing -->
                  <bly-permission-form-item label="Stream Router:" v-if="listType === 'output' && item.outputType === 'ROUTE'">
                    <el-select
                      v-model="item.streamRouterId"
                      placeholder="Select Stream Router"
                      size="mini"
                      @change="onEditStreamRouterChange(item)"
                    >
                      <el-option
                        v-for="router in availableStreamRouters"
                        :key="router.id"
                        :label="router.name"
                        :value="router.id"
                      >
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Interface:" v-if="listType === 'output' && item.outputType === 'ROUTE'">
                    <el-select
                      v-model="item.interfaceId"
                      placeholder="Select interface"
                      size="mini"
                      @change="onEditInterfaceChange(item)"
                    >
                      <el-option
                        v-for="routerInterface in item._availableInterfaces || []"
                        :key="routerInterface.id"
                        :label="routerInterface.name || routerInterface.id"
                        :value="routerInterface.id"
                      ></el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Interface Name:" v-if="listType === 'output' && item.outputType === 'ROUTE'">
                    <el-input v-model="item.interfaceName" size="mini" readonly />
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Conflict:" v-if="listType === 'output' && item.outputType === 'ROUTE' && item.routeInterfaceConflict">
                    <div class="text-xs" style="color: #d97706;">
                      Used by {{ item.routeInterfaceConflict.name }} ({{ item.routeInterfaceConflict.id }})
                    </div>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Techex Output ID:" v-if="listType === 'output' && item.outputType === 'TECHEX'">
                    <el-input v-model="item.techexOutputId" size="mini" />
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Techex Edge ID:" v-if="listType === 'output' && item.outputType === 'TECHEX'">
                    <el-input v-model="item.techexEdgeId" size="mini" />
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Techex Blank Stream ID:" v-if="listType === 'output' && item.outputType === 'TECHEX'">
                    <el-input v-model="item.techexBlankStreamId" size="mini" />
                  </bly-permission-form-item>

                  <!-- MediaConnect ARN fields (read-only) -->
                  <bly-permission-form-item label="Router Output ARN:" v-if="listType === 'output' && item.outputType === 'MEDIA_CONNECT'">
                    <el-input v-model="item.routerOutputArn" size="mini" />
                  </bly-permission-form-item>
                  <bly-permission-form-item label="Routing Scope:" v-if="listType === 'output' && item.outputType === 'MEDIA_CONNECT'">
                    <el-select v-model="item.routingScope" size="mini">
                      <el-option v-for="scope in mediaConnectRoutingScopes" :key="scope" :value="scope"></el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Url:" v-if="listType === 'output' && ['ROUTE', 'TECHEX'].includes(item.outputType)">
                    <el-input v-model="item.url" size="mini" />
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Location:" v-if="listType === 'output'">
                    <el-select
                      v-model="item.location"
                      placeholder="Select location"
                      size="mini"
                      clearable
                    >
                      <el-option
                        v-for="location in getOutputLocationOptions(item.outputType, item.location)"
                        :key="location.value"
                        :value="location.value"
                        :label="location.label"
                      >
                        <span>{{ location.label }} ({{ location.value }})</span>
                        <small style="margin-left: 10px; opacity: 0.75; float: right">
                          {{ location.description }}
                        </small>
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <div
                    v-if="listType === 'output' && item.outputType === 'OTT' && item.allowExternalConfigUpdate"
                    style="width: 100%"
                  >
                    <bly-permission-form-item label="Wowza Target:">
                      <el-select
                        v-model="item.wowzaTargetId"
                        size="mini"
                        placeholder="Select target"
                        @change="
                          {
                            const selectedTarget = wowzaTargetsFromStore.find((target) => target.id === item.wowzaTargetId);
                            if (selectedTarget) {
                              item.name = selectedTarget.name || selectedTarget.entryName || item.name;
                              item.wowzaTargetConfig = normalizeWowzaTargetConfig(selectedTarget);
                            }
                          }
                        "
                      >
                        <el-option
                          v-for="target in wowzaTargetsFromStore"
                          :key="target.id"
                          :value="target.id"
                          :label="target.name || target.entryName"
                        ></el-option>
                      </el-select>
                    </bly-permission-form-item>
                    <bly-permission-form-item
                      label="Target Configuration:"
                      :span="{ sm: 24, md: 24, lg: 24 }"
                    >
                      <wowza-target-config v-model="item.wowzaTargetConfig"></wowza-target-config>
                      <div class="mt-2" v-if="item.wowzaTargetId">
                        <el-button
                          size="mini"
                          type="danger"
                          @click="deleteWowzaTargetForOutput(item)"
                        >
                          Delete Selected Target
                        </el-button>
                      </div>
                    </bly-permission-form-item>
                  </div>

                  <div
                    v-if="listType === 'output' && item.outputType === 'MEDIA_CONNECT' && item.allowExternalConfigUpdate"
                    style="width: 100%"
                  >
                    <bly-permission-form-item label="MediaConnect Name:">
                      <el-input v-model="item.mcOutputName" size="mini" />
                    </bly-permission-form-item>
                    <bly-permission-form-item label="Maximum Bitrate:">
                      <el-input v-model.number="item.mcOutputBitrate" size="mini" type="number" />
                    </bly-permission-form-item>
                    <bly-permission-form-item label="Tier:">
                      <el-select v-model="item.mcOutputTier" size="mini">
                        <el-option v-for="tier in mediaConnectTiersOutput" :key="tier" :value="tier"></el-option>
                      </el-select>
                    </bly-permission-form-item>
                    <bly-permission-form-item label="Network Interface:">
                      <el-select
                        v-model="item.mcOutputNetworkInterfaceArn"
                        size="mini"
                        :disabled="!!item.mediaConnectOutputId"
                      >
                        <el-option
                          v-for="ni in mediaConnectNetworkInterfaces"
                          :key="ni.networkInterfaceArn"
                          :value="ni.networkInterfaceArn"
                          :label="ni.name"
                        ></el-option>
                      </el-select>
                    </bly-permission-form-item>
                    <bly-permission-form-item label="Protocol:">
                      <el-select v-model="item.mcOutputProtocol" size="mini">
                        <el-option v-for="protocol in mediaConnectProtocols" :key="protocol" :value="protocol"></el-option>
                      </el-select>
                    </bly-permission-form-item>
                    <bly-permission-form-item
                      label="Destination Address:"
                      v-if="['SRT_CALLER', 'RTP', 'RIST'].includes(item.mcOutputProtocol)"
                    >
                      <el-input v-model="item.mcOutputDestinationAddress" size="mini" />
                    </bly-permission-form-item>
                    <bly-permission-form-item
                      label="Destination Port:"
                      v-if="['SRT_CALLER', 'RTP', 'RIST'].includes(item.mcOutputProtocol)"
                    >
                      <el-input v-model.number="item.mcOutputDestinationPort" size="mini" type="number" />
                    </bly-permission-form-item>
                    <bly-permission-form-item
                      label="Listener Port:"
                      v-if="item.mcOutputProtocol === 'SRT_LISTENER'"
                    >
                      <el-input v-model.number="item.mcOutputPort" size="mini" type="number" />
                    </bly-permission-form-item>
                    <bly-permission-form-item
                      label="Latency:"
                      v-if="['SRT_CALLER', 'SRT_LISTENER'].includes(item.mcOutputProtocol)"
                    >
                      <el-input v-model.number="item.mcOutputLatency" size="mini" type="number" />
                    </bly-permission-form-item>
                  </div>

                  <!-- Stream Manager Endpoints for ROUTE outputs -->
                  <div
                    v-if="listType === 'output' && item.outputType === 'ROUTE'"
                    style="width: 100%"
                  >
                    <bly-permission-form-item
                      label="Stream Manager Endpoints:"
                      :span="{ sm: 24, md: 24, lg: 24 }"
                    >
                      <!-- Endpoints Array Management -->
                      <div class="mb-3">
                        <div class="flex items-center justify-between mb-2">
                          <span class="text-sm font-medium">Endpoint Configuration</span>
                          <el-button size="mini" type="primary" @click="addEditSmEndpoint(item)">
                            Add Endpoint
                          </el-button>
                        </div>
                        <!-- Endpoints List -->
                        <div v-if="item.smEndpoints.length > 0" class="space-y-2">
                          <div
                            v-for="(endpoint, index) in item.smEndpoints"
                            :key="index"
                            class="border rounded-sm p-2 border-black relative"
                          >
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                              <div>
                                <label class="block text-xs font-medium mb-1">Interface ID *</label>
                                <el-input
                                  v-model="endpoint.interfaceId"
                                  size="mini"
                                  placeholder="e.g. 0197ef25-b58e-7379-9ee1-bb65714da74b"
                                  @blur="validateEditSmEndpoint(item, endpoint)"
                                  :class="{
                                    'is-error':
                                      endpoint._validationErrors &&
                                      endpoint._validationErrors.interfaceId,
                                  }"
                                />
                                <div
                                  v-if="
                                    endpoint._validationErrors &&
                                    endpoint._validationErrors.interfaceId
                                  "
                                  class="text-red-500 text-xs mt-1"
                                >
                                  {{ endpoint._validationErrors.interfaceId }}
                                </div>
                              </div>

                              <div>
                                <label class="block text-xs font-medium mb-1"
                                  >Interface Name *</label
                                >
                                <el-input
                                  v-model="endpoint.interfaceName"
                                  size="mini"
                                  placeholder="e.g. Michal Mux Test"
                                  @blur="validateEditSmEndpoint(item, endpoint)"
                                  :class="{
                                    'is-error':
                                      endpoint._validationErrors &&
                                      endpoint._validationErrors.interfaceName,
                                  }"
                                />
                                <div
                                  v-if="
                                    endpoint._validationErrors &&
                                    endpoint._validationErrors.interfaceName
                                  "
                                  class="text-red-500 text-xs mt-1"
                                >
                                  {{ endpoint._validationErrors.interfaceName }}
                                </div>
                              </div>

                              <div>
                                <label class="block text-xs font-medium mb-1"
                                  >Stream Manager ID *</label
                                >
                                <el-input
                                  v-model="endpoint.streamManagerId"
                                  size="mini"
                                  placeholder="e.g. img-sr-04"
                                  @blur="validateEditSmEndpoint(item, endpoint)"
                                  :class="{
                                    'is-error':
                                      endpoint._validationErrors &&
                                      endpoint._validationErrors.streamManagerId,
                                  }"
                                />
                                <div
                                  v-if="
                                    endpoint._validationErrors &&
                                    endpoint._validationErrors.streamManagerId
                                  "
                                  class="text-red-500 text-xs mt-1"
                                >
                                  {{ endpoint._validationErrors.streamManagerId }}
                                </div>
                              </div>

                              <div>
                                <label class="block text-xs font-medium mb-1">Type *</label>
                                <el-select
                                  v-model="endpoint.type"
                                  size="mini"
                                  placeholder="Select type"
                                  @blur="validateEditSmEndpoint(item, endpoint)"
                                  :class="{
                                    'is-error':
                                      endpoint._validationErrors && endpoint._validationErrors.type,
                                  }"
                                >
                                  <el-option value="SR" label="SR"></el-option>
                                </el-select>
                                <div
                                  v-if="
                                    endpoint._validationErrors && endpoint._validationErrors.type
                                  "
                                  class="text-red-500 text-xs mt-1"
                                >
                                  {{ endpoint._validationErrors.type }}
                                </div>
                              </div>

                              <div class="md:col-span-2">
                                <label class="block text-xs font-medium mb-1"
                                  >Interface Description</label
                                >
                                <el-input
                                  v-model="endpoint.interfaceDescription"
                                  size="mini"
                                  placeholder="Optional description"
                                />
                              </div>
                            </div>

                            <div class="flex justify-end">
                              <el-button
                                size="mini"
                                type="danger"
                                @click="removeEditSmEndpoint(item, index)"
                                :disabled="getEditSmEndpointsArray(item).length <= 1"
                              >
                                Remove
                              </el-button>
                            </div>
                          </div>
                        </div>

                        <!-- No endpoints message -->
                        <div
                          v-else
                          class="text-center py-4 text-gray-500 border-2 border-dashed border-gray-300 rounded-sm"
                        >
                          No endpoints configured. Click "Add Endpoint" to start.
                        </div>
                      </div>
                    </bly-permission-form-item>
                  </div>

                  <!--
                      ---- OUTPUT PROFILE SPECIFIC DATA
                      ----
                      --->
                  <bly-permission-form-item
                    label="Outputs:"
                    :span="{ sm: 24, md: 24, lg: 24 }"
                    v-if="listType === 'outputProfile'"
                  >
                    <el-select
                      v-model="item.outputs"
                      multiple
                      placeholder="Select outputs"
                      value-key="id"
                      filterable
                      size="mini"
                    >
                      <el-option
                        v-for="(output, index) in sortedOutputs"
                        :key="item.id + output.id + index"
                        :label="output.name"
                        :value="output"
                      >
                        <span>{{ output.name }}</span>
                        <small style="opacity: 0.75; float: right; margin-left: 10px">
                          {{ output.description }}
                        </small>
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>
                  <bly-permission-form-item
                    label=""
                    :span="{ sm: 24, md: 24, lg: 24 }"
                    v-if="listType === 'outputProfile'"
                  >
                    <div v-if="itemAccountsFromSelectedClaims(item)">
                      <small style="color: red">
                        Some of the assigned outputs has wrong user rights.
                      </small>
                    </div>
                  </bly-permission-form-item>

                  <!-- ROUTER DESTINATION SPECIFIC DATA -->
                  <!-- ROUTER DESTINATION SPECIFIC DATA -->
                  <bly-permission-form-item
                    label="Origin router group:"
                    v-if="listType === 'destinations'"
                  >
                    <el-input
                      v-model="item.originRouterGroup"
                      placeholder="Origin router group"
                      required
                      size="small"
                    >
                    </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Origin router ID:"
                    v-if="listType === 'destinations'"
                  >
                    <el-input
                      v-model="item.originRouterId"
                      placeholder="Origin router ID"
                      required
                      size="small"
                    >
                    </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Default Source:"
                    v-if="listType === 'destinations'"
                  >
                    <el-select
                      v-model="item.routerDestinationDefaultSourceId"
                      placeholder="Select default source"
                      value-key="id"
                      filterable
                      size="small"
                    >
                      <el-option
                        :key="el.id"
                        :value="el"
                        :label="el.name"
                        v-for="el in sortedSources"
                      >
                        <span>{{ el.name }}</span>
                        <small style="margin-left: 10px; opacity: 0.75; float: right">
                          {{ el.description }}
                        </small>
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>
                  <bly-permission-form-item
                    label="Origin router destination ID:"
                    v-if="listType === 'destinations'"
                  >
                    <el-input
                      v-model="item.originRouterDestinationId"
                      placeholder="Origin router sestination ID"
                      required
                      size="small"
                    >
                    </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Outputs:"
                    :span="{ sm: 24, md: 24, lg: 24 }"
                    v-if="listType === 'destinations'"
                  >
                    <el-select
                      v-model="item.mappedOutputs"
                      placeholder="Select outputs"
                      value-key="id"
                      multiple
                      filterable
                      size="small"
                    >
                      <el-option
                        :key="el.id"
                        :value="el"
                        :label="el.name"
                        v-for="el in sortedOutputs"
                      >
                        <span>{{ el.name }}</span>
                        <small style="margin-left: 10px; opacity: 0.75; float: right">
                          {{ el.description }}
                        </small>
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Router Groups:"
                    :span="{ sm: 24, md: 24, lg: 24 }"
                    v-if="listType === 'destinations'"
                  >
                    <el-select
                      v-model="item.routerGroups"
                      placeholder="Select"
                      value-key="id"
                      multiple
                      disabled
                      size="small"
                    >
                      <el-option
                        :key="el.id"
                        :value="el"
                        :label="el.name"
                        v-for="el in routerGroupList"
                      >
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <!-- ROUTER GROUP SPECIFIC DATA -->
                  <bly-permission-form-item label="Router:" v-if="listType === 'routerGroups'">
                    <el-select
                      v-model="item.router"
                      placeholder="Select router"
                      value-key="id"
                      size="small"
                    >
                      <el-option
                        :key="router.id"
                        :value="router"
                        :label="router.name + ' (' + router.account.name + ')'"
                        v-for="router in routers"
                      >
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Sources:"
                    :span="{ sm: 24, md: 24, lg: 24 }"
                    v-if="listType === 'routerGroups'"
                  >
                    <el-select
                      v-model="item.sources"
                      placeholder="Select sources"
                      value-key="id"
                      multiple
                      filterable
                      size="small"
                    >
                      <el-option
                        :key="source.id + item.id"
                        :value="source"
                        :label="source.name"
                        v-for="source in sortedSources"
                      >
                        <span>{{ source.name }}</span>
                        <small style="margin-left: 10px; opacity: 0.75; float: right">
                          {{ source.description }}
                        </small>
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Destinations:"
                    :span="{ sm: 24, md: 24, lg: 24 }"
                    v-if="listType === 'routerGroups'"
                  >
                    <el-select
                      v-model="item.destinations"
                      placeholder="Select destinations"
                      value-key="id"
                      multiple
                      filterable
                      size="small"
                    >
                      <el-option
                        :key="dest.id + item.id + dest.name"
                        :value="dest"
                        :label="dest.name"
                        v-for="dest in sortedDest"
                      >
                        <span>{{ dest.name }}</span>
                        <small style="margin-left: 10px; opacity: 0.75; float: right">
                          {{ dest.description }}
                        </small>
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <!-- STREAM DESTINATION SPECIFIC DATA -->
                  <!-- STREAM DESTINATION SPECIFIC DATA -->
                  <bly-permission-form-item
                    label="Router destination ID:"
                    v-if="listType === 'streamDestinations'"
                  >
                    <el-select
                      v-model="item.streamDestinationRouterDestinationId"
                      placeholder="Select router destination"
                      value-key="id"
                      filterable
                      size="small"
                    >
                      <el-option
                        :key="el.id"
                        :value="el.id"
                        :label="el.name"
                        v-for="el in sortedRouterDestinations"
                      >
                        <span>{{ el.name }}</span>
                        <small style="margin-left: 10px; opacity: 0.75; float: right">
                          {{ el.description }}
                        </small>
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Type:" v-if="listType === 'streamDestinations'">
                    <el-select v-model="item.type" placeholder="Select stream type" size="small">
                      <el-option :key="el" :value="el" :label="el" v-for="el in streamTypes">
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Port:" v-if="listType === 'streamDestinations'">
                    <el-input v-model="item.port" placeholder="Port" required size="small">
                    </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Address:"
                    v-if="listType === 'streamDestinations'"
                  >
                    <el-input v-model="item.address" placeholder="Address" required size="small">
                    </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Talkback Address:"
                    v-if="listType === 'streamDestinations'"
                  >
                    <el-input v-model="item.talkbackAddress" size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Talkback Port:"
                    v-if="listType === 'streamDestinations'"
                  >
                    <el-input v-model="item.talkbackPort" size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Latency (ms):"
                    v-if="listType === 'streamDestinations'"
                  >
                    <el-input v-model="item.latencyMs" placeholder="Latency " size="small">
                    </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Buffer Max (ms):"
                    v-if="listType === 'streamDestinations'"
                  >
                    <el-input v-model="item.bufferMaxMs" placeholder="" size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Buffer Min (ms):"
                    v-if="listType === 'streamDestinations'"
                  >
                    <el-input v-model="item.bufferMinMs" size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Enc Passphrase:"
                    v-if="listType === 'streamDestinations'"
                  >
                    <el-input v-model="item.encPassphrase" required size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Enc Key Length:"
                    v-if="listType === 'streamDestinations'"
                  >
                    <el-input v-model="item.encKeyLen" size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Enc Type:"
                    v-if="listType === 'streamDestinations'"
                  >
                    <el-select v-model="item.encType" placeholder="Select enc type" size="small">
                      <el-option
                        :key="el"
                        :value="el"
                        :label="el"
                        v-for="el in streamEncryptionTypes"
                      >
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="UDP Address:"
                    v-if="listType === 'streamDestinations'"
                  >
                    <el-input v-model="item.udpAddress" size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="UDP Port:"
                    v-if="listType === 'streamDestinations'"
                  >
                    <el-input v-model="item.udpPort" size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="UDP Rtt:"
                    v-if="listType === 'streamDestinations'"
                  >
                    <el-input v-model="item.udpRtt" size="small"> </el-input>
                  </bly-permission-form-item>

                  <!-- STREAM SOURCE SPECIFIC DATA -->
                  <!-- STREAM SOURCE SPECIFIC DATA -->
                  <bly-permission-form-item label="Type:" v-if="listType === 'streamSources'">
                    <el-select v-model="item.type" placeholder="Select stream type" size="small">
                      <el-option :key="el" :value="el" :label="el" v-for="el in streamTypes">
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Port:" v-if="listType === 'streamSources'">
                    <el-input v-model="item.port" placeholder="Port" required size="small">
                    </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Address:" v-if="listType === 'streamSources'">
                    <el-input v-model="item.address" placeholder="Address" required size="small">
                    </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Talkback Address:"
                    v-if="listType === 'streamSources'"
                  >
                    <el-input v-model="item.talkbackAddress" size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Talkback Port:"
                    v-if="listType === 'streamSources'"
                  >
                    <el-input v-model="item.talkbackPort" size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Latency (ms):"
                    v-if="listType === 'streamSources'"
                  >
                    <el-input v-model="item.latencyMs" placeholder="Latency " size="small">
                    </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Buffer Max (ms):"
                    v-if="listType === 'streamSources'"
                  >
                    <el-input v-model="item.bufferMaxMs" placeholder="" size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Buffer Min (ms):"
                    v-if="listType === 'streamSources'"
                  >
                    <el-input v-model="item.bufferMinMs" size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Enc Passphrase:"
                    v-if="listType === 'streamSources'"
                  >
                    <el-input v-model="item.encPassphrase" required size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="Enc Key Length:"
                    v-if="listType === 'streamSources'"
                  >
                    <el-input v-model="item.encKeyLen" size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="Enc Type:" v-if="listType === 'streamSources'">
                    <el-select v-model="item.encType" placeholder="Select enc type" size="small">
                      <el-option
                        :key="el"
                        :value="el"
                        :label="el"
                        v-for="el in streamEncryptionTypes"
                      >
                      </el-option>
                    </el-select>
                  </bly-permission-form-item>

                  <bly-permission-form-item
                    label="UDP Address:"
                    v-if="listType === 'streamSources'"
                  >
                    <el-input v-model="item.udpAddress" size="small"> </el-input>
                  </bly-permission-form-item>

                  <bly-permission-form-item label="UDP Port:" v-if="listType === 'streamSources'">
                    <el-input v-model="item.udpPort" size="small"> </el-input>
                  </bly-permission-form-item>
                </el-row>
              </div>
            </el-collapse-transition>
          </div>
        </transition-group>

        <pagination
          v-model="page"
          :per-page="pageSize"
          :records="totalCount"
          @paginate="loadPage"
          :options="options"
        />
      </div>
    </div>
    <!-------------------------

        ADD ITEM

      ----------------------------->
    <permission-form-modal
      v-if="usingPermissionModal && permissionModalDraft"
      :visible.sync="permissionModalVisible"
      :mode="permissionModalMode"
      :entity-type="permissionModalEntityType"
      :loading="permissionModalLoading"
      @save="savePermissionModal"
      @close="closePermissionModal"
    >
      <template #footer-start>
        <el-dropdown
          v-if="['input', 'output', 'transcodingProfile', 'transcodingOutput'].includes(permissionModalEntityType) && isSysAdmin"
          trigger="click"
          @command="applySamplePreset"
        >
          <button
            type="button"
            class="inline-flex min-h-[30px] items-center rounded-md border border-[#2a333d] bg-[#161d24] px-3 text-[12px] font-medium text-[#d7dfec] transition-colors duration-150 hover:border-[#ffaa00] hover:text-white"
          >
            Test Data<i class="el-icon-arrow-down el-icon--right ml-1 text-xs"></i>
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="preset in getSamplePresetOptions(permissionModalEntityType)"
              :key="preset.command"
              :command="preset.command"
            >
              {{ preset.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>

      <input-permission-form
        v-if="permissionModalEntityType === 'input'"
        :value="permissionModalDraft"
        :errors="permissionModalErrors"
        :mode="permissionModalMode"
        :accounts="accounts"
        :claims-tree="claimsTree"
        :input-types="inputTypes"
        :locations="locations"
        :stream-routers="streamRouters"
        :media-connect-routing-scopes="mediaConnectRoutingScopes"
        :media-connect-tiers-input="mediaConnectTiersInput"
        :media-connect-protocols="mediaConnectProtocols"
        :media-connect-network-interfaces="mediaConnectNetworkInterfaces"
        @input="permissionModalDraft = $event"
        @type-change="handleModalInputTypeChange"
      />

      <output-permission-form
        v-if="permissionModalEntityType === 'output'"
        :value="permissionModalDraft"
        :errors="permissionModalErrors"
        :mode="permissionModalMode"
        :accounts="accounts"
        :claims-tree="claimsTree"
        :output-types="getOutputTypeOptions(permissionModalDraft.output.outputType)"
        :status="status"
        :location-options="permissionModalOutputLocationOptions"
        :stream-routers="availableStreamRouters"
        :stream-router-interfaces="streamRouterInterfaces"
        :available-wowza-servers="availableWowzaServers"
        :wowza-applications="wowzaApplicationsFromStore"
        :wowza-targets="wowzaTargetsFromStore"
        :transcoder-templates="transcoderTemplatesFromStore"
        :ott-platform-types="getOttPlatformOptions(permissionModalDraft.output.ottPlatform)"
        :media-connect-routing-scopes="mediaConnectRoutingScopes"
        :media-connect-tiers-output="mediaConnectTiersOutput"
        :media-connect-protocols="mediaConnectProtocols"
        :media-connect-network-interfaces="mediaConnectNetworkInterfaces"
        :media-connect-outputs="mediaConnectOutputs"
        :is-event-editor="isEventEditor"
        @input="permissionModalDraft = $event"
        @type-change="handleModalOutputTypeChange"
        @wowza-server-change="handleModalWowzaServerChange"
        @wowza-application-change="handleModalWowzaApplicationChange"
        @wowza-target-change="handleModalWowzaTargetChange"
        @stream-router-change="handleModalStreamRouterChange"
        @interface-change="handleModalInterfaceChange"
        @media-connect-output-change="handleModalMediaConnectOutputChange"
      />

      <output-profile-permission-form
        v-if="permissionModalEntityType === 'outputProfile'"
        :value="permissionModalDraft"
        :errors="permissionModalErrors"
        :mode="permissionModalMode"
        :claims-tree="claimsTree"
        :outputs="sortedOutputs"
        :has-access-mismatch="permissionModalOutputProfileHasAccessMismatch"
        @input="permissionModalDraft = $event"
      />

      <bly-input-profile-permission-form
        v-if="permissionModalEntityType === 'inputProfile'"
        :value="permissionModalDraft"
        :errors="permissionModalErrors"
        :mode="permissionModalMode"
        :claims-tree="claimsTree"
        :inputs="sortedInputs"
        :providers="providers || []"
        :input-types="inputTypes"
        :locations="locations || []"
        :routing-scopes="mediaConnectRoutingScopes"
        @input="permissionModalDraft = $event"
      />

      <bly-provider-permission-form
        v-if="permissionModalEntityType === 'provider'"
        :value="permissionModalDraft"
        :errors="permissionModalErrors"
        :mode="permissionModalMode"
        :claims-tree="claimsTree"
        @input="permissionModalDraft = $event"
      />

      <location-permission-form
        v-if="permissionModalEntityType === 'location'"
        :value="permissionModalDraft"
        :errors="permissionModalErrors"
        :mode="permissionModalMode"
        :location-types="locationTypes"
        @input="permissionModalDraft = $event"
      />

      <transcoding-permission-form
        v-if="['transcodingProfile', 'transcodingOutput'].includes(permissionModalEntityType)"
        :value="permissionModalDraft"
        :errors="permissionModalErrors"
        :mode="permissionModalMode"
        :claims-tree="claimsTree"
        :entity-type="permissionModalEntityType"
        @input="permissionModalDraft = $event"
        @validation-change="transcodingOutputValid = $event.isValid; transcodingOutputErrors = $event.errors"
      />
    </permission-form-modal>

    <el-dialog
      v-if="!usesPermissionModal(formType)"
      :title="'Create ' + formType"
      :visible.sync="showAddDialog"
      :close-on-click-modal="false"
      :width="formType === 'transcodingProfile' || formType === 'transcodingOutput' ? '1200px' : '360px'"
      :custom-class="formType === 'transcodingProfile' || formType === 'transcodingOutput' ? 'permissions-modal permissions-modal--transcoding' : 'permissions-modal'"
    >
      <div class="dialog-form" v-if="showAddDialog">
        <el-form
          ref="addItemForm"
          :model="form"
          label-position="top"
          :class="{ 'transcoding-create-form': formType === 'transcodingProfile' || formType === 'transcodingOutput' }"
        >
          <!-- BASIC FIELDS -->
          <!-- BASIC FIELDS -->
          <el-form-item required prop="name">
            <el-input v-model="form.name" placeholder="Name"></el-input>
          </el-form-item>
          <el-form-item prop="description" v-if="formType !== 'routerGroup'">
            <el-input
              type="text"
              v-model="form.description"
              size="small"
              placeholder="Description"
            ></el-input>
          </el-form-item>

          <el-form-item prop="id">
            <el-input type="text" v-model="form.id" size="small" placeholder="id"></el-input>
          </el-form-item>

          <el-form-item prop="location" v-if="formType === 'input'">
            <el-select
              v-model="form.input.locationArray"
              placeholder="Select locations"
              size="small"
              multiple
              clearable
            >
              <el-option
                :key="location.id"
                :value="location.code"
                :label="location.name"
                v-for="location in locations"
              >
                <span>{{ location.name }} ({{ location.code }})</span>
                <small style="margin-left: 10px; opacity: 0.75; float: right">
                  {{ location.description }}
                </small>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="location" v-if="formType === 'output'">
            <el-select
              v-model="form.output.location"
              placeholder="Select location"
              size="small"
              clearable
            >
              <el-option
                :key="location.id"
                :value="location.code"
                :label="location.name"
                v-for="location in locations"
              >
                <span>{{ location.name }} ({{ location.code }})</span>
                <small style="margin-left: 10px; opacity: 0.75; float: right">
                  {{ location.description }}
                </small>
              </el-option>
            </el-select>
          </el-form-item>

          <div v-if="formType === 'transcoderProfile'">
            <el-divider content-position="left">Transcoder Profile specific data</el-divider>
            <el-form-item prop="description" v-if="formType === 'transcoderProfile'">
              <el-input
                type="text"
                v-model="form.transcoderProfile.transcoderProfile"
                size="small"
                required
                placeholder="Transcoder Profile"
              ></el-input>
            </el-form-item>
          </div>

          <!-- transcoding Channel/OUTPUT FIELDS -->
          <div v-if="formType === 'transcodingProfile' || formType === 'transcodingOutput'">
            <el-divider content-position="left">Transcoding specific data</el-divider>
            <el-form-item label="Type" required>
              <el-select v-model="form.transcoding.type" placeholder="Select type" class="w-full" size="small">
                <el-option label="MediaLive" value="MEDIA_LIVE"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Config (JSON)">
              <TranscodingConfigEditor v-if="formType === 'transcodingProfile'" v-model="form.transcoding.config" />
              <TranscodingOutputConfigEditor
                v-else-if="formType === 'transcodingOutput'"
                v-model="form.transcoding.config"
                @validation-change="transcodingOutputValid = $event.isValid; transcodingOutputErrors = $event.errors"
              />
            </el-form-item>
          </div>

          <!-- accounts -->
          <!-- accounts -->
          <div v-if="formType === 'input' || formType === 'output'">
            <el-divider content-position="left">Map to accounts</el-divider>
            <small>
              Please set access permissions for the added account, otherwise users won't be able to
              access it
            </small>
            <el-form-item prop="ottPlatform">
              <el-select
                v-model="form.accounts"
                placeholder="Select account"
                value-key="id"
                multiple
                size="small"
              >
                <el-option
                  :key="account.id"
                  :value="account"
                  :label="account.client.name + ' > ' + account.name"
                  v-for="account in accounts"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <!-- INPUT SPECIFIC FIELDS -->
          <!-- INPUT SPECIFIC FIELDS -->
          <div v-if="formType === 'input'">
            <el-divider content-position="left">Input specific data</el-divider>

            <el-form-item prop="input.streamFileBaseName">
              <el-input
                v-model="form.input.streamFileBaseName"
                size="small"
                placeholder="Stream file base name"
              ></el-input>
            </el-form-item>

            <el-form-item prop="input.type">
              <el-select v-model="form.input.type" placeholder="Select input type" size="small">
                <el-option :key="inputType" v-for="inputType in inputTypes" :value="inputType">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="input.inputDownlinkConfigId">
              <el-input
                v-model="form.input.inputDownlinkConfigId"
                size="small"
                placeholder="Downlink config ID"
              ></el-input>
            </el-form-item>

              <el-form-item prop="input.url">
                <el-input v-model="form.input.url"
                  size="small"
                  placeholder="Input URL"
                  :disabled="form.input.createInterface"></el-input>
              </el-form-item>

            <el-form-item prop="input.frcAvailable">
              <el-switch
                v-model="form.input.frcAvailable"
                size="small"
                active-text="FRC Available"
              ></el-switch>
            </el-form-item>
            <el-form-item prop="input.requireDetails">
              <el-switch
                v-model="form.input.requireDetails"
                size="small"
                active-text="Require Details"
              ></el-switch>
              </el-form-item>

              <!-- Stream Router Interface Section -->
              <el-divider content-position="left">Stream Router Interface</el-divider>

              <el-form-item prop="input.createInterface">
                <el-switch v-model="form.input.createInterface"
                  size="small"
                   active-text="Create Stream Router Interface"></el-switch>
              </el-form-item>

              <div v-if="form.input.createInterface">
                <el-form-item prop="input.streamRouterId" required>
                  <el-select v-model="form.input.streamRouterId"
                    placeholder="Select Stream Router"
                    size="small">
                    <el-option
                      v-for="router in streamRouters"
                      :key="router.id"
                      :value="router.id"
                      :label="router.name">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="input.interfaceName" required>
                  <el-input v-model="form.input.interfaceName"
                    size="small"
                    placeholder="Interface Name"></el-input>
                </el-form-item>

                <el-form-item prop="input.sourceUrl" required>
                  <el-input v-model="form.input.sourceUrl"
                    size="small"
                    placeholder="Source URL"></el-input>
                </el-form-item>

                <el-form-item prop="input.destinationUrl" required>
                  <el-input v-model="form.input.destinationUrl"
                    size="small"
                    placeholder="Destination URL"
                    @input="form.input.url = form.input.destinationUrl"></el-input>
                </el-form-item>

                <el-form-item prop="input.tags">
                  <el-select v-model="form.input.tags"
                    multiple
                    filterable
                    allow-create
                    default-first-option
                    placeholder="Tags"
                    size="small">
                  </el-select>
                </el-form-item>

                <el-form-item prop="input.autostart">
                  <el-switch v-model="form.input.autostart"
                    size="small"
                    active-text="Auto-start Interface"></el-switch>
              </el-form-item>
                <stream-router-interface-config v-model="form.input" :stream-routers="streamRouters"></stream-router-interface-config>
              </div>
          </div>

          <!-- MEDIA_CONNECT INPUT -->
          <div v-if="form.input.type === 'MEDIA_CONNECT'">
            <el-divider content-position="left">MediaConnect Input Configuration</el-divider>
            <el-form-item prop="input.mcInputName" required>
              <el-input v-model="form.input.mcInputName" size="small" placeholder="Name"></el-input>
            </el-form-item>
            <el-form-item prop="input.mcInputBitrate" required>
              <el-input v-model.number="form.input.mcInputBitrate" type="number" size="small" min="1000000" placeholder="Maximum Bitrate (e.g. 20000000)"></el-input>
            </el-form-item>
            <el-form-item prop="input.mcInputRoutingScope" required>
              <el-select v-model="form.input.mcInputRoutingScope" placeholder="Routing Scope" size="small">
                <el-option v-for="s in mediaConnectRoutingScopes" :key="s" :value="s"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="input.mcInputTier" required>
              <el-select v-model="form.input.mcInputTier" placeholder="Tier" size="small">
                <el-option v-for="t in mediaConnectTiersInput" :key="t" :value="t"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="input.mcInputNetworkInterfaceArn" required>
              <el-select v-model="form.input.mcInputNetworkInterfaceArn" placeholder="Network Interface" size="small">
                <el-option v-for="ni in mediaConnectNetworkInterfaces" :key="ni.networkInterfaceArn" :value="ni.networkInterfaceArn" :label="ni.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="input.mcInputProtocol" required>
              <el-select v-model="form.input.mcInputProtocol" placeholder="Protocol" size="small">
                <el-option v-for="p in mediaConnectProtocols" :key="p" :value="p"></el-option>
              </el-select>
            </el-form-item>

            <template v-if="form.input.mcInputProtocol === 'SRT_LISTENER'">
              <el-form-item prop="input.mcInputPort" required>
                <el-input v-model.number="form.input.mcInputPort" type="number" size="small" placeholder="Port"></el-input>
              </el-form-item>
              <el-form-item prop="input.mcInputLatency" required>
                <el-input v-model.number="form.input.mcInputLatency" type="number" size="small" placeholder="Min Latency (ms)"></el-input>
              </el-form-item>
            </template>
            <template v-if="form.input.mcInputProtocol === 'SRT_CALLER'">
              <el-form-item prop="input.mcInputSourceAddress" required>
                <el-input v-model="form.input.mcInputSourceAddress" size="small" placeholder="Source Address"></el-input>
              </el-form-item>
              <el-form-item prop="input.mcInputSourcePort" required>
                <el-input v-model.number="form.input.mcInputSourcePort" type="number" size="small" placeholder="Source Port"></el-input>
              </el-form-item>
              <el-form-item prop="input.mcInputLatency" required>
                <el-input v-model.number="form.input.mcInputLatency" type="number" size="small" placeholder="Min Latency (ms)"></el-input>
              </el-form-item>
            </template>
            <template v-if="form.input.mcInputProtocol === 'RTP'">
              <el-form-item prop="input.mcInputPort" required>
                <el-input v-model.number="form.input.mcInputPort" type="number" size="small" placeholder="Port"></el-input>
              </el-form-item>
            </template>
            <template v-if="form.input.mcInputProtocol === 'RIST'">
              <el-form-item prop="input.mcInputPort" required>
                <el-input v-model.number="form.input.mcInputPort" type="number" size="small" placeholder="Port"></el-input>
              </el-form-item>
              <el-form-item prop="input.mcInputRecoveryLatency" required>
                <el-input v-model.number="form.input.mcInputRecoveryLatency" type="number" size="small" placeholder="Recovery Latency (ms)"></el-input>
              </el-form-item>
            </template>
          </div>

          <!-- ROUTER SPECIFIC FIELDS -->
          <!-- ROUTER SPECIFIC FIELDS -->
          <div v-if="formType === 'router'">
            <el-divider content-position="left">Router specific data</el-divider>

            <el-form-item prop="routerAccountId">
              <el-select
                v-model="form.router.routerAccountId"
                placeholder="Select account"
                value-key="id"
                size="small"
              >
                <el-option
                  :key="account.id"
                  :value="account"
                  :label="account.client.name + ' > ' + account.name"
                  v-for="account in accounts"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <!-- OUTPUT SPECIFIC FIELDS -->
          <div v-if="formType === 'output'">
            <el-divider content-position="left">Output specific data</el-divider>
            <el-form-item prop="displayName">
              <el-input
                v-model="form.output.displayName"
                size="small"
                placeholder="Display Name"
              ></el-input>
            </el-form-item>

            <el-form-item prop="allowExternalConfigUpdate" v-if="isEventEditor">
              <el-switch
                v-model="form.output.allowExternalConfigUpdate"
                size="small"
                active-text="Allow External Config Update"
              ></el-switch>
            </el-form-item>
            <el-form-item prop="output.outputType" required="">
              <el-select
                v-model="form.output.outputType"
                placeholder="Output Type"
                size="small"
                @change="onOutputTypeChange"
              >
                <el-option
                  :key="outputTypeItem"
                  v-for="outputTypeItem in getOutputTypeOptions(form.output.outputType)"
                  :value="outputTypeItem"
                >
                  {{ outputTypeItem.replace("_", " ") }}
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="output.status" required="">
              <el-select v-model="form.output.status" placeholder="Output Status" size="small">
                <el-option
                  :key="outputTypeItem"
                  v-for="outputTypeItem in status"
                  :value="outputTypeItem"
                >
                  {{ outputTypeItem.replace("_", " ") }}
                </el-option>
              </el-select>
            </el-form-item>

              <!-- ROUTE Output Fields -->
              <div v-if="form.output.outputType === 'ROUTE'">
                <el-divider content-position="left">Stream Router Configuration</el-divider>

                <el-form-item prop="output.createInterface">
                  <el-switch v-model="form.output.createInterface"
                    size="small"
                     active-text="Create Stream Router Interface"></el-switch>
                </el-form-item>

                <div v-if="form.output.createInterface">
                  <el-form-item prop="output.streamRouterId" required>
                    <el-select v-model="form.output.streamRouterId"
                      placeholder="Select Stream Router"
                      size="small">
                      <el-option
                        v-for="router in streamRouters"
                        :key="router.id"
                        :value="router.id"
                        :label="router.name">
                      </el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item prop="output.interfaceName" required>
                    <el-input v-model="form.output.interfaceName"
                      size="small"
                      placeholder="Interface Name"></el-input>
                  </el-form-item>

                  <el-form-item prop="output.sourceUrl" required>
                    <el-input v-model="form.output.sourceUrl"
                      size="small"
                      placeholder="Source URL"></el-input>
                  </el-form-item>

                  <el-form-item prop="output.destinationUrl" required>
                    <el-input v-model="form.output.destinationUrl"
                      size="small"
                      placeholder="Destination URL"></el-input>
                  </el-form-item>

                  <el-form-item prop="output.tags">
                    <el-select v-model="form.output.tags"
                      multiple
                      filterable
                      allow-create
                      default-first-option
                      placeholder="Tags"
                      size="small">
                    </el-select>
                  </el-form-item>

                  <el-form-item prop="output.autostart">
                    <el-switch v-model="form.output.autostart"
                      size="small"
                      active-text="Auto-start Interface"></el-switch>
                  </el-form-item>
                </div>
              </div>

              <!-- OTT Output Fields -->
              <div v-if="form.output.outputType === 'OTT'">
                <el-divider content-position="left">Wowza Configuration</el-divider>

                <el-form-item prop="output.wowzaServerId" required v-loading="loadingWowzaData">
                  <el-select v-model="form.output.wowzaServerId"
                    placeholder="Select Wowza Server"
                    size="small"
                    @change="onWowzaServerChange">
                    <el-option
                      v-for="server in wowzaServersFromEquipment"
                      :key="server.id"
                      :value="server.id"
                      :label="server.name">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="output.wowzaApplicationId" required v-if="form.output.wowzaServerId">
                  <el-select v-model="form.output.wowzaApplicationId"
                    placeholder="Select Wowza Application"
                    size="small"
                    @change="onWowzaApplicationChange"
                    v-loading="loadingWowzaData">
                    <el-option
                      v-for="app in wowzaApplicationsFromStore"
                      :key="app.id"
                      :value="app.id"
                      :label="app.name">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="output.ottDefaultTranscoderProfile" v-if="form.output.wowzaApplicationId">
                  <el-select v-model="form.output.ottDefaultTranscoderProfile"
                    placeholder="Select Transcoder Template"
                    size="small"
                    v-loading="loadingWowzaData">
                    <el-option
                      v-for="template in transcoderTemplatesFromStore"
                      :key="template.id"
                      :value="template.id"
                      :label="template.name">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="output.ottPlatform" required>
                  <el-select v-model="form.output.ottPlatform"
                    placeholder="Select OTT platform type"
                    size="small">
                    <el-option
                      :key="platformType"
                      v-for="platformType in ottPlatformTypes" :value="platformType">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item prop="output.ottNoStremKeyRequired">
                  <el-checkbox
                    v-model="form.output.ottNoStremKeyRequired"
                    label="Stream key not required"
                    size="small"/>
                </el-form-item>

                <!-- Wowza Target Selection/Creation -->
                <el-divider content-position="left">Target Configuration</el-divider>

                <el-form-item prop="output.createWowzaTarget">
                  <el-switch v-model="form.output.createWowzaTarget"
                    size="small"
                    active-text="Create New Target"
                    inactive-text="Select Existing Target"></el-switch>
                </el-form-item>

                <el-form-item prop="output.wowzaTargetId" v-if="!form.output.createWowzaTarget && form.output.wowzaApplicationId">
                  <el-select v-model="form.output.wowzaTargetId"
                    placeholder="Select Wowza Target"
                    size="small"
                    @change="onWowzaTargetChange"
                    v-loading="loadingWowzaData">
                    <el-option
                      v-for="target in wowzaTargetsFromStore"
                      :key="target.id"
                      :value="target.id"
                      :label="target.name">
                    </el-option>
                  </el-select>
                </el-form-item>

                <!-- New Target Creation Fields -->
                <div v-if="form.output.createWowzaTarget">
                  <el-form-item prop="output.wowzaTargetConfig.entryName" required>
                    <el-input v-model="form.output.wowzaTargetConfig.entryName"
                      size="small"
                      placeholder="Entry Name"></el-input>
                  </el-form-item>

                  <el-form-item prop="output.wowzaTargetConfig.sourceStreamName">
                    <el-input v-model="form.output.wowzaTargetConfig.sourceStreamName"
                      size="small"
                      placeholder="Source Stream Name"></el-input>
                  </el-form-item>

                  <el-form-item prop="output.wowzaTargetConfig.streamName">
                    <el-input v-model="form.output.wowzaTargetConfig.streamName"
                      size="small"
                      placeholder="Stream Name"></el-input>
                  </el-form-item>

                  <el-row :gutter="14">
                    <el-col :span="16">
                      <el-form-item prop="output.wowzaTargetConfig.host">
                        <el-input v-model="form.output.wowzaTargetConfig.host"
                          size="small"
                          placeholder="Host"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item prop="output.wowzaTargetConfig.port">
                        <el-input v-model="form.output.wowzaTargetConfig.port"
                          size="small"
                          type="number"
                          placeholder="Port"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item prop="output.wowzaTargetConfig.enabled">
                    <el-switch v-model="form.output.wowzaTargetConfig.enabled"
                      size="small"
                      active-text="Target Enabled"></el-switch>
                  </el-form-item>
                </div>
              </div>

              <!-- Legacy OTT server input for non-Wowza outputs -->
              <el-form-item prop="output.ottServer" v-if="form.output.outputType === 'OTT' && !form.output.wowzaServerId">
                <el-input v-model="form.output.ottServer"
                  size="small"
                  placeholder="OTT Server"></el-input>
              </el-form-item>
            <el-form-item prop="output.ottServer" v-if="form.output.outputType === 'OTT'">
              <el-input
                v-model="form.output.ottServer"
                size="small"
                placeholder="OTT Server"
              ></el-input>
            </el-form-item>

            <el-form-item prop="output.ottPlatform" v-if="form.output.outputType === 'OTT' && !form.output.wowzaServerId">
              <el-select
                v-model="form.output.location"
                placeholder="Select location"
                size="small"
              >
                <el-option
                  v-for="location in getOutputLocationOptions(form.output.outputType, form.output.location)"
                  :key="location.value"
                  :label="location.label"
                  :value="location.value"
                >
                  <span>{{ location.label }} ({{ location.value }})</span>
                  <small style="margin-left: 10px; opacity: 0.75; float: right">
                    {{ location.description }}
                  </small>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              prop="output.url"
              v-if="['ROUTE', 'TECHEX'].includes(form.output.outputType)"
            >
              <el-input v-model="form.output.url" size="small" placeholder="URL"></el-input>
            </el-form-item>

            <div v-if="form.output.outputType === 'OTT'">
              <el-divider content-position="left">Wowza Configuration</el-divider>

              <el-form-item prop="output.wowzaServerId" required v-loading="loadingWowzaData">
                <el-select
                  v-model="form.output.wowzaServerId"
                  placeholder="Select Wowza Server"
                  size="small"
                  @change="onWowzaServerChange"
                >
                  <el-option
                    v-for="server in availableWowzaServers"
                    :key="server.id"
                    :value="server.id"
                    :label="server.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                prop="output.wowzaApplicationId"
                required
                v-if="form.output.wowzaServerId"
                v-loading="loadingWowzaData"
              >
                <el-select
                  v-model="form.output.wowzaApplicationId"
                  placeholder="Select Wowza Application"
                  size="small"
                  @change="onWowzaApplicationChange"
                >
                  <el-option
                    v-for="app in wowzaApplicationsFromStore"
                    :key="app.id"
                    :value="app.id"
                    :label="app.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item prop="output.ottPlatform" required>
                <el-select
                  v-model="form.output.ottPlatform"
                  placeholder="Select OTT platform type"
                  size="small"
                >
                  <el-option
                    v-for="platformType in getOttPlatformOptions(form.output.ottPlatform)"
                    :key="platformType"
                    :value="platformType"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                prop="output.ottDefaultTranscoderProfile"
                v-if="form.output.wowzaApplicationId"
              >
                <el-select
                  v-model="form.output.ottDefaultTranscoderProfile"
                  placeholder="Select Transcoder Template"
                  size="small"
                  v-loading="loadingWowzaData"
                >
                  <el-option
                    v-for="template in transcoderTemplatesFromStore"
                    :key="template.id"
                    :value="template.id"
                    :label="template.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item prop="output.ottNoStremKeyRequired">
                <el-checkbox
                  v-model="form.output.ottNoStremKeyRequired"
                  label="Stream key not required"
                  size="small"
                />
              </el-form-item>

              <div v-if="form.output.allowExternalConfigUpdate">
                <el-form-item prop="output.createWowzaTarget">
                  <el-switch
                    v-model="form.output.createWowzaTarget"
                    size="small"
                    active-text="Create New Target"
                    inactive-text="Use Existing Target"
                  ></el-switch>
                </el-form-item>

                <el-form-item
                  prop="output.wowzaTargetId"
                  v-if="!form.output.createWowzaTarget && form.output.wowzaApplicationId"
                >
                  <el-select
                    v-model="form.output.wowzaTargetId"
                    placeholder="Select Wowza Target"
                    size="small"
                    @change="onWowzaTargetChange"
                    v-loading="loadingWowzaData"
                  >
                    <el-option
                      v-for="target in wowzaTargetsFromStore"
                      :key="target.id"
                      :value="target.id"
                      :label="target.name || target.entryName"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <div
                  v-if="form.output.createWowzaTarget || form.output.wowzaTargetId"
                  class="mb-2"
                >
                  <wowza-target-config
                    v-model="form.output.wowzaTargetConfig"
                  ></wowza-target-config>
                  <div class="mt-2" v-if="form.output.wowzaTargetId">
                    <el-button
                      type="danger"
                      size="mini"
                      @click="deleteWowzaTargetForOutput(form.output)"
                    >
                      Delete Selected Target
                    </el-button>
                  </div>
                </div>
              </div>

              <div v-else class="text-xs text-gray-500" style="margin-top: -4px; margin-bottom: 12px;">
                External Wowza updates are disabled. Only local MOS config will be saved.
              </div>
            </div>

            <div v-if="form.output.outputType === 'ROUTE'">
              <el-divider content-position="left">Stream Router Configuration</el-divider>

              <el-form-item prop="output.streamRouterId" required>
                <el-select
                  v-model="form.output.streamRouterId"
                  placeholder="Select Stream Router"
                  size="small"
                  @change="onStreamRouterChange"
                >
                  <el-option
                    v-for="router in availableStreamRouters"
                    :key="router.id"
                    :label="router.name"
                    :value="router.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                prop="output.interfaceId"
                v-if="form.output.streamRouterId"
                v-loading="loadingStreamRouterInterfaces"
              >
                <el-select
                  v-model="form.output.interfaceId"
                  placeholder="Select Interface"
                  size="small"
                  @change="onInterfaceChange"
                  :disabled="loadingStreamRouterInterfaces"
                >
                  <el-option
                    v-for="routerInterface in streamRouterInterfaces"
                    :key="routerInterface.id"
                    :label="routerInterface.name || routerInterface.id"
                    :value="routerInterface.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <div
                v-if="form.output.routeInterfaceConflict"
                class="text-xs"
                style="margin-top: -6px; margin-bottom: 12px; color: #d97706;"
              >
                Interface is already used by output:
                <strong>{{ form.output.routeInterfaceConflict.name }}</strong>
                ({{ form.output.routeInterfaceConflict.id }})
              </div>

              <el-form-item
                prop="output.interfaceName"
                v-if="form.output.interfaceId"
                v-loading="loadingInterfaceDetails"
              >
                <el-input
                  v-model="form.output.interfaceName"
                  size="small"
                  placeholder="Interface Name"
                  readonly
                ></el-input>
              </el-form-item>

              <el-form-item
                prop="output.interfaceDescription"
                v-if="form.output.interfaceId"
                v-loading="loadingInterfaceDetails"
              >
                <el-input
                  v-model="form.output.interfaceDescription"
                  size="small"
                  placeholder="Interface Description"
                  readonly
                ></el-input>
              </el-form-item>

              <el-divider content-position="left">Stream Manager Endpoints</el-divider>

              <div class="mb-4 flex items-center">
                <el-button type="primary" size="small" @click="addSmEndpoint" icon="el-icon-plus">
                  Add Endpoint
                </el-button>
                <small class="ml-3 opacity-75 break-keep">
                  Endpoints are stored as SR mappings only.
                </small>
              </div>

              <div
                v-if="form.output.smEndpoints && form.output.smEndpoints.length > 0"
                class="sm-endpoints-list"
              >
                <div
                  v-for="(endpoint, index) in form.output.smEndpoints"
                  :key="index"
                  class="endpoint-card mb-3 p-3 border border-gray-300 rounded-sm"
                >
                  <div class="flex justify-between items-center mb-3">
                    <h4 class="text-sm font-medium">Endpoint {{ index + 1 }}</h4>
                    <el-button
                      type="danger"
                      size="mini"
                      icon="el-icon-delete"
                      @click="removeSmEndpoint(index)"
                      circle
                    >
                    </el-button>
                  </div>

                  <el-row :gutter="12">
                    <el-col :span="12">
                      <el-form-item label="Interface ID *" class="mb-2">
                        <el-input
                          v-model="endpoint.interfaceId"
                          size="small"
                          @blur="validateSmEndpointField(endpoint, 'interfaceId')"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Interface Name *" class="mb-2">
                        <el-input
                          v-model="endpoint.interfaceName"
                          size="small"
                          @blur="validateSmEndpointField(endpoint, 'interfaceName')"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="12">
                    <el-col :span="12">
                      <el-form-item label="Stream Manager ID *" class="mb-2">
                        <el-input
                          v-model="endpoint.streamManagerId"
                          size="small"
                          @blur="validateSmEndpointField(endpoint, 'streamManagerId')"
                        >
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="Type *" class="mb-2">
                        <el-select
                          v-model="endpoint.type"
                          size="small"
                          placeholder="Select type"
                          @change="validateSmEndpointField(endpoint, 'type')"
                        >
                          <el-option value="SR" label="SR"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item label="Interface Description" class="mb-0">
                    <el-input
                      v-model="endpoint.interfaceDescription"
                      size="small"
                    >
                    </el-input>
                  </el-form-item>

                  <div
                    v-if="endpoint._validationErrors && endpoint._validationErrors.length > 0"
                    class="mt-2"
                  >
                    <div
                      v-for="error in endpoint._validationErrors"
                      :key="error"
                      class="text-red-500 text-xs"
                    >
                      {{ error }}
                    </div>
                  </div>
                </div>
              </div>

              <div v-else class="text-center py-4 text-gray-500">
                <i class="el-icon-info"></i>
                <p class="mt-2">
                  No endpoints configured. Add at least one endpoint for ROUTE outputs.
                </p>
              </div>
            </div>

            <div v-if="form.output.outputType === 'TECHEX'">
              <el-divider content-position="left">Techex Configuration</el-divider>
              <el-form-item prop="output.techexOutputId" required>
                <el-input
                  v-model="form.output.techexOutputId"
                  size="small"
                  placeholder="Techex Output ID"
                ></el-input>
              </el-form-item>
              <el-form-item prop="output.techexEdgeId" required>
                <el-input
                  v-model="form.output.techexEdgeId"
                  size="small"
                  placeholder="Techex Edge ID"
                ></el-input>
              </el-form-item>
              <el-form-item prop="output.techexBlankStreamId">
                <el-input
                  v-model="form.output.techexBlankStreamId"
                  size="small"
                  placeholder="Techex Blank Stream ID"
                ></el-input>
              </el-form-item>
            </div>

            <div v-if="form.output.outputType === 'MEDIA_CONNECT'">
              <el-divider content-position="left">MediaConnect Configuration</el-divider>

              <el-form-item prop="output.routingScope" required>
                <el-select
                  v-model="form.output.routingScope"
                  placeholder="Routing Scope"
                  size="small"
                >
                  <el-option
                    v-for="scope in mediaConnectRoutingScopes"
                    :key="scope"
                    :value="scope"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item prop="output.routerOutputArn">
                <el-input
                  v-model="form.output.routerOutputArn"
                  size="small"
                  placeholder="Router Output ARN"
                ></el-input>
              </el-form-item>

              <div v-if="form.output.allowExternalConfigUpdate">
                <el-form-item prop="output.mcOutputName" required>
                  <el-input
                    v-model="form.output.mcOutputName"
                    size="small"
                    placeholder="MediaConnect Output Name"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="output.mcOutputBitrate" required>
                  <el-input
                    v-model.number="form.output.mcOutputBitrate"
                    type="number"
                    size="small"
                    placeholder="Maximum Bitrate"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="output.mcOutputTier" required>
                  <el-select
                    v-model="form.output.mcOutputTier"
                    placeholder="Tier"
                    size="small"
                  >
                    <el-option
                      v-for="tier in mediaConnectTiersOutput"
                      :key="tier"
                      :value="tier"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="output.mcOutputNetworkInterfaceArn" required>
                  <el-select
                    v-model="form.output.mcOutputNetworkInterfaceArn"
                    placeholder="Network Interface"
                    size="small"
                    :disabled="!!form.output.mediaConnectOutputId"
                  >
                    <el-option
                      v-for="ni in mediaConnectNetworkInterfaces"
                      :key="ni.networkInterfaceArn"
                      :value="ni.networkInterfaceArn"
                      :label="ni.name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="output.mcOutputProtocol" required>
                  <el-select
                    v-model="form.output.mcOutputProtocol"
                    placeholder="Protocol"
                    size="small"
                  >
                    <el-option
                      v-for="protocol in mediaConnectProtocols"
                      :key="protocol"
                      :value="protocol"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <template v-if="form.output.mcOutputProtocol === 'SRT_CALLER'">
                  <el-form-item prop="output.mcOutputDestinationAddress" required>
                    <el-input
                      v-model="form.output.mcOutputDestinationAddress"
                      size="small"
                      placeholder="Destination Address"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="output.mcOutputDestinationPort" required>
                    <el-input
                      v-model.number="form.output.mcOutputDestinationPort"
                      type="number"
                      size="small"
                      placeholder="Destination Port"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="output.mcOutputLatency" required>
                    <el-input
                      v-model.number="form.output.mcOutputLatency"
                      type="number"
                      size="small"
                      placeholder="Min Latency (ms)"
                    ></el-input>
                  </el-form-item>
                </template>
                <template v-if="form.output.mcOutputProtocol === 'SRT_LISTENER'">
                  <el-form-item prop="output.mcOutputPort" required>
                    <el-input
                      v-model.number="form.output.mcOutputPort"
                      type="number"
                      size="small"
                      placeholder="Port"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="output.mcOutputLatency" required>
                    <el-input
                      v-model.number="form.output.mcOutputLatency"
                      type="number"
                      size="small"
                      placeholder="Min Latency (ms)"
                    ></el-input>
                  </el-form-item>
                </template>
                <template v-if="['RTP', 'RIST'].includes(form.output.mcOutputProtocol)">
                  <el-form-item prop="output.mcOutputDestinationAddress" required>
                    <el-input
                      v-model="form.output.mcOutputDestinationAddress"
                      size="small"
                      placeholder="Destination Address"
                    ></el-input>
                  </el-form-item>
                  <el-form-item prop="output.mcOutputDestinationPort" required>
                    <el-input
                      v-model.number="form.output.mcOutputDestinationPort"
                      type="number"
                      size="small"
                      placeholder="Destination Port"
                    ></el-input>
                  </el-form-item>
                </template>
              </div>
            </div>
          </div>
          <!-- OUTPUTPROFILE SPECIFIC FIELDS -->
          <div v-if="formType === 'outputProfile'">
            <el-divider content-position="left">Output profile specific data</el-divider>
            <!-- {{accountsFromSelectedClaims}} -->
            <el-form-item prop="outputs">
              <el-select
                v-model="form.outputProfile.outputs"
                multiple
                collapse-tags
                filterable
                placeholder="Select outputs"
                size="mini"
              >
                <el-option
                  v-for="item in sortedOutputs"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                  <span>{{ item.name }}</span>
                  <small style="opacity: 0.75; float: right; margin-left: 10px">
                    {{ item.description }}
                  </small>
                </el-option>
              </el-select>
              <small v-show="doesUserHaveAccessToOutputs" style="color: red">
                Some of the assigned outputs has wrong user rights.
              </small>
            </el-form-item>
          </div>

          <!-- MULTIVIEWERS SPECIFIC FIELDS -->
          <div v-if="formType === 'multiviewer'">
            <el-divider content-position="left">Multiviewers specific data</el-divider>
            <!-- {{accountsFromSelectedClaims}} -->
            <el-form-item prop="audioControlId">
              <el-input
                v-model="form.multiviewer.audioControlId"
                placeholder="Audio control id"
                required
                size="small"
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="routableDestinationId">
              <el-input
                v-model="form.multiviewer.routableDestinationId"
                placeholder="Destination id"
                required
                size="small"
              >
              </el-input>
            </el-form-item>
            <el-form-item prop="type">
              <el-select v-model="form.multiviewer.type" placeholder="Multiviewer type" size="mini">
                <el-option v-for="item in ['OTT', 'ROUTABLE']" :key="item" :value="item">
                  <span>{{ item }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="outputs">
              <el-select
                v-model="form.multiviewer.streamSources"
                multiple
                collapse-tags
                filterable
                placeholder="Select stream sources"
                size="mini"
              >
                <el-option
                  v-for="item in mvStreamSources"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                  <span>{{ item.name }}</span>
                  <small style="opacity: 0.75; float: right; margin-left: 10px">
                    {{ item.description }}
                  </small>
                </el-option>
              </el-select>
              <!-- <small v-show="doesUserHaveAccessToOutputs" style="color: red">
                  Some of the assigned outputs has wrong user rights.
                </small> -->
              <!-- <ul class="list-group " v-sortable="{ handle: '.handle' }">
                    <li class="list-group-item mb-4 p-3 bg-gray-100" v-for="source in form.multiviewer.streamSources" :key="source">
                      {{sourceNameById(source)}} <i class="handle far fa-bars"></i>
                    </li>

                </ul> -->
              <draggable
                tag="ul"
                draggable=".item"
                v-model="form.multiviewer.streamSources"
                class="list-group mt-2"
                handle=".handle"
              >
                <li
                  class="item list-group mb-1 p-1 px-2 bg-gray-100"
                  v-for="source in form.multiviewer.streamSources"
                  :key="source"
                >
                  <i class="handle far fa-bars"></i> {{ sourceNameById(source) }}
                </li>
              </draggable>
            </el-form-item>
            <el-form-item prop="grid">
              <el-input
                v-model="form.multiviewer.grid"
                size="small"
                placeholder="Multiviewer grid size"
              ></el-input>
            </el-form-item>
          </div>

          <!-- ROUTER GROUP SPECIFIC FIELDS -->
          <!-- ROUTER GROUP SPECIFIC FIELDS -->
          <div v-if="formType === 'routerGroup'">
            <el-divider content-position="left">Router Group specific data</el-divider>

            <el-form-item prop="routerAccountId">
              <el-select
                v-model="form.routerGroup.routerGroupRouterId"
                placeholder="Select router"
                value-key="id"
                required
                size="small"
              >
                <el-option :key="el.id" :value="el.id" :label="el.name" v-for="el in routers">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="routerGroup.sources">
              <el-select
                v-model="form.routerGroup.sources"
                placeholder="Select sources"
                value-key="id"
                required
                multiple
                filterable
                size="small"
              >
                <el-option :key="el.id" :value="el" :label="el.name" v-for="el in sortedSources">
                  <span>{{ el.name }}</span>
                  <small style="margin-left: 10px; opacity: 0.75; float: right">
                    {{ el.description }}
                  </small>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="routerGroup.destinations">
              <el-select
                v-model="form.routerGroup.destinations"
                placeholder="Select destinations"
                value-key="id"
                required
                filterable
                multiple
                size="small"
              >
                <el-option :key="el.id" :value="el" :label="el.name" v-for="el in sortedDest">
                  <span>{{ el.name }}</span>
                  <small style="margin-left: 10px; opacity: 0.75; float: right">
                    {{ el.description }}
                  </small>
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <!-- ROUTER SOURCE SPECIFIC FIELDS -->
          <div v-if="formType === 'routerSource'">
            <el-divider content-position="left">Router Source specific data</el-divider>
            <el-form-item prop="mappedInputs">
              <el-select
                v-model="form.routerSource.mappedInputs"
                placeholder="Select inputs"
                value-key="id"
                multiple
                filterable
                size="small"
              >
                <el-option :key="el.id" :value="el" :label="el.name" v-for="el in sortedInputs">
                  <span>{{ el.name }}</span>
                  <small style="margin-left: 10px; opacity: 0.75; float: right">
                    {{ el.description }}
                  </small>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="routerSource.originRouterGroup" required>
              <el-input
                v-model="form.routerSource.originRouterGroup"
                placeholder="Origin router group"
                required
                size="small"
              >
              </el-input>
            </el-form-item>

            <el-form-item prop="routerSource.originRouterId" required>
              <el-input
                v-model="form.routerSource.originRouterId"
                placeholder="Origin router ID"
                required
                size="small"
              >
              </el-input>
            </el-form-item>

            <el-form-item prop="routerSource.originRouterSourceId" required>
              <el-input
                v-model="form.routerSource.originRouterSourceId"
                placeholder="Origin router source id"
                required
                size="small"
              >
              </el-input>
            </el-form-item>
          </div>

          <!-- ROUTER DESTINATION SPECIFIC FIELDS -->
          <!-- ROUTER DESTINATION SPECIFIC FIELDS -->
          <div v-if="formType === 'routerDestination'">
            <el-divider content-position="left">Router Destination specific data</el-divider>
            <el-form-item prop="mappedOutputs">
              <el-select
                v-model="form.routerDestination.mappedOutputs"
                placeholder="Select outputs"
                value-key="id"
                multiple
                filterable
                size="small"
              >
                <el-option :key="el.id" :value="el" :label="el.name" v-for="el in sortedOutputs">
                  <span>{{ el.name }}</span>
                  <small style="margin-left: 10px; opacity: 0.75; float: right">
                    {{ el.description }}
                  </small>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="routerDestination.originRouterGroup" required>
              <el-input
                v-model="form.routerDestination.originRouterGroup"
                placeholder="Origin router group"
                size="small"
              >
              </el-input>
            </el-form-item>

            <el-form-item prop="routerDestination.originRouterId" required>
              <el-input
                v-model="form.routerDestination.originRouterId"
                placeholder="Origin router ID"
                size="small"
              >
              </el-input>
            </el-form-item>

            <el-form-item prop="routerDestination.originRouterDestinationId" required>
              <el-input
                v-model="form.routerDestination.originRouterDestinationId"
                placeholder="Origin router destination ID"
                size="small"
              >
              </el-input>
            </el-form-item>

            <el-form-item prop="routerDestination.routerDestinationDefaultSourceId">
              <el-select
                v-model="form.routerDestination.routerDestinationDefaultSourceId"
                placeholder="Select default source"
                value-key="id"
                filterable
                size="small"
              >
                <el-option :key="el.id" :value="el" :label="el.name" v-for="el in sortedSources">
                  <span>{{ el.name }}</span>
                  <small style="margin-left: 10px; opacity: 0.75; float: right">
                    {{ el.description }}
                  </small>
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <!-- STREAM DESTINATION SPECIFIC FIELDS -->
          <!-- STREAM DESTINATION SPECIFIC FIELDS -->
          <div v-if="formType === 'streamDestination'">
            <el-divider content-position="left">Stream Destination specific data</el-divider>

            <el-form-item prop="streamDestination.type" required>
              <el-select
                v-model="form.streamDestination.type"
                placeholder="Select stream type"
                size="small"
              >
                <el-option :key="el" :value="el" :label="el" v-for="el in streamTypes"> </el-option>
              </el-select>
            </el-form-item>

            <el-row :gutter="14">
              <el-col :span="15">
                <el-form-item prop="streamDestination.udpAddress">
                  <el-input
                    v-model="form.streamDestination.udpAddress"
                    placeholder="UDP Address"
                    required
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item prop="streamDestination.udpPort">
                  <el-input
                    type="number"
                    v-model="form.streamDestination.udpPort"
                    placeholder="UDP Port"
                    required
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item prop="streamDestination.udpRtt">
              <el-input
                v-model="form.streamDestination.udpRtt"
                type="number"
                placeholder="UDP Rtt"
                required
                size="small"
              >
              </el-input>
            </el-form-item>

            <el-form-item prop="streamDestination.streamDestinationRouterDestinationId">
              <el-select
                v-model="form.streamDestination.streamDestinationRouterDestinationId"
                placeholder="Select router destination"
                value-key="id"
                filterable
                size="small"
              >
                <el-option
                  :key="el.id"
                  :value="el.id"
                  :label="el.name"
                  v-for="el in sortedRouterDestinations"
                >
                  <span>{{ el.name }}</span>
                  <small style="margin-left: 10px; opacity: 0.75; float: right">
                    {{ el.description }}
                  </small>
                </el-option>
              </el-select>
            </el-form-item>

            <el-row :gutter="14">
              <el-col :span="15">
                <el-form-item prop="streamDestination.address">
                  <el-input
                    v-model="form.streamDestination.address"
                    placeholder="Address"
                    required
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item prop="streamDestination.port">
                  <el-input
                    v-model="form.streamDestination.port"
                    placeholder="Port"
                    type="number"
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="14">
              <el-col :span="15">
                <el-form-item prop="streamDestination.talkbackAddress">
                  <el-input
                    v-model="form.streamDestination.talkbackAddress"
                    placeholder="Talkback Address"
                    required
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item prop="streamDestination.talkbackPort">
                  <el-input
                    v-model="form.streamDestination.talkbackPort"
                    placeholder="Talkback Port"
                    type="number"
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="14">
              <el-col :span="8">
                <el-form-item prop="streamDestination.latencyMs">
                  <el-input
                    v-model="form.streamDestination.latencyMs"
                    placeholder="Latency (ms)"
                    type="number"
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="streamDestination.bufferMaxMs">
                  <el-input
                    v-model="form.streamDestination.bufferMaxMs"
                    placeholder="Max Buffer (ms)"
                    type="number"
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="streamDestination.bufferMinMs">
                  <el-input
                    v-model="form.streamDestination.bufferMinMs"
                    placeholder="Min Buffer (ms)"
                    type="number"
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item prop="streamDestination.encPassphrase">
              <el-input
                v-model="form.streamDestination.encPassphrase"
                placeholder="Enc Passphrase"
                required
                size="small"
              >
              </el-input>
            </el-form-item>

            <el-row :gutter="14">
              <el-col :span="12">
                <el-form-item prop="streamDestination.encKeyLen">
                  <el-input
                    v-model="form.streamDestination.encKeyLen"
                    placeholder="Enc Key Length"
                    type="number"
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="streamDestination.encType">
                  <el-select
                    v-model="form.streamDestination.encType"
                    placeholder="Select enc type"
                    size="small"
                  >
                    <el-option
                      :key="el"
                      :value="el"
                      :label="el"
                      v-for="el in streamEncryptionTypes"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- STREAM SOURCE SPECIFIC FIELDS -->
          <!-- STREAM SOURCE SPECIFIC FIELDS -->
          <div v-if="formType === 'streamSource'">
            <el-divider content-position="left">Stream Destination specific data</el-divider>

            <el-form-item prop="streamSource.type" required>
              <el-select
                v-model="form.streamSource.type"
                placeholder="Select stream type"
                size="small"
              >
                <el-option :key="el" :value="el" :label="el" v-for="el in streamTypes"> </el-option>
              </el-select>
            </el-form-item>

            <el-row :gutter="14">
              <el-col :span="15">
                <el-form-item prop="streamSource.udpAddress">
                  <el-input
                    v-model="form.streamSource.udpAddress"
                    placeholder="UDP Address"
                    required
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item prop="streamSource.udpPort">
                  <el-input
                    v-model="form.streamSource.udpPort"
                    placeholder="UDP Port"
                    type="number"
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="14">
              <el-col :span="15">
                <el-form-item prop="streamSource.address">
                  <el-input
                    v-model="form.streamSource.address"
                    placeholder="Address"
                    required
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item prop="streamSource.port">
                  <el-input
                    v-model="form.streamSource.port"
                    placeholder="Port"
                    type="number"
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="14">
              <el-col :span="15">
                <el-form-item prop="streamSource.talkbackAddress">
                  <el-input
                    v-model="form.streamSource.talkbackAddress"
                    placeholder="Talkback Address"
                    required
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item prop="streamSource.talkbackPort">
                  <el-input
                    v-model="form.streamSource.talkbackPort"
                    placeholder="Talkback Port"
                    required
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="14">
              <el-col :span="8">
                <el-form-item prop="streamSource.latencyMs">
                  <el-input
                    v-model="form.streamSource.latencyMs"
                    placeholder="Latency (ms)"
                    type="number"
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="streamSource.bufferMaxMs">
                  <el-input
                    v-model="form.streamSource.bufferMaxMs"
                    placeholder="Max Buffer (ms)"
                    type="number"
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <div v-if="formType === 'streamSource'">
                  <el-form-item prop="streamSource.bufferMinMs">
                    <el-input
                      v-model="form.streamSource.bufferMinMs"
                      placeholder="Min Buffer (ms)"
                      type="number"
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-form-item prop="streamSource.encPassphrase">
              <el-input
                v-model="form.streamSource.encPassphrase"
                placeholder="Enc Passphrase"
                required
                size="small"
              >
              </el-input>
            </el-form-item>

            <el-row :gutter="14">
              <el-col :span="12">
                <el-form-item prop="streamSource.encKeyLen">
                  <el-input
                    v-model="form.streamSource.encKeyLen"
                    placeholder="Enc Key Length"
                    type="number"
                    size="small"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="streamSource.encType">
                  <el-select
                    v-model="form.streamSource.encType"
                    placeholder="Select enc type"
                    size="small"
                  >
                    <el-option
                      :key="el"
                      :value="el"
                      :label="el"
                      v-for="el in streamEncryptionTypes"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- CLAIMS -->
          <div v-if="formType !== 'location'">
            <el-divider content-position="left">Claims</el-divider>
            <el-form-item prop="claimsCanAccess" required="">
              <div class="claim-cascade">
                <div class="claim-cascade-input">
                  <ma-permissions class="bly-permissions"></ma-permissions>
                  <el-cascader
                    size="small"
                    placeholder="Select access claims"
                    v-model="form.claimsCanAccess"
                    :options="claimsTree"
                    collapse-tags
                    :props="{ multiple: true, checkStrictly: true }"
                    :show-all-levels="false"
                    clearable
                  >
                  </el-cascader>
                </div>
              </div>
              <small v-if="formType === 'outputProfile'">
                Please specify account users <el-tag size="mini">(usr.{acc}.{client})</el-tag><br />
                for Output Profiles due to list visibility reasons
              </small>
            </el-form-item>
            <el-form-item prop="claimsCanEdit" required="">
              <div class="claim-cascade">
                <div class="claim-cascade-input">
                  <ma-edit class="bly-edit"></ma-edit>
                  <el-cascader
                    size="small"
                    placeholder="Select edit claims"
                    v-model="form.claimsCanEdit"
                    :options="claimsTree"
                    collapse-tags
                    :props="{ multiple: true, checkStrictly: true }"
                    :show-all-levels="false"
                    clearable
                  ></el-cascader>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">

        <el-dropdown
          v-if="['input', 'output', 'transcodingProfile', 'transcodingOutput'].includes(formType) && isSysAdmin"
          trigger="click"
          @command="applySamplePreset"
        >
          <el-button size="small">
            Test Data<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="preset in getSamplePresetOptions()"
              :key="preset.command"
              :command="preset.command"
            >
              {{ preset.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          @click="
            showAddDialog = false;
            resetForm();
          "
          >Cancel</el-button
        >
        <el-button type="primary" :loading="addItemLoading" @click="addItem(form)">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import { mapState, mapActions } from "vuex";
import draggable from "vuedraggable";
import TranscodingConfigEditor from "../components/Admin/TranscodingConfigEditor.vue";
import TranscodingOutputConfigEditor from "../components/Admin/TranscodingOutputConfigEditor.vue";
import Pagination from "vue-pagination-2";
import PaginationTemplate from "./PaginationTemplate.vue";
import ProbesServices from "../services/Probes";

import StreamRouterInterfaceConfig from "@/components/StreamRouter/StreamRouterInterfaceConfig.vue";
import WowzaTargetConfig from "@/components/Wowza/WowzaTargetConfig.vue";
import PermissionFormModal from "@/components/PermissionsSimple/PermissionFormModal.vue";
import InputPermissionForm from "@/components/PermissionsSimple/InputPermissionForm.vue";
import OutputPermissionForm from "@/components/PermissionsSimple/OutputPermissionForm.vue";
import OutputProfilePermissionForm from "@/components/PermissionsSimple/OutputProfilePermissionForm.vue";
import TranscodingPermissionForm from "@/components/PermissionsSimple/TranscodingPermissionForm.vue";
import LocationPermissionForm from "@/components/PermissionsSimple/LocationPermissionForm.vue";
import {
  buildClaimSelections,
  buildPermissionSearchIndex,
  cloneDeep,
  matchesPermissionSearch,
  normalizeLocationArray,
  serializeClaimSelections,
  sortByName,
  supportsPermissionModalType,
} from "@/services/permissionsSimpleHelpers";
import {
  validateInputForm,
  validateOutputForm,
  validateOutputProfileForm,
  validateInputProfileForm,
  validateProviderForm,
  validateTranscodingForm,
} from "@/services/permissionsSimpleValidation";
import { createDefaultInputProfileConfig } from "@/services/inputProfileConfig";

const MOS_OUTPUT_TYPES = ["OTT", "ROUTE", "TECHEX", "MEDIA_CONNECT"];
const MOS_OTT_PLATFORM_TYPES = ["YOUTUBE", "RTMP"];
const MOS_WOWZA_SERVERS = [
  { id: "1044", name: "1044" },
  { id: "1045", name: "1045" },
];
const MOS_STREAM_ROUTERS = [
  { id: "IMG-SR03", name: "IMG-SR03" },
  { id: "IMG-SR04", name: "IMG-SR04" },
];
const MOS_OUTPUT_LOCATIONS = {
  OTT: ["IMG-UK"],
  ROUTE: ["IMG-UK"],
  TECHEX: ["LON1", "LON2", "HGK1", "SGP1"],
};
const LOCATION_TYPES = ["AWS", "TECHEX", "WOWZA", "SR", "DEFAULT"];

function createDefaultWowzaTargetConfig() {
  return {
    entryName: null,
    enabled: true,
    sourceStreamName: null,
    streamName: null,
    host: null,
    port: null,
    profile: "rtmp",
    application: null,
    timeToLive: null,
    streamWaitTimeout: null,
    videoPort: null,
    audioPort: null,
    srtLatency: null,
    srtTooLatePacketDrop: true,
    srtTimestampBasedDeliveryMode: true,
    srtSendBufferSize: null,
    srtSendBufferSizeUDP: null,
    srtMaximumSegmentSize: null,
    srtFlightFlagSize: null,
    srtMaximumBandwidth: null,
    srtInputBandwidth: null,
    srtOverheadBandwidth: null,
    srtConnectTimeout: null,
    srtPeerIdleTimeout: null,
    srtStreamId: null,
  };
}

function createDefaultOutputForm() {
  return {
    outputType: null,
    status: null,
    displayName: null,
    url: null,
    location: null,
    allowExternalConfigUpdate: false,
    config: null,
    outputConfigError: null,
    routeInterfaceConflict: null,
    ottApplication: null,
    ottNoStremKeyRequired: false,
    ottPlatform: null,
    ottServer: null,
    ottDefaultTranscoderProfile: null,
    wowzaServerId: null,
    wowzaApplicationId: null,
    wowzaTargetId: null,
    createWowzaTarget: false,
    wowzaTargetConfig: createDefaultWowzaTargetConfig(),
    streamRouterId: null,
    interfaceId: null,
    interfaceName: null,
    interfaceDescription: "",
    routeType: "SR",
    smEndpoints: [],
    techexOutputId: null,
    techexEdgeId: null,
    techexBlankStreamId: null,
    routerOutputArn: null,
    routingScope: "REGIONAL",
    mediaConnectOutputId: null,
    mediaConnectOutputDetails: null,
    mcOutputName: null,
    mcOutputBitrate: null,
    mcOutputTier: "OUTPUT_50",
    mcOutputNetworkInterfaceArn: null,
    mcOutputProtocol: null,
    mcOutputPort: null,
    mcOutputLatency: null,
    mcOutputDestinationAddress: null,
    mcOutputDestinationPort: null,
  };
}

function createDefaultTranscodingProfileConfig() {
  return JSON.stringify({
    name: "",
    inputType: "MEDIACONNECT_ROUTER",
    channelClass: "SINGLE_PIPELINE",
    InputSpecification: {
      Codec: "AVC",
      MaximumBitrate: "MAX_20_MBPS",
      Resolution: "HD",
    },
  });
}

function createDefaultTranscodingOutputConfig() {
  return JSON.stringify({
    outputGroup: {
      name: "Archive-Group-01",
      type: "HLS",
      outputGroupSettings: {
        HlsGroupSettings: {
          Destination: {
            DestinationRefId: "FROM_TEMPLATE",
          },
          DirectoryStructure: "SINGLE_DIRECTORY",
          IndexNSegments: 10,
          ManifestDurationFormat: "FLOATING_POINT",
          Mode: "LIVE",
          SegmentLength: 6,
        },
      },
      outputs: [
        {
          OutputName: "HD-HLS-Output",
          OutputSettings: {
            HlsOutputSettings: {
              H265PackagingType: "HVC1",
              HlsSettings: {
                HlsSettingsChoice: "STANDARD_HLS",
                StandardHlsSettings: {
                  AudioRenditionSets: "program_audio",
                  M3u8Settings: {
                    AudioPids: "492-498",
                    VideoPid: "481",
                  },
                },
              },
            },
          },
        },
      ],
    },
  });
}

export default {
  components: {
    StreamRouterInterfaceConfig,
    WowzaTargetConfig,
    PermissionFormModal,
    InputPermissionForm,
    OutputPermissionForm,
    OutputProfilePermissionForm,
    TranscodingPermissionForm,
    LocationPermissionForm,
    draggable,
    TranscodingConfigEditor,
    TranscodingOutputConfigEditor,
    Pagination,
  },
  data() {
    return {
      // psgination
      page: 1,
      pageSize: 50,
      sortedList: [],
      options: {
        template: PaginationTemplate,
        edgeNavigation: true,
        hasEdgeNav: true,
      },
      probes: [],
      availableStreamRouters: MOS_STREAM_ROUTERS,
      availableWowzaServers: MOS_WOWZA_SERVERS,
      streamRouterInterfaces: [],
      loadingStreamRouterInterfaces: false,
      loadingInterfaceDetails: false,
      wowzaApplications: [],
      wowzaTargets: [],
      loadingMediaConnectOutputs: false,
      // Stream Router & Wowza data
      loadingWowzaData: false,
      //
      listCompactStyle: true,
      activeList: [],
      activeItem: null,
      listType: "",
      inputList: null,
      loading: false,
      initializing: false,
      showAddDialog: false,
      addItemLoading: false,
      transcodingOutputValid: true,
      transcodingOutputErrors: [],
      formType: "",
      editedItem: null,
      inEditMode: false,
      varPlaceholder: null,
      form: {
        name: "",
        description: null,
        claimsCanAccess: [],
        claimsCanEdit: [],
        accounts: [],
        input: {
          streamFileBaseName: null,
          type: null,
          inputDownlinkConfigId: null,
          url: null,
          frcAvailable: null,
          requireDetails: null,
          probeProjectId: null,
          probeTaskId: null,
          // Stream Router Interface fields
          createInterface: false,
          streamRouterId: null,
          interfaceName: null,
          source: { url: null, type: 'SRT', max_connections: null, latency: null, ttl: null, passphrase: null, stream_id: null, max_bw: null },
          destination: { url: null, type: 'SRT', max_connections: null, latency: null, ttl: null, passphrase: null, stream_id: null, max_bw: null },
          processors: [],
          tags: [],
          whitelist: [],
          autostart: false,
          location: null,
          locationArray: [],
          // AWS MediaConnect fields
          mcInputName: null,
          mcInputBitrate: null,
          mcInputRoutingScope: 'REGIONAL',
          mcInputTier: 'INPUT_50',
          mcInputNetworkInterfaceArn: null,
          mcInputProtocol: null,
          mcInputPort: null,
          mcInputLatency: null,
          mcInputSourceAddress: null,
          mcInputSourcePort: null,
          mcInputRecoveryLatency: null,
        },
        transcoderProfile: {
          transcoderProfile: null,
        },
        transcoding: {
          type: "MEDIA_LIVE",
          config: JSON.stringify({
            name: "",
            inputType: "MEDIACONNECT_ROUTER",
            channelClass: "SINGLE_PIPELINE",
            InputSpecification: {
              Codec: "AVC",
              MaximumBitrate: "MAX_20_MBPS",
              Resolution: "HD"
            }
          })
        },
        multiviewer: {
          grid: 2,
          streamSources: [],
          routableDestinationId: null,
          type: null,
        },
        output: {
          ...createDefaultOutputForm(),
        },
        outputProfile: {
          outputs: [],
        },
        location: {
          code: null,
          type: "DEFAULT",
        },
        router: {
          routerAccountId: null,
          routerGroups: [],
        },
        routerSource: {
          originRouterGroup: null,
          originRouterId: null,
          originRouterSourceId: null,
          routerGroups: [],
          mappedInputs: [],
        },
        routerDestination: {
          originRouterDestinationId: null,
          originRouterGroup: null,
          originRouterId: null,
          routerDestinationRoutedSourceId: null,
          routerDestinationDefaultSourceId: null,
          routerGroups: [],
          mappedInputs: [],
          mappedOutputs: [],
        },
        routerGroup: {
          routerGroupRouterId: null,
          sources: [],
          destinations: [],
        },
        streamSource: {
          type: null,
          port: null,
          address: null,
          talkbackAddress: null,
          talkbackPort: null,

          latencyMs: null,
          bufferMaxMs: null,
          bufferMinMs: null,
          encPassphrase: null,
          encKeyLen: null,
          encType: null,
          udpAddress: null,
          udpPort: null,
        },
        streamDestination: {
          type: null,
          streamDestinationRouterDestinationId: null,
          port: null,
          address: null,
          talkbackAddress: null,
          talkbackPort: null,

          latencyMs: null,
          bufferMaxMs: null,
          bufferMinMs: null,
          encPassphrase: null,
          encKeyLen: null,
          encType: null,
          udpAddress: null,
          udpPort: null,
          udpRtt: null,
        },
      },
      // Stream Manager Endpoints JSON management
      smEndpointsJsonError: null,
      status: ["ONLINE", "OFFLINE", "DELETED"],
      outputTypes: MOS_OUTPUT_TYPES,
      locationTypes: LOCATION_TYPES,
      ottPlatformTypes: MOS_OTT_PLATFORM_TYPES,
      inputTypes: ["DOWNLINK", "ROUTE", "TECHEX", "MEDIA_CONNECT"],
      mediaConnectRoutingScopes: ["REGIONAL", "GLOBAL"],
      mediaConnectTiersInput: ["INPUT_20", "INPUT_50", "INPUT_100"],
      mediaConnectTiersOutput: ["OUTPUT_20", "OUTPUT_50", "OUTPUT_100"],
      mediaConnectProtocols: ["SRT_LISTENER", "SRT_CALLER", "RTP", "RIST"],

      searchQuery: "",
      selectedInputTypeFilter: "",
      selectedOutputTypeFilter: "",
      permissionModalVisible: false,
      permissionModalMode: "create",
      permissionModalEntityType: "",
      permissionModalDraft: null,
      permissionModalErrors: {},
      permissionModalLoading: false,
    };
  },
  computed: {
    ...mapState({
      acl: (state) => state.userAccount.aclCurrent,
      isAdmin: (state) => state.userAccount.isAdmin,
      isSysAdmin: (state) => state.userAccount.isSysAdmin,
      // loading: state => state.permissions.loading,
      clients: (state) => state.permissions.clients,
      claims: (state) => state.permissions.claims,
      inputs: (state) => state.permissions.inputs,
      inputProfiles: (state) => state.permissions.inputProfiles,
      providers: (state) => state.permissions.providers,
      outputs: (state) => state.permissions.outputs,
      multiviewers: (state) => state.permissions.multiviewers,
      outputsById: (state) => state.permissions.outputsById,
      outputProfiles: (state) => state.permissions.outputProfiles,
      routers: (state) => state.permissions.routers,
      routerGroups: (state) => state.permissions.routerGroups,
      routerDestinations: (state) => state.permissions.routerDestinations,
      routerSources: (state) => state.permissions.routerSources,
      streamDestinations: (state) => state.stream.streamDestinations,
      streamSources: (state) => state.stream.streamSources,
      streamRouters: (state) => state.streamingManager.streamRouters,
      transcodingProfiles: (state) => state.permissions.transcodingProfiles,
      transcodingOutputs: (state) => state.permissions.transcodingOutputs,
      userSession: (state) => state.userAccount.userSession,
      transcoderProfiles: (state) => state.permissions.transcoderProfiles,
      locations: (state) => state.permissions.locations,
      streamEncryptionTypes: (state) => state.stream.encryptionTypes,
      streamTypes: (state) => state.stream.streamTypes,
      equipment: (state) => state.permissions.equipment,
      // Wowza data from StreamingManager
      wowzaServersFromStore: (state) => state.streamingManager.wowzaServers,
      wowzaApplicationsFromStore: (state) => state.streamingManager.wowzaApplications,
      wowzaTargetsFromStore: (state) => state.streamingManager.wowzaTargets,
      transcoderTemplatesFromStore: (state) => state.streamingManager.transcoderTemplates,
      mediaConnectNetworkInterfaces: (state) => state.streamingManager.mediaConnectNetworkInterfaces,
      mediaConnectOutputs: (state) => state.streamingManager.mediaConnectOutputs,
    }),
    userId() {
      return this.userSession.idToken.payload.sub;
    },
    isEventEditor() {
      return this.isSysAdmin || this.isAdmin || (this.acl && (this.acl.clientAdmin || this.acl.ee || this.acl.eventCoordinator));
    },
    claimsByCode() {
      const claims = {};
      this.claims.forEach((claim) => {
        claims[claim.code] = claim;
      });
      return claims;
    },
    filteredList() {
      let list = this.sortedList;

      if (this.listType === "input" && this.selectedInputTypeFilter) {
        list = list.filter((item) => item.type === this.selectedInputTypeFilter);
      }

      if (this.listType === "output" && this.selectedOutputTypeFilter) {
        list = list.filter((item) => item.outputType === this.selectedOutputTypeFilter);
      }

      if (!this.searchQuery) return list;

      const query = this.searchQuery.toLowerCase();
      return list.filter((item) => {
        return Object.values(item).some((value) => String(value).toLowerCase().includes(query));
      });
    },
    availableInputTypeFilters() {
      const typesFromData = this.sortedList
        .map((item) => item?.type)
        .filter((type) => !!type);
      return [...new Set([...this.inputTypes, ...typesFromData])];
    },
    availableOutputTypeFilters() {
      const typesFromData = this.sortedList
        .map((item) => item?.outputType)
        .filter((type) => !!type);
      return [...new Set([...this.outputTypes, ...typesFromData])];
    },
    displayList() {
      const start = this.page * this.pageSize - this.pageSize;
      const end = start + this.pageSize;
      return this.filteredList.slice(start, end);
    },

    listName() {
      return this.listType.split(/(?=[A-Z])/).join(" ");
    },

    totalCount() {
      return this.filteredList.length;
    },

    mvStreamSources() {
      return this.streamSources.filter((item) => item.type === "HLS" || item.type === "DASH");
    },
    totalItems() {
      return this.filteredList.length;
    },
    usingPermissionModal() {
      return supportsPermissionModalType(this.permissionModalEntityType);
    },
    permissionModalOutputLocationOptions() {
      if (!this.permissionModalDraft?.output?.outputType) return [];
      return this.getOutputLocationOptions(
        this.permissionModalDraft.output.outputType,
        this.permissionModalDraft.output.location
      );
    },
    permissionModalOutputProfileHasAccessMismatch() {
      if (this.permissionModalEntityType !== "outputProfile" || !this.permissionModalDraft) {
        return false;
      }

      const selectedClaims = serializeClaimSelections(this.permissionModalDraft.claimsCanAccess);
      const selectedAccounts = selectedClaims
        .map((claim) => String(claim).split(".").pop())
        .filter(Boolean);

      const outputAccounts = (this.permissionModalDraft.outputIds || [])
        .map((outputId) => this.outputsById?.[outputId])
        .filter(Boolean)
        .flatMap((output) => output.claimsCanAccess || [])
        .map((claim) => String(claim).split(".").pop());

      return outputAccounts.some((accountCode) => !selectedAccounts.includes(accountCode));
    },

    // Get Wowza servers from equipment
    wowzaServersFromEquipment() {
      if (!this.equipment) return [];
      return this.equipment.filter(eq => eq.equipmentType === 'WOWZA')
        .sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });
    },

    // output profile - outputs access test
    //
    accountsFromSelectedClaims() {
      const accounts = this.form.claimsCanAccess
        .flat(Infinity)
        .map((claim) => claim.split(".").pop());
      return accounts;
    },

    selectedProfileOutputs() {
      let outputs = [];
      this.form.outputProfile.outputs.forEach((el) => {
        outputs = [...outputs, this.outputsById[el]];
      });

      return outputs;
    },

    selectedProfileOutputAccounts() {
      const accounts = this.selectedProfileOutputs
        .map((el) => el.claimsCanAccess)
        .flat(Infinity)
        .map((el) => el.split(".").pop());
      return [...new Set(accounts)];
    },

    doesUserHaveAccessToOutputs() {
      let doesNotHaveAccess = false;

      this.selectedProfileOutputAccounts.forEach((el) => {
        if (this.accountsFromSelectedClaims.indexOf(el) === -1) doesNotHaveAccess = true;
      });

      return doesNotHaveAccess;
    },
    //
    // end output profile - outputs access test

    // output profile edit - outputs access test
    //
    itemAccountsFromSelectedClaims() {
      return (item) => {
        const accountsClaims = item.claimsCanAccess.map((claim) => claim.split(".").pop());

        const accounts = item.outputs
          .map((el) => el.claimsCanAccess)
          .flat(Infinity)
          .map((el) => el.split(".").pop());

        let doesNotHaveAccess = false;

        accounts.forEach((el) => {
          if (accountsClaims.indexOf(el) === -1) doesNotHaveAccess = true;
        });

        return doesNotHaveAccess;
      };
    },
    //
    // output profile edit - outputs access test

    sortedRouterDestinations() {
      return this.routerDestinations.slice(0).sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },

    sortedOutputs() {
      return this.outputs.slice(0).sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },

    sortedInputs() {
      return this.inputs.slice(0).sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },

    sortedDest() {
      return this.routerDestinations.slice(0).sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },

    sortedSources() {
      return this.routerSources.slice(0).sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    },

    routerGroupList() {
      return this.routerGroups
        .filter((item) => {
          if (!item) return false;
          return true;
        })
        .sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
    },

    sourceNameById() {
      return (id) => {
        let name = "";
        this.mvStreamSources.forEach((el) => (name = el.id === id ? el.name : name));
        return name;
      };
    },

    accounts() {
      const accountList = [];
      this.clients.forEach((client) => {
        client.accounts.items.forEach((account) => {
          accountList.push({
            ...account,
            client,
          });
        });
      });
      return accountList;
    },

    activeItemPermissions() {
      // const permissions = {};
      const permissions = this.clients.map((client) => {
        const newClientObject = {
          name: client.name,
          code: client.code,
          description: client.description,
          accounts: {},
          claim: `usr.${client.code}`,
        };
        newClientObject.accounts = client.accounts.items.map((account) => {
          const newAccountObject = {
            name: account.name,
            code: account.code,
            description: account.description,
            claim: `usr.${account.code}.${client.code}`,
            claims: {},
          };
          // console.log('newAccountObject', newAccountObject);
          this.claims.forEach((claim) => {
            if (claim.code === "ca") return;
            newAccountObject.claims[claim.code] = `${claim.code}.${account.code}.${client.code}`;
          });
          return newAccountObject;
        });

        return newClientObject;
      });
      return permissions;
    },
    claimsNames() {
      const claims = {};
      this.claimsTree.forEach((clientClaim) => {
        claims[clientClaim.value] = clientClaim.label;
        clientClaim.children.forEach((accountClaim) => {
          claims[accountClaim.value] = accountClaim.label;

          const hasChildren = !!accountClaim.children;

          if (hasChildren) {
            accountClaim.children.forEach((childrenClaim) => {
              claims[childrenClaim.value] = childrenClaim.label;
            });
          }
        });
      });
      return claims;
    },
    claimsTree() {
      // const permissions = [];
      if (!this.clients) return [];
      const newClaimTree = this.clients.map((client) => {
        const newClientObject = {
          label: `${client.name} [usr.${client.code}]`,
          value: `usr.${client.code}`,
          children: [],
        };

        newClientObject.children = client.accounts.items.map((account) => {
          const newAccountObject = {
            label: `${account.name} [usr.${account.code}.${client.code}]`,
            value: `usr.${account.code}.${client.code}`,
            children: [],
          };
          // console.log('newAccountObject', newAccountObject);
          this.claims.forEach((claim) => {
            if (claim.code === "ca") return;
            const claimString = `${claim.code}.${account.code}.${client.code}`;
            newAccountObject.children.push({
              value: claimString,
              label: `${claim.name} [${claimString}]`,
            });
          });
          return newAccountObject;
        });

        newClientObject.children.unshift({
          label: `Client Admin [ca.${client.code}.${client.code}]`,
          value: `ca.${client.code}.${client.code}`,
        });
        return newClientObject;
      });
      return newClaimTree;
    },
    isClaimAssign() {
      return (claim, object) => {
        const isActvie = object.indexOf(claim) > -1;
        return isActvie ? "active" : "";
      };
    },
    isClaimDisabled() {
      return (claim, object) => {
        const isActvie = object.indexOf(claim) > -1;
        return isActvie ? " disabled" : "";
      };
    },

    // Computed property to sync smEndpoints array with JSON string
    smEndpointsJsonString: {
      get() {
        if (this.form.output.smEndpoints && this.form.output.smEndpoints.length > 0) {
          return JSON.stringify(this.form.output.smEndpoints, null, 2);
        }
        return "";
      },
      set(value) {
        try {
          if (value.trim()) {
            this.form.output.smEndpoints = JSON.parse(value);
          } else {
            this.form.output.smEndpoints = [];
          }
          this.smEndpointsJsonError = null;
        } catch (error) {
          this.smEndpointsJsonError = "Invalid JSON format";
          console.error("Failed to parse smEndpoints JSON:", error);
        }
      },
    },
  },
  watch: {
    // Watch for changes in inline editing location array and sync with location string
    'editedItem.locationArray': {
      handler(newArray) {
        if (newArray && Array.isArray(newArray) && this.editedItem) {
          this.editedItem.location = newArray.join(',');
        }
      },
      deep: true,
    },
    // Watch for changes in form location array and sync with location string
    'form.input.locationArray': {
      handler(newArray) {
        if (newArray && Array.isArray(newArray)) {
          this.form.input.location = newArray.join(',');
        }
      },
      deep: true,
    },
    editedItem: {
      handler(newValue, oldValue) {
        // Prevent infinite loop by only processing when the item actually changes
        if (!newValue || newValue === oldValue || newValue._smEndpointsProcessed) {
          return;
        }

        // Initialize smEndpoints properly when an item is loaded for editing
        if (newValue.outputType === "ROUTE") {
          // Mark as processed to prevent re-processing
          this.$set(newValue, "_smEndpointsProcessed", true);

          // Initialize JSON edit mode properties
          this.$set(newValue, "_showJsonEdit", false);

          if (newValue.smEndpoints) {
            if (typeof newValue.smEndpoints === "string") {
              try {
                const parsed = JSON.parse(newValue.smEndpoints);
                if (Array.isArray(parsed)) {
                  // Set up smEndpoints array for form interface and add validation structure
                  const endpointsWithValidation = parsed.map((endpoint) => ({
                    ...endpoint,
                    _validationErrors: {},
                  }));
                  this.$set(newValue, "smEndpoints", endpointsWithValidation);
                  this.$set(newValue, "_jsonEditValue", JSON.stringify(parsed, null, 2));
                } else {
                  // Invalid data, initialize empty
                  this.$set(newValue, "smEndpoints", []);
                  this.$set(newValue, "_jsonEditValue", "[]");
                }
              } catch (error) {
                console.warn("Failed to parse smEndpoints JSON, initializing empty array:", error);
                // Initialize empty array for malformed JSON
                this.$set(newValue, "smEndpoints", []);
                this.$set(newValue, "_jsonEditValue", "[]");
              }
            } else if (Array.isArray(newValue.smEndpoints)) {
              // Already an array, just add validation structure
              const endpointsWithValidation = newValue.smEndpoints.map((endpoint) => ({
                ...endpoint,
                _validationErrors: endpoint._validationErrors || {},
              }));
              this.$set(newValue, "smEndpoints", endpointsWithValidation);
              this.$set(
                newValue,
                "_jsonEditValue",
                JSON.stringify(
                  endpointsWithValidation.map((e) => {
                    const { _validationErrors, ...clean } = e;
                    return clean;
                  }),
                  null,
                  2
                )
              );
            }
          } else {
            // No existing smEndpoints, initialize empty
            this.$set(newValue, "smEndpoints", []);
            this.$set(newValue, "_jsonEditValue", "[]");
          }
        }
      },
      deep: false, // Changed to false to prevent deep watching that can cause loops
      immediate: true,
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions({
      listInputs: "permissions/listInputs",
      listOutputs: "permissions/listOutputs",
      listMultiviewers: "permissions/listMultiviewers",
      listClients: "permissions/listClients",
      listClaims: "permissions/listClaims",
      listRouters: "permissions/listRouters",
      listRouterGroups: "permissions/listRouterGroups",
      listRouterDestinations: "permissions/listRouterDestinations",
      listRouterSources: "permissions/listRouterSources",
      listOutputProfiles: "permissions/listOutputProfiles",
      listTranscoderProfiles: "permissions/listTranscoderProfiles",
      listTranscodingProfiles: "permissions/listTranscodingProfiles",
      listTranscodingOutputs: "permissions/listTranscodingOutputs",
      listLocationss: "permissions/listLocationss",
      addLocation: "permissions/addLocation",
      removeLocation: "permissions/removeLocation",

      listInputProfiles: "permissions/listInputProfiles",
      createInputProfile: "permissions/createInputProfile",
      updateInputProfile: "permissions/updateInputProfile",
      deleteInputProfile: "permissions/deleteInputProfile",
      createInputProfileInputMap: "permissions/createInputProfileInputMap",
      deleteInputProfileInputMap: "permissions/deleteInputProfileInputMap",

      listProviders: "permissions/listProviders",
      createProvider: "permissions/createProvider",
      updateProvider: "permissions/updateProvider",
      deleteProvider: "permissions/deleteProvider",

      updateInput: "permissions/updateInput",
      getOutput: "permissions/getOutput",
      updateOutput: "permissions/updateOutput",
      updateMultiviewer: "permissions/updateMultiviewer",
      updateOutputProfile: "permissions/updateOutputProfile",
      updateRouter: "permissions/updateRouter",
      updateRouterGroup: "permissions/updateRouterGroup",
      updateRouterSource: "permissions/updateRouterSource",
      updateRouterDestination: "permissions/updateRouterDestination",
      updateTranscoderProfile: "permissions/updateTranscoderProfile",
      updateTranscodingProfile: "permissions/updateTranscodingProfile",
      updateTranscodingOutput: "permissions/updateTranscodingOutput",

      deleteInput: "permissions/deleteInput",
      deleteOutput: "permissions/deleteOutput",
      deleteMultiviewer: "permissions/deleteMultiviewer",
      deleteOutputProfile: "permissions/deleteOutputProfile",
      deleteRouter: "permissions/deleteRouter",
      deleteRouterGroup: "permissions/deleteRouterGroup",
      deleteRouterSource: "permissions/deleteRouterSource",
      deleteRouterDestination: "permissions/deleteRouterDestination",
      deleteTranscoderProfile: "permissions/deleteTranscoderProfile",
      deleteTranscodingProfile: "permissions/deleteTranscodingProfile",
      deleteTranscodingOutput: "permissions/deleteTranscodingOutput",

      createInput: "permissions/createInput",
      createOutput: "permissions/createOutput",
      createMultiviewer: "permissions/createMultiviewer",
      createOutputProfile: "permissions/createOutputProfile",
      createRouter: "permissions/createRouter",
      createRouterGroup: "permissions/createRouterGroup",
      createRouterDestination: "permissions/createRouterDestination",
      createRouterSource: "permissions/createRouterSource",
      createTranscoderProfile: "permissions/createTranscoderProfile",
      createTranscodingProfile: "permissions/createTranscodingProfile",
      createTranscodingOutput: "permissions/createTranscodingOutput",

      // MAP: Output profile <- output
      createOutputProfileOutputMap: "permissions/createOutputProfileOutputMap",
      deleteOutputProfileOutputMap: "permissions/deleteOutputProfileOutputMap",

      // MAP: Account -> input/output
      createOutputAccountMap: "permissions/createOutputAccountMap",
      createInputAccountMap: "permissions/createInputAccountMap",

      // MAP: router group -> source/destination
      createRouterDestinationGroupMap: "permissions/createRouterDestinationGroupMap",
      createRouterSourceGroupMap: "permissions/createRouterSourceGroupMap",
      deleteRouterDestinationGroupMap: "permissions/deleteRouterDestinationGroupMap",
      deleteRouterSourceGroupMap: "permissions/deleteRouterSourceGroupMap",

      // MAP: input/output -> source/destination
      createInputRouterSourceMap: "permissions/createInputRouterSourceMap",
      createOutputRouterDestinationMap: "permissions/createOutputRouterDestinationMap",
      deleteInputRouterSourceMap: "permissions/deleteInputRouterSourceMap",
      deleteOutputRouterDestinationMap: "permissions/deleteOutputRouterDestinationMap",

      // MAP : delete others
      deleteEventOutputMap: "permissions/deleteEventOutputMap",
      deleteOutputEquipmentMap: "permissions/deleteOutputEquipmentMap",
      deleteOutputAccountMap: "permissions/deleteOutputAccountMap",
      deleteInputAccountMap: "permissions/deleteInputAccountMap",

      // Stream Sources/Destinations
      listStreamSources: "stream/listStreamSources",
      listStreamDestinations: "stream/listStreamDestinations",
      createStreamDestination: "stream/createStreamDestination",
      createStreamSource: "stream/createStreamSource",
      deleteStreamDestination: "stream/deleteStreamDestination",
      deleteStreamSource: "stream/deleteStreamSource",
      updateStreamDestination: "stream/updateStreamDestination",
      updateStreamSource: "stream/updateStreamSource",

      // MAP: Stream Source -> Multiviewer
      createStreamSourceMultiviewerMap: "permissions/createStreamSourceMultiviewerMap",
      deleteStreamSourceMultiviewerMap: "permissions/deleteStreamSourceMultiviewerMap",
      updateStreamSourceMultiviewerMap: "permissions/updateStreamSourceMultiviewerMap",

      // Stream Router Interface Actions
      listStreamRouterInterfacesConnections: "stream/listStreamRouterInterfacesConnections",
      getStreamRouterInterfaceConnections: "stream/getStreamRouterInterfaceConnections",
      listStreamRouterInterfaces: "stream/listStreamRouterInterfaces",
      getStreamRouterInterface: "stream/getStreamRouterInterface",
      getStreamRouterInterfaceStatus: "stream/getStreamRouterInterfaceStatus",
      createStreamRouterInterface: "stream/createStreamRouterInterface",
      updateStreamRouterInterface: "stream/updateStreamRouterInterface",
      deleteStreamRouterInterface: "stream/deleteStreamRouterInterface",

      // Wowza Actions
      listWowzaApplications: "stream/listWowzaApplications",
      getWowzaApplication: "stream/getWowzaApplication",
      listWowzaAppTargets: "stream/listWowzaAppTargets",
      getWowzaAppTarget: "stream/getWowzaAppTarget",
      createExternalWowzaTarget: "stream/createExternalWowzaTarget",
      updateExternalWowzaTarget: "stream/updateExternalWowzaTarget",
      deleteExternalWowzaTarget: "stream/deleteExternalWowzaTarget",

      // Stream Router actions
      createStreamRouterInterface: 'streamingManager/createStreamRouterInterface',
      deleteStreamRouterInterface: 'streamingManager/deleteStreamRouterInterface',
      listStreamRouters: 'streamingManager/loadStreamRouters',

      // Wowza actions
      loadWowzaServers: 'streamingManager/loadWowzaServers',
      loadWowzaApplications: 'streamingManager/loadWowzaApplications',
      loadWowzaTargetsAndTemplates: 'streamingManager/loadWowzaTargetsAndTemplates',
      createExternalWowzaTarget: 'streamingManager/createExternalWowzaTarget',
      updateExternalWowzaTarget: 'streamingManager/updateExternalWowzaTarget',
      loadMediaConnectNetworkInterfaces: 'streamingManager/loadMediaConnectNetworkInterfaces',
      loadMediaConnectOutputs: 'streamingManager/loadMediaConnectOutputs',
      getMediaConnectOutputById: 'streamingManager/getMediaConnectOutputById',
      createMediaConnectInputInStore: 'streamingManager/createMediaConnectInput',
      createMediaConnectOutputInStore: 'streamingManager/createMediaConnectOutput',
      updateMediaConnectOutputInStore: 'streamingManager/updateMediaConnectOutput',

    }),
    usesPermissionModal(type = this.listType) {
      return supportsPermissionModalType(type);
    },
    createEmptyInputState() {
      return {
        streamFileBaseName: null,
        type: null,
        inputDownlinkConfigId: null,
        url: null,
        frcAvailable: null,
        requireDetails: null,
        probeProjectId: null,
        probeTaskId: null,
        createInterface: false,
        streamRouterId: null,
        interfaceName: null,
        source: {
          url: null,
          type: "SRT",
          max_connections: null,
          latency: null,
          ttl: null,
          passphrase: null,
          stream_id: null,
          max_bw: null,
        },
        destination: {
          url: null,
          type: "SRT",
          max_connections: null,
          latency: null,
          ttl: null,
          passphrase: null,
          stream_id: null,
          max_bw: null,
        },
        processors: [],
        tags: [],
        whitelist: [],
        autostart: false,
        location: null,
        locationArray: [],
        mcInputName: null,
        mcInputBitrate: null,
        mcInputRoutingScope: "REGIONAL",
        mcInputTier: "INPUT_50",
        mcInputNetworkInterfaceArn: null,
        mcInputProtocol: null,
        mcInputPort: null,
        mcInputLatency: null,
        mcInputSourceAddress: null,
        mcInputSourcePort: null,
        mcInputRecoveryLatency: null,
      };
    },
    createBasePermissionDraft(item = {}) {
      return {
        id: item.id || "",
        version: item.version || item.expectedVersion || null,
        name: item.name || "",
        description: item.description || "",
        claimsCanAccess: buildClaimSelections(item.claimsCanAccess || []),
        claimsCanEdit: buildClaimSelections(item.claimsCanEdit || []),
      };
    },
    createPermissionModalDraft(entityType, item = null) {
      const base = this.createBasePermissionDraft(item || {});

      if (entityType === "input") {
        return {
          ...base,
          accountIds: [],
          input: {
            ...this.createEmptyInputState(),
            streamFileBaseName: item?.streamFileBaseName || null,
            type: item?.type || null,
            inputDownlinkConfigId: item?.inputDownlinkConfigId || null,
            url: item?.url || null,
            frcAvailable: item?.frcAvailable ?? null,
            requireDetails: item?.requireDetails ?? null,
            probeProjectId: item?.probeProjectId || null,
            probeTaskId: item?.probeTaskId || null,
            location: item?.location || null,
            locationArray: normalizeLocationArray(item?.location),
          },
        };
      }

      if (entityType === "output") {
        const normalizedOutput = item ? this.normalizeOutputForEdit(cloneDeep(item)) : createDefaultOutputForm();
        return {
          ...base,
          accountIds: [],
          output: {
            ...createDefaultOutputForm(),
            ...cloneDeep(normalizedOutput),
          },
        };
      }

      if (entityType === "outputProfile") {
        return {
          ...base,
          outputIds: item?.outputs ? item.outputs.map((output) => output.id) : [],
          outputMapping: item?.outputMapping ? cloneDeep(item.outputMapping) : [],
          originalOutputs: item?.originalOutputs ? [...item.originalOutputs] : [],
        };
      }

      if (entityType === "inputProfile") {
        return {
          ...base,
          inputProfile: {
            config: typeof item?.config === "string"
              ? item.config
              : JSON.stringify(item?.config || JSON.parse(createDefaultInputProfileConfig())),
            location: item?.location || null,
            supportedTypes: item?.supportedTypes ? [...item.supportedTypes] : [],
            inputProfileProviderId: item?.inputProfileProviderId || null,
            inputIds: item?.inputs ? item.inputs.map((input) => input.id) : [],
          },
          inputMapping: item?.inputMapping ? cloneDeep(item.inputMapping) : [],
          originalInputs: item?.originalInputs ? [...item.originalInputs] : [],
        };
      }

      if (entityType === "provider") {
        return {
          ...base,
          provider: {
            contactDetails: item?.contactDetails || null,
            instructions: item?.instructions || null,
          },
        };
      }

      if (entityType === "location") {
        return {
          ...base,
          location: {
            code: item?.code || "",
            type: item?.type || "DEFAULT",
          },
        };
      }

      if (entityType === "transcodingProfile" || entityType === "transcodingOutput") {
        const defaultConfig = entityType === "transcodingProfile"
          ? createDefaultTranscodingProfileConfig()
          : createDefaultTranscodingOutputConfig();
        return {
          ...base,
          transcoding: {
            type: item?.type || "MEDIA_LIVE",
            config: typeof item?.config === "string"
              ? item.config
              : JSON.stringify(item?.config || JSON.parse(defaultConfig)),
          },
        };
      }

      return base;
    },
    openPermissionModal(mode, entityType, item = null) {
      this.permissionModalMode = mode;
      this.permissionModalEntityType = entityType;
      this.permissionModalErrors = {};
      this.transcodingOutputValid = true;
      this.transcodingOutputErrors = [];
      this.permissionModalDraft = this.createPermissionModalDraft(entityType, item);
      this.permissionModalVisible = true;

      if (entityType === "input") {
        this.ensureMediaConnectInterfacesLoaded();
      }

      if (entityType === "output") {
        this.ensureMediaConnectInterfacesLoaded();
        if (this.permissionModalDraft.output.outputType === "MEDIA_CONNECT") {
          this.ensureMediaConnectOutputsLoaded();
        }
        if (this.permissionModalDraft.output.outputType === "ROUTE" && this.permissionModalDraft.output.streamRouterId) {
          this.handleModalStreamRouterChange(this.permissionModalDraft.output.streamRouterId, {
            preserveInterface: true,
            skipEmit: true,
          });
        }
        if (
          this.permissionModalDraft.output.outputType === "OTT" &&
          this.permissionModalDraft.output.wowzaServerId &&
          this.permissionModalDraft.output.wowzaApplicationId
        ) {
          this.handleModalWowzaServerChange(this.permissionModalDraft.output.wowzaServerId, {
            preserveApplication: true,
            skipEmit: true,
          }).then(() => {
            this.handleModalWowzaApplicationChange(this.permissionModalDraft.output.wowzaApplicationId, {
              skipEmit: true,
            });
          });
        }
      }
    },
    closePermissionModal() {
      this.permissionModalVisible = false;
      this.permissionModalErrors = {};
      this.permissionModalLoading = false;
      this.transcodingOutputValid = true;
      this.transcodingOutputErrors = [];
      this.permissionModalDraft = null;
      this.permissionModalEntityType = "";
      this.permissionModalMode = "create";
    },
    async ensureMediaConnectInterfacesLoaded() {
      if (this.mediaConnectNetworkInterfaces.length > 0) return;
      await this.fetchMediaConnectInterfaces();
    },
    async ensureMediaConnectOutputsLoaded() {
      if (this.mediaConnectOutputs.length > 0) return;
      await this.fetchMediaConnectOutputs();
    },
    safeJsonParse(value, fallback = null) {
      if (!value || typeof value !== "string") return fallback;
      try {
        return JSON.parse(value);
      } catch (error) {
        return fallback;
      }
    },

    getSamplePresetOptions(entityType = this.formType) {
      if (entityType === "input") {
        return [
          { command: "input:ROUTE", label: "Sample Input: ROUTE" },
          { command: "input:TECHEX", label: "Sample Input: TECHEX" },
          { command: "input:MEDIA_CONNECT", label: "Sample Input: MEDIA_CONNECT" },
        ];
      }

      if (entityType === "output") {
        return [
          { command: "output:OTT", label: "Sample Output: OTT" },
          { command: "output:ROUTE", label: "Sample Output: ROUTE" },
          { command: "output:TECHEX", label: "Sample Output: TECHEX" },
          { command: "output:MEDIA_CONNECT", label: "Sample Output: MEDIA_CONNECT" },
        ];
      }

      if (entityType === "transcodingProfile") {
        return [{ command: "transcodingProfile:MEDIA_LIVE", label: "Sample Transcoding Channel: MediaLive" }];
      }

      if (entityType === "transcodingOutput") {
        return [{ command: "transcodingOutput:MEDIA_LIVE", label: "Sample Transcoding Output: MediaLive" }];
      }

      return [];
    },

    randomNumber(min = 1000, max = 9999) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    randomToken(prefix = "sample") {
      return `${prefix}-${Date.now()}-${this.randomNumber(100, 999)}`;
    },

    randomIpAddress() {
      return [
        this.randomNumber(10, 210),
        this.randomNumber(0, 255),
        this.randomNumber(0, 255),
        this.randomNumber(1, 254),
      ].join(".");
    },

    randomPort(min = 10000, max = 60000) {
      return this.randomNumber(min, max);
    },

    randomUuidLike() {
      const segment = (length) =>
        [...Array(length)].map(() => Math.floor(Math.random() * 16).toString(16)).join("");
      return `${segment(8)}-${segment(4)}-${segment(4)}-${segment(4)}-${segment(12)}`;
    },
    buildSampleTranscodingProfileConfig() {
      const config = this.safeJsonParse(createDefaultTranscodingProfileConfig(), {});
      if (Array.isArray(config.defaultDestinations) && config.defaultDestinations.length === 0) {
        delete config.defaultDestinations;
      }
      config.name = this.randomToken("medialive-channel");
      return JSON.stringify(config);
    },
    buildSampleTranscodingOutputConfig() {
      const config = this.safeJsonParse(createDefaultTranscodingOutputConfig(), {});
      if (!config.outputGroup || typeof config.outputGroup !== "object") {
        config.outputGroup = {};
      }
      const outputGroup = config.outputGroup;

      config.destinations = [
        {
          Id: "Destination-1",
          Settings: [
            { Url: "s3ssl://example-primary-bucket/live/channel" },
            { Url: "s3ssl://example-backup-bucket/live/channel" },
          ],
        },
      ];
      config.videoDescriptions = [
        {
          Name: "video_1080p30",
          Width: 1920,
          Height: 1080,
          codecType: "H264Settings",
        },
      ];
      config.audioDescriptions = [
        {
          Name: "audio_eng",
          AudioSelectorName: "Audio Selector 1",
          codecType: "AacSettings",
        },
      ];

      outputGroup.type = "HLS";
      if (!outputGroup.outputGroupSettings) outputGroup.outputGroupSettings = {};
      if (!outputGroup.outputGroupSettings.HlsGroupSettings) outputGroup.outputGroupSettings.HlsGroupSettings = {};
      if (!outputGroup.outputGroupSettings.HlsGroupSettings.Destination) {
        outputGroup.outputGroupSettings.HlsGroupSettings.Destination = {};
      }
      outputGroup.outputGroupSettings.HlsGroupSettings.Destination.DestinationRefId = "Destination-1";

      if (!Array.isArray(outputGroup.outputs) || outputGroup.outputs.length === 0) {
        outputGroup.outputs = [
          {
            OutputName: "HD-HLS-Output",
            OutputSettings: {
              HlsOutputSettings: {
                HlsSettingsType: "StandardHlsSettings",
                H265PackagingType: "HVC1",
                NameModifier: "_1080p",
                HlsSettings: {
                  HlsSettingsChoice: "STANDARD_HLS",
                  StandardHlsSettings: {
                    AudioRenditionSets: "program_audio",
                    M3u8Settings: {
                      AudioPids: "492-498",
                      VideoPid: "481",
                    },
                  },
                },
              },
            },
          },
        ];
      }

      outputGroup.name = this.randomToken("output-group");
      outputGroup.outputs[0].OutputName = this.randomToken("output");
      outputGroup.outputs[0].VideoDescriptionName = "video_1080p30";
      outputGroup.outputs[0].AudioDescriptionNames = ["audio_eng"];
      if (!outputGroup.outputs[0].OutputSettings) outputGroup.outputs[0].OutputSettings = {};
      if (!outputGroup.outputs[0].OutputSettings.HlsOutputSettings) {
        outputGroup.outputs[0].OutputSettings.HlsOutputSettings = {};
      }
      outputGroup.outputs[0].OutputSettings.HlsOutputSettings.HlsSettingsType = "StandardHlsSettings";
      outputGroup.outputs[0].OutputSettings.HlsOutputSettings.NameModifier = "_1080p";

      // Keep backend payload in canonical format.
      delete config.name;
      delete config.type;
      delete config.outputGroupSettings;
      delete config.outputs;

      return JSON.stringify(config);
    },

    getDefaultSampleClaimSelections() {
      const preferredClaimPath = this.claimsTree
        .flatMap((entry) => [entry, ...(entry.children || [])])
        .find((entry) => entry.value === "usr.ct");

      if (preferredClaimPath) {
        return {
          access: [["usr.ct"]],
          edit: [["usr.ct"]],
        };
      }

      return {
        access: [],
        edit: [],
      };
    },

    getDefaultSampleAccounts() {
      const preferredAccount = (this.accounts || []).find(
        (account) => account?.name === "CloudTree" && account?.client?.name === "CloudTree"
      );

      if (preferredAccount) {
        return [preferredAccount];
      }

      return this.accounts && this.accounts.length > 0 ? [this.accounts[0]] : [];
    },
    getDefaultSampleAccountIds() {
      return this.getDefaultSampleAccounts().map((account) => account.id);
    },

    applyBaseSampleFormData(prefix) {
      const claimSelections = this.getDefaultSampleClaimSelections();
      this.form.name = `[TEST] ${this.randomToken(prefix)}`;
      this.form.description = `Autofilled ${prefix} sample data`;
      this.form.id = "";
      this.form.accounts = this.getDefaultSampleAccounts();
      this.form.claimsCanAccess = claimSelections.access;
      this.form.claimsCanEdit = claimSelections.edit;
    },
    createBaseSamplePermissionDraft(entityType, prefix) {
      const claimSelections = this.getDefaultSampleClaimSelections();
      return {
        ...this.createPermissionModalDraft(entityType),
        name: `[TEST] ${this.randomToken(prefix)}`,
        description: `Autofilled ${prefix} sample data`,
        id: "",
        claimsCanAccess: claimSelections.access,
        claimsCanEdit: claimSelections.edit,
        ...(entityType === "outputProfile" ? {} : { accountIds: this.getDefaultSampleAccountIds() }),
      };
    },

    async applySamplePreset(command) {
      if (!command) return;

      const [entityType, sampleType] = command.split(":");
      if (
        this.permissionModalVisible &&
        this.permissionModalDraft &&
        entityType === this.permissionModalEntityType
      ) {
        this.permissionModalErrors = {};
        if (entityType === "input") {
          await this.populateSampleInputDraft(sampleType);
          return;
        }

        if (entityType === "output") {
          await this.populateSampleOutputDraft(sampleType);
          return;
        }

        if (entityType === "transcodingProfile") {
          this.populateSampleTranscodingProfileDraft(sampleType);
          return;
        }

        if (entityType === "transcodingOutput") {
          this.populateSampleTranscodingOutputDraft(sampleType);
          return;
        }
      }

      if (entityType === "input") {
        await this.populateSampleInput(sampleType);
        return;
      }

      if (entityType === "output") {
        await this.populateSampleOutput(sampleType);
        return;
      }

      if (entityType === "transcodingProfile") {
        this.populateSampleTranscodingProfile(sampleType);
        return;
      }

      if (entityType === "transcodingOutput") {
        this.populateSampleTranscodingOutput(sampleType);
      }
    },
    populateSampleTranscodingProfile(sampleType = "MEDIA_LIVE") {
      this.applyBaseSampleFormData(`transcoding-profile-${String(sampleType || "").toLowerCase()}`);
      this.form.transcoding = {
        ...this.form.transcoding,
        type: "MEDIA_LIVE",
        config: this.buildSampleTranscodingProfileConfig(),
      };
    },
    populateSampleTranscodingOutput(sampleType = "MEDIA_LIVE") {
      this.applyBaseSampleFormData(`transcoding-output-${String(sampleType || "").toLowerCase()}`);
      this.transcodingOutputValid = true;
      this.transcodingOutputErrors = [];
      this.form.transcoding = {
        ...this.form.transcoding,
        type: "MEDIA_LIVE",
        config: this.buildSampleTranscodingOutputConfig(),
      };
    },
    populateSampleTranscodingProfileDraft(sampleType = "MEDIA_LIVE") {
      const draft = this.createBaseSamplePermissionDraft(
        "transcodingProfile",
        `transcoding-profile-${String(sampleType || "").toLowerCase()}`
      );
      draft.transcoding = {
        ...(draft.transcoding || {}),
        type: "MEDIA_LIVE",
        config: this.buildSampleTranscodingProfileConfig(),
      };
      this.permissionModalDraft = draft;
    },
    populateSampleTranscodingOutputDraft(sampleType = "MEDIA_LIVE") {
      const draft = this.createBaseSamplePermissionDraft(
        "transcodingOutput",
        `transcoding-output-${String(sampleType || "").toLowerCase()}`
      );
      this.transcodingOutputValid = true;
      this.transcodingOutputErrors = [];
      draft.transcoding = {
        ...(draft.transcoding || {}),
        type: "MEDIA_LIVE",
        config: this.buildSampleTranscodingOutputConfig(),
      };
      this.permissionModalDraft = draft;
    },

    async populateSampleInput(inputType) {
      this.applyBaseSampleFormData(`input-${String(inputType || "").toLowerCase()}`);
      const defaultLocation = this.locations?.[0]?.code || null;
      const defaultRouter = this.availableStreamRouters[0]?.id || this.streamRouters?.[0]?.id || null;
      const defaultInterfaceArn = this.mediaConnectNetworkInterfaces?.[0]?.networkInterfaceArn || null;
      const port = this.randomPort();
      const sourcePort = this.randomPort();

      this.form.input = {
        ...this.form.input,
        type: inputType,
        streamFileBaseName: this.randomToken("stream"),
        inputDownlinkConfigId: this.randomToken("dl"),
        frcAvailable: true,
        requireDetails: false,
        locationArray: defaultLocation ? [defaultLocation] : [],
        location: defaultLocation,
        url: `srt://${this.randomIpAddress()}:${port}?streamid=${this.randomToken("input")}`,
        createInterface: inputType === "ROUTE",
        streamRouterId: inputType === "ROUTE" ? defaultRouter : null,
        interfaceName: inputType === "ROUTE" ? this.randomToken("if") : null,
        source: {
          ...this.form.input.source,
          type: "SRT",
          url: `srt://${this.randomIpAddress()}:${sourcePort}?mode=listener`,
          latency: 2000,
          max_connections: 1,
        },
        destination: {
          ...this.form.input.destination,
          type: "SRT",
          url: `srt://${this.randomIpAddress()}:${port}?mode=caller`,
          latency: 2000,
          max_connections: 1,
        },
        tags: inputType === "ROUTE" ? [this.randomToken("tag")] : [],
        autostart: inputType === "ROUTE",
        mcInputName: this.randomToken("mc-input"),
        mcInputBitrate: 20000000,
        mcInputRoutingScope: "REGIONAL",
        mcInputTier: "INPUT_50",
        mcInputNetworkInterfaceArn: defaultInterfaceArn,
        mcInputProtocol: "SRT_LISTENER",
        mcInputPort: port,
        mcInputLatency: 2000,
        mcInputSourceAddress: this.randomIpAddress(),
        mcInputSourcePort: sourcePort,
        mcInputRecoveryLatency: 1000,
      };

      if (inputType === "TECHEX") {
        this.form.input.url = `udp://${this.randomIpAddress()}:${port}`;
        this.form.input.createInterface = false;
      }
    },
    async populateSampleInputDraft(inputType) {
      if (inputType === "MEDIA_CONNECT") {
        await this.ensureMediaConnectInterfacesLoaded();
      }

      const defaultLocation = this.locations?.[0]?.code || null;
      const defaultRouter = this.availableStreamRouters[0]?.id || this.streamRouters?.[0]?.id || null;
      const defaultInterfaceArn = this.mediaConnectNetworkInterfaces?.[0]?.networkInterfaceArn || null;
      const port = this.randomPort();
      const sourcePort = this.randomPort();
      const draft = this.createBaseSamplePermissionDraft("input", `input-${String(inputType || "").toLowerCase()}`);

      draft.input = {
        ...draft.input,
        type: inputType,
        streamFileBaseName: this.randomToken("stream"),
        inputDownlinkConfigId: this.randomToken("dl"),
        frcAvailable: true,
        requireDetails: false,
        locationArray: defaultLocation ? [defaultLocation] : [],
        location: defaultLocation,
        url: `srt://${this.randomIpAddress()}:${port}?streamid=${this.randomToken("input")}`,
        createInterface: inputType === "ROUTE",
        streamRouterId: inputType === "ROUTE" ? defaultRouter : null,
        interfaceName: inputType === "ROUTE" ? this.randomToken("if") : null,
        source: {
          ...draft.input.source,
          type: "SRT",
          url: `srt://${this.randomIpAddress()}:${sourcePort}?mode=listener`,
          latency: 2000,
          max_connections: 1,
        },
        destination: {
          ...draft.input.destination,
          type: "SRT",
          url: `srt://${this.randomIpAddress()}:${port}?mode=caller`,
          latency: 2000,
          max_connections: 1,
        },
        tags: inputType === "ROUTE" ? [this.randomToken("tag")] : [],
        autostart: inputType === "ROUTE",
        mcInputName: this.randomToken("mc-input"),
        mcInputBitrate: 20000000,
        mcInputRoutingScope: "REGIONAL",
        mcInputTier: "INPUT_50",
        mcInputNetworkInterfaceArn: defaultInterfaceArn,
        mcInputProtocol: "SRT_LISTENER",
        mcInputPort: port,
        mcInputLatency: 2000,
        mcInputSourceAddress: this.randomIpAddress(),
        mcInputSourcePort: sourcePort,
        mcInputRecoveryLatency: 1000,
      };

      if (inputType === "TECHEX") {
        draft.input.url = `udp://${this.randomIpAddress()}:${port}`;
        draft.input.createInterface = false;
      }

      this.permissionModalDraft = draft;
    },

    async populateSampleOutput(outputType) {
      this.applyBaseSampleFormData(`output-${String(outputType || "").toLowerCase()}`);
      const defaultRouter = this.availableStreamRouters[0]?.id || null;
      const defaultLocation = this.getPreferredOutputLocation(outputType, null, {
        preserveLegacy: false,
      });
      const defaultInterfaceArn = this.mediaConnectNetworkInterfaces?.[0]?.networkInterfaceArn || null;
      const outputPort = this.randomPort();

      this.form.output = {
        ...createDefaultOutputForm(),
        outputType,
        status: "ONLINE",
        displayName: this.randomToken("display"),
        allowExternalConfigUpdate: false,
        location: defaultLocation,
        url: ["ROUTE", "TECHEX"].includes(outputType)
          ? `srt://${this.randomIpAddress()}:${outputPort}?streamid=${this.randomToken("output")}`
          : null,
        ottPlatform: outputType === "OTT" ? "RTMP" : null,
        wowzaServerId: outputType === "OTT" ? this.availableWowzaServers[0]?.id || null : null,
        ottServer: outputType === "OTT" ? this.availableWowzaServers[0]?.id || null : null,
        ottNoStremKeyRequired: outputType === "OTT",
        ottDefaultTranscoderProfile: null,
        streamRouterId: outputType === "ROUTE" ? defaultRouter : null,
        interfaceId: null,
        interfaceName: null,
        interfaceDescription: "",
        smEndpoints: outputType === "ROUTE" ? [] : [],
        techexOutputId: outputType === "TECHEX" ? this.randomToken("tx-out") : null,
        techexEdgeId: outputType === "TECHEX" ? this.randomToken("tx-edge") : null,
        techexBlankStreamId: outputType === "TECHEX" ? this.randomToken("tx-blank") : null,
        routingScope: outputType === "MEDIA_CONNECT" ? "REGIONAL" : "REGIONAL",
        routerOutputArn: outputType === "MEDIA_CONNECT"
          ? `arn:aws:mediaconnect:eu-west-1:123456789012:output:${this.randomToken("router-output")}`
          : null,
        mcOutputName: outputType === "MEDIA_CONNECT" ? this.randomToken("mc-output") : null,
        mcOutputBitrate: outputType === "MEDIA_CONNECT" ? 20000000 : null,
        mcOutputTier: outputType === "MEDIA_CONNECT" ? "OUTPUT_50" : "OUTPUT_50",
        mcOutputNetworkInterfaceArn: outputType === "MEDIA_CONNECT" ? defaultInterfaceArn : null,
        mcOutputProtocol: outputType === "MEDIA_CONNECT" ? "SRT_CALLER" : null,
        mcOutputDestinationAddress: outputType === "MEDIA_CONNECT" ? this.randomIpAddress() : null,
        mcOutputDestinationPort: outputType === "MEDIA_CONNECT" ? outputPort : null,
        mcOutputLatency: outputType === "MEDIA_CONNECT" ? 2000 : null,
      };

      if (outputType === "OTT" && this.form.output.wowzaServerId) {
        try {
          await this.loadWowzaApplications(this.form.output.wowzaServerId);
          const defaultApp = this.wowzaApplicationsFromStore?.[0] || null;
          this.form.output.wowzaApplicationId = defaultApp?.id || null;
          this.form.output.ottApplication = defaultApp?.id || defaultApp?.name || null;
          if (defaultApp?.id) {
            await this.loadWowzaTargetsAndTemplates({
              serverId: this.form.output.wowzaServerId,
              applicationId: defaultApp.id,
            });
            this.form.output.ottDefaultTranscoderProfile =
              this.transcoderTemplatesFromStore?.[0]?.id || null;
          }
        } catch (error) {
          console.error("Failed to load sample Wowza data", error);
        }
      }

      if (outputType === "ROUTE" && defaultRouter) {
        try {
          this.streamRouterInterfaces = await this.loadStreamRouterInterfacesForTarget(defaultRouter);
          const sampleInterface = this.streamRouterInterfaces[0] || null;
          if (sampleInterface) {
            this.form.output.interfaceId = sampleInterface.id;
            await this.onInterfaceChange();
          } else {
            this.form.output.interfaceId = this.randomUuidLike();
            this.form.output.interfaceName = this.randomToken("interface");
            this.form.output.interfaceDescription = "Autofilled route interface";
            this.form.output.smEndpoints = this.sanitizeRouteEndpoints([], {
              interfaceId: this.form.output.interfaceId,
              interfaceName: this.form.output.interfaceName,
              streamManagerId: defaultRouter,
              interfaceDescription: this.form.output.interfaceDescription,
            }).map((endpoint) => ({
              ...endpoint,
              _validationErrors: [],
            }));
          }
        } catch (error) {
          console.error("Failed to load sample route interfaces", error);
        }
      }
    },
    async populateSampleOutputDraft(outputType) {
      if (outputType === "MEDIA_CONNECT") {
        await Promise.all([
          this.ensureMediaConnectInterfacesLoaded(),
          this.ensureMediaConnectOutputsLoaded(),
        ]);
      }

      const defaultRouter = this.availableStreamRouters[0]?.id || null;
      const defaultLocation = this.getPreferredOutputLocation(outputType, null, {
        preserveLegacy: false,
      });
      const defaultInterfaceArn = this.mediaConnectNetworkInterfaces?.[0]?.networkInterfaceArn || null;
      const outputPort = this.randomPort();
      const draft = this.createBaseSamplePermissionDraft("output", `output-${String(outputType || "").toLowerCase()}`);

      draft.output = {
        ...createDefaultOutputForm(),
        outputType,
        status: "ONLINE",
        displayName: this.randomToken("display"),
        allowExternalConfigUpdate: false,
        location: defaultLocation,
        url: ["ROUTE", "TECHEX"].includes(outputType)
          ? `srt://${this.randomIpAddress()}:${outputPort}?streamid=${this.randomToken("output")}`
          : null,
        ottPlatform: outputType === "OTT" ? "RTMP" : null,
        wowzaServerId: outputType === "OTT" ? this.availableWowzaServers[0]?.id || null : null,
        ottServer: outputType === "OTT" ? this.availableWowzaServers[0]?.id || null : null,
        ottNoStremKeyRequired: outputType === "OTT",
        ottDefaultTranscoderProfile: null,
        streamRouterId: outputType === "ROUTE" ? defaultRouter : null,
        interfaceId: null,
        interfaceName: null,
        interfaceDescription: "",
        smEndpoints: [],
        techexOutputId: outputType === "TECHEX" ? this.randomToken("tx-out") : null,
        techexEdgeId: outputType === "TECHEX" ? this.randomToken("tx-edge") : null,
        techexBlankStreamId: outputType === "TECHEX" ? this.randomToken("tx-blank") : null,
        routingScope: "REGIONAL",
        routerOutputArn: outputType === "MEDIA_CONNECT"
          ? `arn:aws:mediaconnect:eu-west-1:123456789012:output:${this.randomToken("router-output")}`
          : null,
        mcOutputName: outputType === "MEDIA_CONNECT" ? this.randomToken("mc-output") : null,
        mcOutputBitrate: outputType === "MEDIA_CONNECT" ? 20000000 : null,
        mcOutputTier: "OUTPUT_50",
        mcOutputNetworkInterfaceArn: outputType === "MEDIA_CONNECT" ? defaultInterfaceArn : null,
        mcOutputProtocol: outputType === "MEDIA_CONNECT" ? "SRT_CALLER" : null,
        mcOutputDestinationAddress: outputType === "MEDIA_CONNECT" ? this.randomIpAddress() : null,
        mcOutputDestinationPort: outputType === "MEDIA_CONNECT" ? outputPort : null,
        mcOutputLatency: outputType === "MEDIA_CONNECT" ? 2000 : null,
      };

      if (outputType === "OTT" && draft.output.wowzaServerId) {
        try {
          await this.loadWowzaApplications(draft.output.wowzaServerId);
          const defaultApp = this.wowzaApplicationsFromStore?.[0] || null;
          draft.output.wowzaApplicationId = defaultApp?.id || null;
          draft.output.ottApplication = defaultApp?.id || defaultApp?.name || null;
          if (defaultApp?.id) {
            await this.loadWowzaTargetsAndTemplates({
              serverId: draft.output.wowzaServerId,
              applicationId: defaultApp.id,
            });
            draft.output.ottDefaultTranscoderProfile =
              this.transcoderTemplatesFromStore?.[0]?.id || null;
          }
        } catch (error) {
          console.error("Failed to load sample Wowza data", error);
        }
      }

      if (outputType === "ROUTE" && defaultRouter) {
        try {
          this.streamRouterInterfaces = await this.loadStreamRouterInterfacesForTarget(defaultRouter);
          const sampleInterface = this.streamRouterInterfaces[0] || null;
          if (sampleInterface) {
            const interfaceDetails = await this.loadRouteInterfaceDetails(defaultRouter, sampleInterface.id);
            draft.output.interfaceId = sampleInterface.id;
            draft.output.interfaceName = interfaceDetails.interfaceName;
            draft.output.interfaceDescription = interfaceDetails.interfaceDescription;
            draft.output.smEndpoints = this.sanitizeRouteEndpoints([], {
              interfaceId: sampleInterface.id,
              interfaceName: interfaceDetails.interfaceName,
              streamManagerId: interfaceDetails.streamManagerId,
              interfaceDescription: interfaceDetails.interfaceDescription,
            }).map((endpoint) => ({
              ...endpoint,
              _validationErrors: {},
            }));
            this.updateRouteConflictState(draft.output);
          } else {
            draft.output.interfaceId = this.randomUuidLike();
            draft.output.interfaceName = this.randomToken("interface");
            draft.output.interfaceDescription = "Autofilled route interface";
            draft.output.smEndpoints = this.sanitizeRouteEndpoints([], {
              interfaceId: draft.output.interfaceId,
              interfaceName: draft.output.interfaceName,
              streamManagerId: defaultRouter,
              interfaceDescription: draft.output.interfaceDescription,
            }).map((endpoint) => ({
              ...endpoint,
              _validationErrors: {},
            }));
          }
        } catch (error) {
          console.error("Failed to load sample route interfaces", error);
        }
      }

      this.permissionModalDraft = draft;
    },

    isSupportedOutputType(outputType) {
      return MOS_OUTPUT_TYPES.includes(outputType);
    },

    getOutputTypeOptions(currentType) {
      const options = [...this.outputTypes];
      if (currentType && !options.includes(currentType)) {
        options.push(currentType);
      }
      return options;
    },

    getOttPlatformOptions(currentPlatform) {
      const options = [...this.ottPlatformTypes];
      if (currentPlatform && !options.includes(currentPlatform)) {
        options.push(currentPlatform);
      }
      return options;
    },

    getAllowedLocationsByType(outputType) {
      if (outputType === "MEDIA_CONNECT") {
        return null;
      }
      return MOS_OUTPUT_LOCATIONS[outputType] || [];
    },

    getPreferredOutputLocation(outputType, currentLocation = null, { preserveLegacy = true } = {}) {
      const allowedLocations = this.getAllowedLocationsByType(outputType);
      if (!allowedLocations) {
        return currentLocation || null;
      }
      if (currentLocation && (allowedLocations.includes(currentLocation) || preserveLegacy)) {
        return currentLocation;
      }
      return allowedLocations[0] || currentLocation || null;
    },

    getOutputLocationOptions(outputType, currentLocation = null) {
      if (outputType === "MEDIA_CONNECT") {
        const regionCodes = new Set();
        this.mediaConnectNetworkInterfaces.forEach((item) => {
          if (item.regionName) regionCodes.add(item.regionName);
        });
        this.mediaConnectOutputs.forEach((item) => {
          if (item.RegionName) regionCodes.add(item.RegionName);
          if (item.AvailabilityZone) regionCodes.add(item.AvailabilityZone);
        });
        if (currentLocation) regionCodes.add(currentLocation);
        return [...regionCodes]
          .filter(Boolean)
          .sort()
          .map((code) => ({
            value: code,
            label: code,
            description: "AWS region",
          }));
      }

      const allowedLocations = this.getAllowedLocationsByType(outputType);
      if (!allowedLocations || allowedLocations.length === 0) {
        return [];
      }

      const codes = currentLocation && !allowedLocations.includes(currentLocation)
        ? [...allowedLocations, currentLocation]
        : allowedLocations;

      return codes.map((code) => {
        const matchedLocation = (this.locations || []).find((location) => location.code === code);
        return {
          value: code,
          label: matchedLocation ? matchedLocation.name : code,
          description: matchedLocation ? matchedLocation.description : "Legacy location",
        };
      });
    },

    normalizeRouteEndpoint(endpoint = {}, fallbackConfig = {}) {
      return {
        interfaceId: endpoint.interfaceId || fallbackConfig.interfaceId || "",
        interfaceName: endpoint.interfaceName || fallbackConfig.interfaceName || "",
        streamManagerId: endpoint.streamManagerId || fallbackConfig.streamManagerId || "",
        interfaceDescription:
          endpoint.interfaceDescription || fallbackConfig.interfaceDescription || "",
        type: "SR",
        _validationErrors: endpoint._validationErrors || {},
      };
    },

    sanitizeRouteEndpoints(smEndpoints, fallbackConfig = {}) {
      let endpoints = [];
      if (typeof smEndpoints === "string") {
        endpoints = this.safeJsonParse(smEndpoints, []);
      } else if (Array.isArray(smEndpoints)) {
        endpoints = smEndpoints;
      }

      if ((!Array.isArray(endpoints) || endpoints.length === 0) && fallbackConfig.interfaceId) {
        endpoints = [fallbackConfig];
      }

      return (Array.isArray(endpoints) ? endpoints : [])
        .map((endpoint) => this.normalizeRouteEndpoint(endpoint, fallbackConfig))
        .filter(
          (endpoint) => endpoint.interfaceId || endpoint.interfaceName || endpoint.streamManagerId
        );
    },

    serializeRouteEndpoints(smEndpoints, fallbackConfig = {}) {
      const endpoints = this.sanitizeRouteEndpoints(smEndpoints, fallbackConfig).map((endpoint) => {
        const { _validationErrors, ...cleanEndpoint } = endpoint;
        return {
          ...cleanEndpoint,
          type: "SR",
        };
      });
      return endpoints.length > 0 ? JSON.stringify(endpoints) : null;
    },

    buildOutputConfigByType(outputData) {
      switch (outputData.outputType) {
        case "ROUTE":
          return JSON.stringify({
            interfaceId: outputData.interfaceId || "",
            interfaceName: outputData.interfaceName || "",
            streamManagerId: outputData.streamRouterId || "",
            interfaceDescription: outputData.interfaceDescription || "",
            type: "SR",
          });
        case "OTT":
          return JSON.stringify({
            platform: outputData.ottPlatform || null,
            server: outputData.ottServer || null,
            application: outputData.ottApplication || null,
            target: outputData.name || null,
            noStreamKeyRequired: !!outputData.ottNoStremKeyRequired,
            defaultTranscoderProfile: outputData.ottDefaultTranscoderProfile || null,
          });
        case "TECHEX":
          return JSON.stringify({
            techexOutputId: outputData.techexOutputId || "",
            techexEdgeId: outputData.techexEdgeId || "",
            techexBlankStreamId: outputData.techexBlankStreamId || "",
          });
        case "MEDIA_CONNECT":
          return JSON.stringify({
            routerOutputArn: outputData.routerOutputArn || "",
            routingScope: outputData.routingScope || "REGIONAL",
          });
        default:
          return outputData.config || null;
      }
    },

    parseOutputConfigByType(outputData) {
      const parsedConfig = this.safeJsonParse(outputData.config, null);
      if (!parsedConfig || typeof parsedConfig !== "object") {
        outputData.outputConfigError = outputData.config ? "Invalid config JSON" : null;
        return null;
      }

      outputData.outputConfigError = null;

      switch (outputData.outputType) {
        case "ROUTE": {
          const normalizedConfig = {
            interfaceId: parsedConfig.interfaceId || "",
            interfaceName: parsedConfig.interfaceName || "",
            streamManagerId: parsedConfig.streamManagerId || parsedConfig.streamRouterId || "",
            interfaceDescription: parsedConfig.interfaceDescription || "",
            type: "SR",
          };
          outputData.streamRouterId = normalizedConfig.streamManagerId;
          outputData.interfaceId = normalizedConfig.interfaceId;
          outputData.interfaceName = normalizedConfig.interfaceName;
          outputData.interfaceDescription = normalizedConfig.interfaceDescription;
          outputData.routeType = "SR";
          outputData.smEndpoints = this.sanitizeRouteEndpoints(outputData.smEndpoints, normalizedConfig);
          return normalizedConfig;
        }
        case "OTT":
          outputData.ottPlatform = parsedConfig.platform || outputData.ottPlatform || null;
          outputData.ottServer = parsedConfig.server || outputData.ottServer || null;
          outputData.ottApplication = parsedConfig.application || outputData.ottApplication || null;
          outputData.ottDefaultTranscoderProfile =
            parsedConfig.defaultTranscoderProfile || outputData.ottDefaultTranscoderProfile || null;
          if (Object.prototype.hasOwnProperty.call(parsedConfig, "noStreamKeyRequired")) {
            outputData.ottNoStremKeyRequired = !!parsedConfig.noStreamKeyRequired;
          } else if (Object.prototype.hasOwnProperty.call(parsedConfig, "streamKeyRequired")) {
            outputData.ottNoStremKeyRequired = !parsedConfig.streamKeyRequired;
          }
          outputData.wowzaServerId = outputData.ottServer;
          outputData.wowzaApplicationId = outputData.ottApplication;
          outputData.wowzaTargetId = outputData.wowzaTargetId || parsedConfig.target || null;
          if (parsedConfig.targetConfig) {
            outputData.wowzaTargetConfig = this.normalizeWowzaTargetConfig(parsedConfig.targetConfig);
          }
          return parsedConfig;
        case "TECHEX":
          outputData.techexOutputId = parsedConfig.techexOutputId || null;
          outputData.techexEdgeId = parsedConfig.techexEdgeId || null;
          outputData.techexBlankStreamId = parsedConfig.techexBlankStreamId || null;
          return parsedConfig;
        case "MEDIA_CONNECT":
          outputData.routerOutputArn = parsedConfig.routerOutputArn || null;
          outputData.routingScope = parsedConfig.routingScope || "REGIONAL";
          outputData.mediaConnectOutputId = parsedConfig.outputId || outputData.mediaConnectOutputId || null;
          return parsedConfig;
        default:
          return parsedConfig;
      }
    },

    normalizeOutputForEdit(outputData) {
      const normalizedOutput = outputData;
      if (!this.isSupportedOutputType(normalizedOutput.outputType)) {
        return normalizedOutput;
      }

      normalizedOutput.allowExternalConfigUpdate = !!normalizedOutput.allowExternalConfigUpdate;
      normalizedOutput.routeType = "SR";
      normalizedOutput.wowzaTargetConfig = {
        ...createDefaultWowzaTargetConfig(),
        ...(normalizedOutput.wowzaTargetConfig || {}),
      };

      const parsedConfig = this.parseOutputConfigByType(normalizedOutput) || {};
      if (normalizedOutput.outputType === "ROUTE") {
        normalizedOutput.smEndpoints = this.sanitizeRouteEndpoints(
          normalizedOutput.smEndpoints,
          parsedConfig
        );
        this.updateRouteConflictState(normalizedOutput);
      }

      normalizedOutput.location = this.getPreferredOutputLocation(
        normalizedOutput.outputType,
        normalizedOutput.location
      );

      return normalizedOutput;
    },

    findRouteInterfaceConflicts(outputData) {
      if (!outputData || !outputData.interfaceId) return [];

      return (this.outputs || []).filter((output) => {
        if (!output || output.id === outputData.id || output.outputType !== "ROUTE") {
          return false;
        }
        const parsedConfig = this.safeJsonParse(output.config, {});
        return (output.interfaceId || parsedConfig.interfaceId) === outputData.interfaceId;
      });
    },

    updateRouteConflictState(outputData) {
      if (!outputData) return;
      const conflicts = this.findRouteInterfaceConflicts(outputData);
      this.$set(outputData, "routeInterfaceConflict", conflicts.length > 0 ? conflicts[0] : null);
    },

    buildOutputPayload(outputData) {
      const payload = {
        outputType: outputData.outputType,
        status: outputData.status,
        displayName: outputData.displayName,
        url: outputData.url,
        location: this.getPreferredOutputLocation(outputData.outputType, outputData.location),
        allowExternalConfigUpdate: !!outputData.allowExternalConfigUpdate,
        ottApplication: outputData.outputType === "OTT" ? outputData.ottApplication : null,
        ottNoStremKeyRequired: outputData.outputType === "OTT"
          ? !!outputData.ottNoStremKeyRequired
          : null,
        ottPlatform: outputData.outputType === "OTT" ? outputData.ottPlatform : null,
        ottServer: outputData.outputType === "OTT" ? outputData.ottServer : null,
        ottDefaultTranscoderProfile: outputData.outputType === "OTT"
          ? outputData.ottDefaultTranscoderProfile
          : null,
        config: this.buildOutputConfigByType(outputData),
        smEndpoints: outputData.outputType === "ROUTE"
          ? this.serializeRouteEndpoints(outputData.smEndpoints, {
            interfaceId: outputData.interfaceId,
            interfaceName: outputData.interfaceName,
            streamManagerId: outputData.streamRouterId,
            interfaceDescription: outputData.interfaceDescription,
          })
          : null,
      };

      return payload;
    },

    parseMediaConnectProtocolConfiguration(protocol, protocolConfiguration = {}) {
      const standardConfig = protocolConfiguration || {};
      if (protocol === "SRT_LISTENER") {
        return {
          mcOutputPort: standardConfig.SrtListener?.Port || null,
          mcOutputLatency: standardConfig.SrtListener?.MinimumLatencyMilliseconds || null,
        };
      }
      if (protocol === "SRT_CALLER") {
        return {
          mcOutputDestinationAddress: standardConfig.SrtCaller?.DestinationAddress || null,
          mcOutputDestinationPort: standardConfig.SrtCaller?.DestinationPort || null,
          mcOutputLatency: standardConfig.SrtCaller?.MinimumLatencyMilliseconds || null,
        };
      }
      if (protocol === "RTP") {
        return {
          mcOutputDestinationAddress: standardConfig.Rtp?.DestinationAddress || null,
          mcOutputDestinationPort: standardConfig.Rtp?.DestinationPort || null,
        };
      }
      if (protocol === "RIST") {
        return {
          mcOutputDestinationAddress: standardConfig.Rist?.DestinationAddress || null,
          mcOutputDestinationPort: standardConfig.Rist?.DestinationPort || null,
        };
      }
      return {};
    },

    buildMediaConnectExternalConfig(outputData, { isUpdate = false } = {}) {
      const existingDetails = outputData.mediaConnectOutputDetails || {};
      const existingStandardConfig = existingDetails.Configuration?.Standard || {};
      const networkInterfaceArn = isUpdate
        ? existingStandardConfig.NetworkInterfaceArn || outputData.mcOutputNetworkInterfaceArn
        : outputData.mcOutputNetworkInterfaceArn;

      if (!isUpdate && !networkInterfaceArn) {
        throw new Error("NetworkInterfaceArn is required to create MediaConnect output");
      }
      if (!outputData.mcOutputProtocol) {
        throw new Error("MediaConnect protocol is required");
      }

      const mediaConnectConfig = {
        Name: (outputData.mcOutputName || outputData.name || "")
          .replace(/[^a-zA-Z0-9_-]/g, "-")
          .replace(/^[^a-zA-Z0-9]+/, "")
          .replace(/[^a-zA-Z0-9]+$/, "")
          .slice(0, 128),
        MaximumBitrate: Number(outputData.mcOutputBitrate),
        RoutingScope: outputData.routingScope || "REGIONAL",
        Tier: outputData.mcOutputTier,
        Configuration: {
          Standard: {
            NetworkInterfaceArn: networkInterfaceArn,
            Protocol: outputData.mcOutputProtocol,
            ProtocolConfiguration: {},
          },
        },
      };

      if (isUpdate) {
        if (outputData.mediaConnectOutputId) mediaConnectConfig.OutputId = outputData.mediaConnectOutputId;
        if (outputData.routerOutputArn) {
          mediaConnectConfig.Arn = outputData.routerOutputArn;
          mediaConnectConfig.RouterOutputArn = outputData.routerOutputArn;
        }
      }

      if (outputData.mcOutputProtocol === "SRT_LISTENER") {
        mediaConnectConfig.Configuration.Standard.ProtocolConfiguration.SrtListener = {
          Port: Number(outputData.mcOutputPort),
          MinimumLatencyMilliseconds: Number(outputData.mcOutputLatency),
        };
      } else if (outputData.mcOutputProtocol === "SRT_CALLER") {
        mediaConnectConfig.Configuration.Standard.ProtocolConfiguration.SrtCaller = {
          DestinationAddress: outputData.mcOutputDestinationAddress,
          DestinationPort: Number(outputData.mcOutputDestinationPort),
          MinimumLatencyMilliseconds: Number(outputData.mcOutputLatency),
        };
      } else if (outputData.mcOutputProtocol === "RTP") {
        mediaConnectConfig.Configuration.Standard.ProtocolConfiguration.Rtp = {
          DestinationAddress: outputData.mcOutputDestinationAddress,
          DestinationPort: Number(outputData.mcOutputDestinationPort),
        };
      } else if (outputData.mcOutputProtocol === "RIST") {
        mediaConnectConfig.Configuration.Standard.ProtocolConfiguration.Rist = {
          DestinationAddress: outputData.mcOutputDestinationAddress,
          DestinationPort: Number(outputData.mcOutputDestinationPort),
        };
      }

      return mediaConnectConfig;
    },

    async fetchMediaConnectInterfaces() {
      try {
        await this.loadMediaConnectNetworkInterfaces();
      } catch (err) {
        console.error("Failed to load MediaConnect interfaces", err);
      }
    },

    async fetchMediaConnectOutputs() {
      this.loadingMediaConnectOutputs = true;
      try {
        await this.loadMediaConnectOutputs();
      } catch (error) {
        console.error("Failed to load MediaConnect outputs", error);
      } finally {
        this.loadingMediaConnectOutputs = false;
      }
    },

    async hydrateMediaConnectOutputDetails(outputData) {
      if (!outputData || outputData.outputType !== "MEDIA_CONNECT") return null;

      if (!this.mediaConnectOutputs.length) {
        await this.fetchMediaConnectOutputs();
      }

      let outputId = outputData.mediaConnectOutputId;
      if (!outputId && outputData.routerOutputArn) {
        const matchedOutput = this.mediaConnectOutputs.find(
          (mediaConnectOutput) => mediaConnectOutput.Arn === outputData.routerOutputArn
        );
        outputId = matchedOutput?.Id || null;
      }

      if (!outputId) return null;

      try {
        const result = await this.getMediaConnectOutputById(outputId);
        if (!result?.success || !result?.data) return null;
        const details = result.data;
        outputData.mediaConnectOutputDetails = details;
        outputData.mediaConnectOutputId = details.Id || outputId;
        outputData.routerOutputArn = outputData.routerOutputArn || details.Arn || null;
        outputData.routingScope = details.RoutingScope || outputData.routingScope || "REGIONAL";
        outputData.mcOutputName = outputData.mcOutputName || details.Name || null;
        outputData.mcOutputBitrate = outputData.mcOutputBitrate || details.MaximumBitrate || null;
        outputData.mcOutputTier = outputData.mcOutputTier || details.Tier || "OUTPUT_50";
        outputData.mcOutputNetworkInterfaceArn =
          details.Configuration?.Standard?.NetworkInterfaceArn ||
          outputData.mcOutputNetworkInterfaceArn ||
          null;
        outputData.mcOutputProtocol =
          details.Configuration?.Standard?.Protocol || outputData.mcOutputProtocol || null;
        Object.assign(
          outputData,
          this.parseMediaConnectProtocolConfiguration(
            outputData.mcOutputProtocol,
            details.Configuration?.Standard?.ProtocolConfiguration
          )
        );
        outputData.location = outputData.location || details.RegionName || null;
        return details;
      } catch (error) {
        console.error("Failed to hydrate MediaConnect output details", error);
      }

      return null;
    },

    async onOutputTypeChange() {
      const nextOutputType = this.form.output.outputType;
      const preservedFields = {
        status: this.form.output.status,
        displayName: this.form.output.displayName,
        url: this.form.output.url,
        allowExternalConfigUpdate: this.form.output.allowExternalConfigUpdate,
        location: this.form.output.location,
      };

      this.form.output = {
        ...createDefaultOutputForm(),
        ...preservedFields,
        outputType: nextOutputType,
        location: this.getPreferredOutputLocation(nextOutputType, preservedFields.location, {
          preserveLegacy: false,
        }),
      };

      if (nextOutputType === "MEDIA_CONNECT") {
        await this.fetchMediaConnectOutputs();
      }
    },

    async onWowzaServerChange() {
      if (!this.form.output.wowzaServerId) return;

      this.loadingWowzaData = true;
      this.form.output.ottServer = this.form.output.wowzaServerId;
      this.form.output.wowzaApplicationId = null;
      this.form.output.ottApplication = null;
      this.form.output.wowzaTargetId = null;

      try {
        await this.loadWowzaApplications(this.form.output.wowzaServerId);
      } catch (error) {
        console.error('Error loading Wowza applications:', error);
        this.$message.error('Failed to load Wowza applications');
      } finally {
        this.loadingWowzaData = false;
      }
    },

    async onWowzaApplicationChange() {
      if (!this.form.output.wowzaServerId || !this.form.output.wowzaApplicationId) return;

      this.loadingWowzaData = true;
      this.form.output.ottApplication = this.form.output.wowzaApplicationId;
      this.form.output.wowzaTargetId = null;

      try {
        await this.loadWowzaTargetsAndTemplates({
          serverId: this.form.output.wowzaServerId,
          applicationId: this.form.output.wowzaApplicationId
        });
      } catch (error) {
        console.error('Error loading Wowza data:', error);
        this.$message.error('Failed to load Wowza data');
      } finally {
        this.loadingWowzaData = false;
      }
    },

    async onEditWowzaServerChange(item) {
      if (!item.wowzaServerId) return;

      this.loadingWowzaData = true;
      item.ottServer = item.wowzaServerId;
      item.wowzaApplicationId = null;
      item.ottApplication = null;
      item.wowzaTargetId = null;

      try {
        await this.loadWowzaApplications(item.wowzaServerId);
      } catch (error) {
        console.error("Error loading Wowza applications:", error);
        this.$message.error("Failed to load Wowza applications");
      } finally {
        this.loadingWowzaData = false;
      }
    },

    async onEditWowzaApplicationChange(item) {
      if (!item.wowzaServerId || !item.wowzaApplicationId) return;

      this.loadingWowzaData = true;
      item.ottApplication = item.wowzaApplicationId;
      item.wowzaTargetId = null;

      try {
        await this.loadWowzaTargetsAndTemplates({
          serverId: item.wowzaServerId,
          applicationId: item.wowzaApplicationId,
        });
      } catch (error) {
        console.error("Error loading Wowza data:", error);
        this.$message.error("Failed to load Wowza data");
      } finally {
        this.loadingWowzaData = false;
      }
    },

    normalizeWowzaTargetConfig(targetData = {}) {
      return {
        ...createDefaultWowzaTargetConfig(),
        entryName: targetData.entryName || targetData.name || targetData.EntryName || null,
        enabled: targetData.enabled ?? targetData.Enabled ?? true,
        sourceStreamName:
          targetData.sourceStreamName || targetData.SourceStreamName || null,
        streamName: targetData.streamName || targetData.StreamName || null,
        host: targetData.host || targetData.Host || null,
        port: targetData.port || targetData.Port || null,
        profile: targetData.profile || targetData.Profile || "rtmp",
        application: targetData.application || targetData.Application || null,
        timeToLive: targetData.timeToLive || targetData.TimeToLive || null,
        streamWaitTimeout:
          targetData.streamWaitTimeout || targetData.StreamWaitTimeout || null,
        videoPort: targetData.videoPort || targetData.VideoPort || null,
        audioPort: targetData.audioPort || targetData.AudioPort || null,
        srtLatency: targetData.srtLatency || targetData.SrtLatency || null,
        srtTooLatePacketDrop:
          targetData.srtTooLatePacketDrop ?? targetData.SrtTooLatePacketDrop ?? true,
        srtTimestampBasedDeliveryMode:
          targetData.srtTimestampBasedDeliveryMode ??
          targetData.SrtTimestampBasedDeliveryMode ??
          true,
        srtSendBufferSize:
          targetData.srtSendBufferSize || targetData.SrtSendBufferSize || null,
        srtSendBufferSizeUDP:
          targetData.srtSendBufferSizeUDP || targetData.SrtSendBufferSizeUDP || null,
        srtMaximumSegmentSize:
          targetData.srtMaximumSegmentSize || targetData.SrtMaximumSegmentSize || null,
        srtFlightFlagSize:
          targetData.srtFlightFlagSize || targetData.SrtFlightFlagSize || null,
        srtMaximumBandwidth:
          targetData.srtMaximumBandwidth || targetData.SrtMaximumBandwidth || null,
        srtInputBandwidth:
          targetData.srtInputBandwidth || targetData.SrtInputBandwidth || null,
        srtOverheadBandwidth:
          targetData.srtOverheadBandwidth || targetData.SrtOverheadBandwidth || null,
        srtConnectTimeout:
          targetData.srtConnectTimeout || targetData.SrtConnectTimeout || null,
        srtPeerIdleTimeout:
          targetData.srtPeerIdleTimeout || targetData.SrtPeerIdleTimeout || null,
        srtStreamId: targetData.srtStreamId || targetData.SrtStreamId || null,
      };
    },

    async onWowzaTargetChange() {
      if (!this.form.output.wowzaTargetId) return;

      const selectedTarget = this.wowzaTargetsFromStore.find(
        (target) => target.id === this.form.output.wowzaTargetId
      );
      if (selectedTarget) {
        this.form.name = selectedTarget.name || selectedTarget.entryName || this.form.name;
        this.form.output.wowzaTargetConfig = this.normalizeWowzaTargetConfig(selectedTarget);
      }
    },

    async createStreamRouterInterfaceForInput(inputData) {
      if (!inputData.createInterface || !inputData.streamRouterId) return null;

      const interfaceData = {
        name: inputData.interfaceName,
        source: inputData.source,
        destination: inputData.destination,
        processors: inputData.processors || [],
        tags: inputData.tags || [],
        whitelist: inputData.whitelist || [],
        autostart: inputData.autostart || false,
      };

      try {
        const result = await this.createStreamRouterInterface({
          streamRouterId: inputData.streamRouterId,
          interfaceData,
        });

        if (result && !result.error) {
          return result;
        } else {
          throw new Error(result?.message || 'Failed to create interface');
        }
      } catch (error) {
        console.error('Error creating stream router interface:', error);
        this.$message.error('Failed to create stream router interface: ' + error.message);
        return null;
      }
    },

    async createStreamRouterInterfaceForOutput(outputData) {
      if (!outputData.createInterface || !outputData.streamRouterId) return null;

      const interfaceData = {
        name: outputData.interfaceName,
        source: {
          url: outputData.sourceUrl,
          type: 'SRT', // Default type, can be made configurable
        },
        destination: {
          url: outputData.destinationUrl,
          type: 'SRT', // Default type, can be made configurable
        },
        processors: outputData.processors || [],
        tags: outputData.tags || [],
        whitelist: outputData.whitelist || [],
        autostart: outputData.autostart || false,
      };

      try {
        const result = await this.createStreamRouterInterface({
          streamRouterId: outputData.streamRouterId,
          interfaceData,
        });

        if (result && !result.error) {
          return result;
        } else {
          throw new Error(result?.message || 'Failed to create interface');
        }
      } catch (error) {
        console.error('Error creating stream router interface:', error);
        this.$message.error('Failed to create stream router interface: ' + error.message);
        return null;
      }
    },

    async createWowzaTargetForOutput(outputData) {
      if (
        !outputData.allowExternalConfigUpdate ||
        !outputData.createWowzaTarget ||
        !outputData.wowzaServerId ||
        !outputData.wowzaApplicationId
      ) {
        return null;
      }

      try {
        const result = await this.createExternalWowzaTarget({
          serverId: outputData.wowzaServerId,
          applicationId: outputData.wowzaApplicationId,
          targetConfig: outputData.wowzaTargetConfig
        });
        
        if (result && result.success) {
          outputData.wowzaTargetId =
            result.data?.targetId || result.data?.id || outputData.wowzaTargetConfig.entryName;
          outputData.createWowzaTarget = false;
          return result;
        } else {
          throw new Error(result?.error || 'Failed to create target');
        }
      } catch (error) {
        console.error('Error creating Wowza target:', error);
        this.$message.error('Failed to create Wowza target: ' + error.message);
        return null;
      }
    },

    async updateWowzaTargetForOutput(outputData) {
      if (
        !outputData.allowExternalConfigUpdate ||
        !outputData.wowzaServerId ||
        !outputData.wowzaApplicationId ||
        !outputData.wowzaTargetId ||
        !outputData.wowzaTargetConfig
      ) {
        return null;
      }

      try {
        const result = await this.updateExternalWowzaTarget({
          serverId: outputData.wowzaServerId,
          applicationId: outputData.wowzaApplicationId,
          targetId: outputData.wowzaTargetId,
          targetConfig: outputData.wowzaTargetConfig
        });
        
        if (result && result.success) {
          return result;
        } else {
          throw new Error(result?.error || 'Failed to update target');
        }
      } catch (error) {
        console.error('Error updating Wowza target:', error);
        this.$message.error('Failed to update Wowza target: ' + error.message);
        return null;
      }
    },

    async deleteWowzaTargetForOutput(outputData) {
      if (
        !outputData.allowExternalConfigUpdate ||
        !outputData.wowzaServerId ||
        !outputData.wowzaApplicationId ||
        !outputData.wowzaTargetId
      ) {
        return null;
      }

      try {
        await this.$confirm(
          "Delete the selected Wowza target in the external service?",
          "Delete Wowza Target",
          { type: "warning" }
        );
      } catch (error) {
        return null;
      }

      try {
        const result = await this.deleteExternalWowzaTarget({
          serverId: outputData.wowzaServerId,
          applicationId: outputData.wowzaApplicationId,
          targetId: outputData.wowzaTargetId,
        });

        if (result && result.success !== false) {
          outputData.wowzaTargetId = null;
          outputData.wowzaTargetConfig = createDefaultWowzaTargetConfig();
          await this.loadWowzaTargetsAndTemplates({
            serverId: outputData.wowzaServerId,
            applicationId: outputData.wowzaApplicationId,
          });
          this.$message.success("Wowza target deleted");
          return result;
        }

        throw new Error(result?.error || result?.message || "Failed to delete target");
      } catch (error) {
        console.error("Error deleting Wowza target:", error);
        this.$message.error(`Failed to delete Wowza target: ${error.message}`);
        return null;
      }
    },

    async createMediaConnectOutputForOutput(outputData) {
      if (!outputData.allowExternalConfigUpdate) return null;

      try {
        const mediaConnectConfig = this.buildMediaConnectExternalConfig(outputData);
        const result = await this.createMediaConnectOutputInStore(mediaConnectConfig);
        if (!result?.success) {
          throw new Error(result?.message || result?.error || "Unknown error");
        }
        const resultData = result.data || {};
        outputData.mediaConnectOutputDetails = resultData;
        outputData.mediaConnectOutputId = resultData.Id || null;
        outputData.routerOutputArn = resultData.Arn || null;
        outputData.routingScope = resultData.RoutingScope || outputData.routingScope || "REGIONAL";
        outputData.location = outputData.location || resultData.RegionName || null;
        return resultData;
      } catch (error) {
        console.error("Failed to create MediaConnect output", error);
        this.$message.error(error.message || String(error));
        return null;
      }
    },

    async updateMediaConnectOutputForOutput(outputData) {
      if (!outputData.allowExternalConfigUpdate) return null;

      await this.hydrateMediaConnectOutputDetails(outputData);

      try {
        const mediaConnectConfig = this.buildMediaConnectExternalConfig(outputData, {
          isUpdate: true,
        });
        const result = await this.updateMediaConnectOutputInStore(mediaConnectConfig);
        if (!result?.success) {
          throw new Error(result?.message || result?.error || "Unknown error");
        }
        const resultData = result.data || {};
        outputData.mediaConnectOutputDetails = resultData;
        outputData.mediaConnectOutputId = resultData.Id || outputData.mediaConnectOutputId || null;
        outputData.routerOutputArn = resultData.Arn || outputData.routerOutputArn || null;
        outputData.routingScope = resultData.RoutingScope || outputData.routingScope || "REGIONAL";
        outputData.location = outputData.location || resultData.RegionName || null;
        return resultData;
      } catch (error) {
        console.error("Failed to update MediaConnect output", error);
        this.$message.error(error.message || String(error));
        return null;
      }
    },

    async init() {
      this.loading = true;
      this.initializing = true;
      try {
        const [
          inputResult,
          outputResult,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          probeResult,
        ] = await Promise.all([
          this.listInputs(),
          this.listOutputs(),
          this.listMultiviewers(),
          this.listOutputProfiles(),
          this.listTranscodingProfiles(),
          this.listTranscodingOutputs(),
          this.listLocationss(),
          this.listClaims(),
          this.listClients(),
          this.loadWowzaServers(),
          ProbesServices.getProbesList(),
          // keep new entries after probeResult - the destructuring above is positional
          this.listInputProfiles(),
          this.listProviders(),
        ]);

        await this.listStreamRouters();

        if (probeResult?.data) {
          this.probes = probeResult.data;
        }

        this.select((inputResult && inputResult.items) || this.inputs || [], "input");
        if (outputResult && outputResult.items && this.listType !== "input") {
          this.select(outputResult.items, "output");
        }
      } finally {
        this.initializing = false;
      }
    },

    showAddForm(type) {
      if (this.usesPermissionModal(type)) {
        this.openPermissionModal("create", type);
        return;
      }
      this.formType = type;
      if (type === "transcodingOutput") {
        this.form.transcoding.config = createDefaultTranscodingOutputConfig();
      } else if (type === "transcodingProfile") {
        this.form.transcoding.config = createDefaultTranscodingProfileConfig();
      }
      this.showAddDialog = true;
    },

    select(data, type) {
      if (this.listType !== type) this.page = 1;
      if (this.listType !== type) {
        this.selectedInputTypeFilter = "";
        this.selectedOutputTypeFilter = "";
      }
      console.log("data,type =>", data, type);
      this.inEditMode = false;
      this.loading = true;
      this.listType = type;
      this.activeList = [];
      const processedItemList = data.map((item, index) => {
        if (!item) return { id: "missing", name: "Corrupted" };
        const access = buildClaimSelections(item.claimsCanAccess || []);
        const edit = buildClaimSelections(item.claimsCanEdit || []);

        const newItem = {
          ...item,
          editing: false,
          saving: false,
          access,
          edit,
          index,
          _searchIndex: buildPermissionSearchIndex(item, type),
        };
        if (type === "output") {
          this.normalizeOutputForEdit(newItem);
        }
        if (type === "multiviewer") {
          newItem.streamSources = item.streamSources.items
            .map((map) => {
              const isNotNull = !!map;
              if (isNotNull)
                return {
                  ...map.streamSource,
                  sortOrder: map.sortOrder,
                  mapId: map.id,
                };
              return {};
            })
            .sort((a, b) => {
              if (a.sortOrder < b.sortOrder) {
                return -1;
              }
              if (a.sortOrder > b.sortOrder) {
                return 1;
              }
              return 0;
            });
          newItem.originalStreamSources = item.streamSources.items;
        }
        if (type === "outputProfile") {
          newItem.outputs = item.outputs.items.map((outputMap) => outputMap.output);
          newItem.outputMapping = item.outputs.items;
          newItem.originalOutputs = item.outputs.items.map((map) => map.output.id);
        }
        if (type === "inputProfile") {
          const inputMaps = (item.inputs && item.inputs.items) || [];
          newItem.inputs = inputMaps.map((map) => map.input);
          newItem.inputMapping = inputMaps;
          newItem.originalInputs = inputMaps.map((map) => map.input.id);
          newItem.inputProfileProviderId = item.provider ? item.provider.id : null;
          newItem.supportedTypes = item.supportedTypes || [];
        }
        if (type === "routers") {
          newItem.routerGroups = item.routerGroups.items;
          newItem.originalRouterGroups = item.routerGroups.items;
        }
        if (type === "routerGroups") {
          // newItem.destinations = item.destinations.items.map(dest => dest.routerDestination);
          newItem.destinations = item.destinations.items.map((map) => {
            const isNotNull = !!map;
            if (isNotNull) return map.routerDestination;
            return {};
          });
          // newItem.sources = item.sources.items.map(source => source.routerSource);
          newItem.sources = item.sources.items.map((map) => {
            const isNotNull = !!map;
            if (isNotNull) return map.routerSource;
            return {};
          });
          newItem.originalDestinations = item.destinations.items;
          newItem.originalSources = item.sources.items;
        }
        if (type === "sources") {
          newItem.mappedInputs = item.mappedInputs.items.map((map) => {
            const isNotNull = !!map;
            if (isNotNull) return map.input;
            return {};
          });
          newItem.originalMappedInputs = item.mappedInputs.items;
          newItem.routerGroups = item.routerGroups.items.map((map) => {
            const isNotNull = !!map;
            if (isNotNull) return map.routerGroup;
            return {};
          });
          newItem.originalRouterGroups = item.routerGroups.items;
        }
        if (type === "destinations") {
          newItem.mappedOutputs = item.mappedOutputs.items.map((map) => map.output);
          newItem.routerDestinationDefaultSourceId = item.defaultSource;
          newItem.originalMappedOutputs = item.mappedOutputs.items;
          newItem.routerGroups = item.routerGroups.items.map((map) => {
            const isNotNull = !!map;
            if (isNotNull) return map.routerGroup;
            return {};
          });
          newItem.originalRouterGroups = item.routerGroups.items;
        }
        if (type === "input") {
          // Parse config JSON for MediaConnect inputs
          if (newItem.type === 'MEDIA_CONNECT' && newItem.config) {
            try {
              const config = JSON.parse(newItem.config);
              newItem.routerInputArn = config.routerInputArn || null;
              newItem.inputArn = config.inputArn || null;
            } catch (e) {
              // Ignore broken legacy config while keeping the list renderable.
            }
          }
          this.probes.forEach((probe) => {
            probe.tasks.forEach((task) => {
              if (String(task.id) === String(newItem.probeTaskId)) {
                newItem.probe = {
                  ...probe,
                  task,
                  key: task.id,
                };
              }
            });
          });
        }
        return newItem;
      });

      this.activeList = processedItemList;
      this.sortedList = sortByName(this.activeList);
      this.loading = false;
    },
    selectItem(data) {
      this.activeItem = data;
    },
    confirmDelete(item, index, type) {
      if (window.confirm("Are you sure you want to delete this item?")) {
        this.deleteItem(item, index, type);
      }
    },
    getSelectedAccountsByIds(accountIds = []) {
      return this.accounts.filter((account) => accountIds.includes(account.id));
    },
    async handleModalInputTypeChange(nextType) {
      if (!this.permissionModalDraft) return;

      this.permissionModalDraft = {
        ...this.permissionModalDraft,
        input: {
          ...this.createEmptyInputState(),
          ...this.permissionModalDraft.input,
          type: nextType,
        },
      };

      if (nextType === "MEDIA_CONNECT") {
        await this.ensureMediaConnectInterfacesLoaded();
      }
    },
    async handleModalOutputTypeChange(nextType) {
      if (!this.permissionModalDraft) return;

      const preservedFields = {
        status: this.permissionModalDraft.output.status,
        displayName: this.permissionModalDraft.output.displayName,
        url: this.permissionModalDraft.output.url,
        allowExternalConfigUpdate: this.permissionModalDraft.output.allowExternalConfigUpdate,
        location: this.permissionModalDraft.output.location,
      };

      this.permissionModalDraft = {
        ...this.permissionModalDraft,
        output: {
          ...createDefaultOutputForm(),
          ...preservedFields,
          outputType: nextType,
          location: this.getPreferredOutputLocation(nextType, preservedFields.location, {
            preserveLegacy: false,
          }),
        },
      };

      if (nextType === "MEDIA_CONNECT") {
        await Promise.all([
          this.ensureMediaConnectInterfacesLoaded(),
          this.ensureMediaConnectOutputsLoaded(),
        ]);
      }
    },
    async handleModalWowzaServerChange(serverId, options = {}) {
      if (!this.permissionModalDraft) return;

      this.permissionModalDraft = {
        ...this.permissionModalDraft,
        output: {
          ...this.permissionModalDraft.output,
          wowzaServerId: serverId,
          ottServer: serverId,
          wowzaApplicationId: options.preserveApplication
            ? this.permissionModalDraft.output.wowzaApplicationId
            : null,
          ottApplication: options.preserveApplication
            ? this.permissionModalDraft.output.ottApplication
            : null,
          wowzaTargetId: options.preserveApplication ? this.permissionModalDraft.output.wowzaTargetId : null,
        },
      };

      if (!serverId) return;

      this.loadingWowzaData = true;
      try {
        await this.loadWowzaApplications(serverId);
      } catch (error) {
        this.$message.error("Failed to load Wowza applications");
      } finally {
        this.loadingWowzaData = false;
      }

      if (!options.skipEmit) {
        this.permissionModalDraft = {
          ...this.permissionModalDraft,
          output: {
            ...this.permissionModalDraft.output,
            wowzaApplicationId: null,
            ottApplication: null,
            wowzaTargetId: null,
          },
        };
      }
    },
    async handleModalWowzaApplicationChange(applicationId, options = {}) {
      if (!this.permissionModalDraft) return;

      this.permissionModalDraft = {
        ...this.permissionModalDraft,
        output: {
          ...this.permissionModalDraft.output,
          wowzaApplicationId: applicationId,
          ottApplication: applicationId,
          wowzaTargetId: options.skipEmit ? this.permissionModalDraft.output.wowzaTargetId : null,
        },
      };

      if (!this.permissionModalDraft.output.wowzaServerId || !applicationId) return;

      this.loadingWowzaData = true;
      try {
        await this.loadWowzaTargetsAndTemplates({
          serverId: this.permissionModalDraft.output.wowzaServerId,
          applicationId,
        });
      } catch (error) {
        this.$message.error("Failed to load Wowza data");
      } finally {
        this.loadingWowzaData = false;
      }
    },
    handleModalWowzaTargetChange(targetId) {
      if (!this.permissionModalDraft) return;

      const selectedTarget = this.wowzaTargetsFromStore.find((target) => target.id === targetId);
      this.permissionModalDraft = {
        ...this.permissionModalDraft,
        name: selectedTarget?.name || selectedTarget?.entryName || this.permissionModalDraft.name,
        output: {
          ...this.permissionModalDraft.output,
          wowzaTargetId: targetId,
          wowzaTargetConfig: selectedTarget
            ? this.normalizeWowzaTargetConfig(selectedTarget)
            : this.permissionModalDraft.output.wowzaTargetConfig,
        },
      };
    },
    async handleModalMediaConnectOutputChange(outputId) {
      if (!this.permissionModalDraft) return;

      const selectedOutput = this.mediaConnectOutputs.find((output) => output.Id === outputId) || null;
      this.permissionModalDraft = {
        ...this.permissionModalDraft,
        output: {
          ...this.permissionModalDraft.output,
          mediaConnectOutputId: outputId || null,
          routerOutputArn: selectedOutput?.Arn || this.permissionModalDraft.output.routerOutputArn || null,
        },
      };

      if (!outputId) return;

      await this.hydrateMediaConnectOutputDetails(this.permissionModalDraft.output);
      this.permissionModalDraft = {
        ...this.permissionModalDraft,
        output: {
          ...this.permissionModalDraft.output,
        },
      };
    },
    async handleModalStreamRouterChange(streamRouterId, options = {}) {
      if (!this.permissionModalDraft) return;

      const nextOutput = {
        ...this.permissionModalDraft.output,
        streamRouterId,
      };

      if (!options.preserveInterface) {
        nextOutput.interfaceId = null;
        nextOutput.interfaceName = null;
        nextOutput.interfaceDescription = "";
        nextOutput.smEndpoints = [];
        nextOutput.routeInterfaceConflict = null;
      }

      this.permissionModalDraft = {
        ...this.permissionModalDraft,
        output: nextOutput,
      };

      if (!streamRouterId) {
        this.streamRouterInterfaces = [];
        return;
      }

      this.loadingStreamRouterInterfaces = true;
      try {
        this.streamRouterInterfaces = await this.loadStreamRouterInterfacesForTarget(streamRouterId);
      } catch (error) {
        this.streamRouterInterfaces = [];
        this.$message.error("Failed to load stream router interfaces");
      } finally {
        this.loadingStreamRouterInterfaces = false;
      }
    },
    async handleModalInterfaceChange(interfaceId) {
      if (!this.permissionModalDraft) return;

      this.permissionModalDraft = {
        ...this.permissionModalDraft,
        output: {
          ...this.permissionModalDraft.output,
          interfaceId,
        },
      };

      if (!this.permissionModalDraft.output.streamRouterId || !interfaceId) return;

      this.loadingInterfaceDetails = true;
      try {
        const interfaceDetails = await this.loadRouteInterfaceDetails(
          this.permissionModalDraft.output.streamRouterId,
          interfaceId
        );
        const nextOutput = {
          ...this.permissionModalDraft.output,
          interfaceId,
          interfaceName: interfaceDetails.interfaceName,
          interfaceDescription: interfaceDetails.interfaceDescription,
          smEndpoints: this.sanitizeRouteEndpoints([], {
            interfaceId,
            interfaceName: interfaceDetails.interfaceName,
            streamManagerId: interfaceDetails.streamManagerId,
            interfaceDescription: interfaceDetails.interfaceDescription,
          }).map((endpoint) => ({
            ...endpoint,
            _validationErrors: {},
          })),
        };
        this.updateRouteConflictState(nextOutput);
        this.permissionModalDraft = {
          ...this.permissionModalDraft,
          output: nextOutput,
        };
      } catch (error) {
        this.$message.error(error.message || "Failed to load interface details");
      } finally {
        this.loadingInterfaceDetails = false;
      }
    },
    validatePermissionModal() {
      if (!this.permissionModalDraft) {
        return { isValid: false, errors: {} };
      }

      if (this.permissionModalEntityType === "input") {
        return validateInputForm(this.permissionModalDraft, {
          requireCreateAccounts: this.permissionModalMode === "create",
        });
      }

      if (this.permissionModalEntityType === "output") {
        return validateOutputForm(this.permissionModalDraft, {
          requireCreateAccounts: this.permissionModalMode === "create",
        });
      }

      if (this.permissionModalEntityType === "outputProfile") {
        return validateOutputProfileForm(this.permissionModalDraft);
      }

      if (this.permissionModalEntityType === "inputProfile") {
        return validateInputProfileForm(this.permissionModalDraft);
      }

      if (this.permissionModalEntityType === "provider") {
        return validateProviderForm(this.permissionModalDraft);
      }

      if (this.permissionModalEntityType === "location") {
        const errors = {};
        if (!String(this.permissionModalDraft?.name || "").trim()) {
          errors.name = "Name is required.";
        }
        if (!String(this.permissionModalDraft?.location?.code || "").trim()) {
          errors["location.code"] = "Code is required.";
        }
        if (!String(this.permissionModalDraft?.location?.type || "").trim()) {
          errors["location.type"] = "Type is required.";
        }
        return {
          isValid: Object.keys(errors).length === 0,
          errors,
        };
      }

      if (["transcodingProfile", "transcodingOutput"].includes(this.permissionModalEntityType)) {
        const validation = validateTranscodingForm(this.permissionModalDraft);
        if (this.permissionModalEntityType === "transcodingOutput" && !this.transcodingOutputValid) {
          validation.isValid = false;
        }
        return validation;
      }

      return { isValid: true, errors: {} };
    },
    async savePermissionModal() {
      const validation = this.validatePermissionModal();
      this.permissionModalErrors = validation.errors;
      if (!validation.isValid) {
        if (this.permissionModalEntityType === "transcodingOutput" && !this.transcodingOutputValid) {
          const errors = this.transcodingOutputErrors || [];
          const message = errors.length > 0
            ? `Please fix transcoding output configuration:\n- ${errors.slice(0, 3).join("\n- ")}${errors.length > 3 ? "\n... and more" : ""}`
            : "Please fill in all required fields in the Transcoding Output Configuration.";
          this.$message.error(message);
          return;
        }

        const firstError = Object.values(validation.errors || {})[0];
        this.$message.error(firstError || "Please fix validation errors before saving.");
        return;
      }

      this.permissionModalLoading = true;

      try {
        if (this.permissionModalMode === "create") {
          await this.createPermissionModalEntity();
        } else {
          await this.updatePermissionModalEntity();
        }

        this.closePermissionModal();
      } catch (error) {
        this.$message.error(error.message || "Failed to save changes");
      } finally {
        this.permissionModalLoading = false;
      }
    },
    buildPermissionPayloadBase(draft, { includeVersion = false, lastUpdatedField = null } = {}) {
      const claimsCanAccess = serializeClaimSelections(draft.claimsCanAccess);
      const claimsCanEdit = serializeClaimSelections(draft.claimsCanEdit);
      const payload = {
        name: draft.name,
        claimsCanAccess,
        claimsCanEdit,
      };

      if (draft.description) payload.description = draft.description;
      if (draft.id) payload.id = draft.id;
      if (includeVersion) payload.expectedVersion = draft.version;
      if (lastUpdatedField) payload[lastUpdatedField] = this.userId;

      return {
        payload,
        claimsCanAccess,
        claimsCanEdit,
      };
    },
    extractMutationErrorMessage(result, fallbackMessage = "Operation failed") {
      if (!result) return fallbackMessage;
      if (result?.error) return result?.message || fallbackMessage;
      if (Object.prototype.hasOwnProperty.call(result, "success") && result.success === false) {
        return result?.message || fallbackMessage;
      }
      return null;
    },
    ensureMutationSucceeded(result, fallbackMessage = "Operation failed") {
      const errorMessage = this.extractMutationErrorMessage(result, fallbackMessage);
      if (errorMessage) throw new Error(errorMessage);
      return result;
    },
    async createPermissionModalEntity() {
      if (this.permissionModalEntityType === "input") {
        return this.createInputFromModal();
      }
      if (this.permissionModalEntityType === "output") {
        return this.createOutputFromModal();
      }
      if (this.permissionModalEntityType === "outputProfile") {
        return this.createOutputProfileFromModal();
      }
      if (this.permissionModalEntityType === "inputProfile") {
        return this.createInputProfileFromModal();
      }
      if (this.permissionModalEntityType === "provider") {
        return this.createProviderFromModal();
      }
      if (this.permissionModalEntityType === "location") {
        return this.createLocationFromModal();
      }
      if (this.permissionModalEntityType === "transcodingProfile") {
        return this.createTranscodingProfileFromModal();
      }
      if (this.permissionModalEntityType === "transcodingOutput") {
        return this.createTranscodingOutputFromModal();
      }
      return null;
    },
    async updatePermissionModalEntity() {
      if (this.permissionModalEntityType === "input") {
        return this.updateInputFromModal();
      }
      if (this.permissionModalEntityType === "output") {
        return this.updateOutputFromModal();
      }
      if (this.permissionModalEntityType === "outputProfile") {
        return this.updateOutputProfileFromModal();
      }
      if (this.permissionModalEntityType === "inputProfile") {
        return this.updateInputProfileFromModal();
      }
      if (this.permissionModalEntityType === "provider") {
        return this.updateProviderFromModal();
      }
      if (this.permissionModalEntityType === "transcodingProfile") {
        return this.updateTranscodingProfileFromModal();
      }
      if (this.permissionModalEntityType === "transcodingOutput") {
        return this.updateTranscodingOutputFromModal();
      }
      return null;
    },
    async createInputFromModal() {
      const draft = cloneDeep(this.permissionModalDraft);
      const { payload, claimsCanAccess, claimsCanEdit } = this.buildPermissionPayloadBase(draft, {
        lastUpdatedField: "inputLastUpdatedById",
      });

      payload.streamFileBaseName = draft.input.streamFileBaseName;
      payload.type = draft.input.type;
      payload.url = draft.input.url;
      payload.inputDownlinkConfigId = draft.input.inputDownlinkConfigId;
      payload.frcAvailable = draft.input.frcAvailable;
      payload.requireDetails = draft.input.requireDetails;
      payload.location = draft.input.locationArray?.length
        ? draft.input.locationArray.join(", ")
        : draft.input.location;

      if (draft.input.type === "MEDIA_CONNECT") {
        const rawName = (draft.input.mcInputName || draft.name || "")
          .replace(/[^a-zA-Z0-9_-]/g, "-")
          .replace(/^[^a-zA-Z0-9]+/, "")
          .replace(/[^a-zA-Z0-9]+$/, "")
          .slice(0, 128);
        const mcConfig = {
          Name: rawName,
          MaximumBitrate: Number(draft.input.mcInputBitrate),
          RoutingScope: draft.input.mcInputRoutingScope,
          Tier: draft.input.mcInputTier,
          Configuration: {
            Standard: {
              NetworkInterfaceArn: draft.input.mcInputNetworkInterfaceArn,
              Protocol: draft.input.mcInputProtocol,
              ProtocolConfiguration: {},
            },
          },
        };

        if (draft.input.mcInputProtocol === "SRT_LISTENER") {
          mcConfig.Configuration.Standard.ProtocolConfiguration.SrtListener = {
            Port: Number(draft.input.mcInputPort),
            MinimumLatencyMilliseconds: Number(draft.input.mcInputLatency),
          };
        } else if (draft.input.mcInputProtocol === "SRT_CALLER") {
          mcConfig.Configuration.Standard.ProtocolConfiguration.SrtCaller = {
            SourceAddress: draft.input.mcInputSourceAddress,
            SourcePort: Number(draft.input.mcInputSourcePort),
            MinimumLatencyMilliseconds: Number(draft.input.mcInputLatency),
          };
        } else if (draft.input.mcInputProtocol === "RTP") {
          mcConfig.Configuration.Standard.ProtocolConfiguration.Rtp = {
            Port: Number(draft.input.mcInputPort),
          };
        } else if (draft.input.mcInputProtocol === "RIST") {
          mcConfig.Configuration.Standard.ProtocolConfiguration.Rist = {
            Port: Number(draft.input.mcInputPort),
            RecoveryLatencyMilliseconds: Number(draft.input.mcInputRecoveryLatency),
          };
        }

        try {
          const result = await this.createMediaConnectInputInStore(mcConfig);
          if (!result?.success) {
            throw new Error(result?.message || result?.error || "Unknown error");
          }
          const resultData = result.data || {};
          payload.config = JSON.stringify({
            routerInputArn: resultData.Arn || null,
            inputArn: resultData.Arn || null,
            inputId: resultData.Id || null,
            inputName: resultData.Name || null,
            inputState: resultData.State || null,
            inputType: resultData.InputType || null,
            ipAddress: resultData.IpAddress || null,
            regionName: resultData.RegionName || null,
            availabilityZone: resultData.AvailabilityZone || null,
          });
        } catch (error) {
          this.$message({
            message: error.message || String(error),
            type: "error",
            duration: 10000,
            showClose: true,
          });
          throw error;
        }
      } else if (draft.input.createInterface) {
        const interfaceResult = await this.createStreamRouterInterfaceForInput(draft.input);
        if (!interfaceResult) throw new Error("Failed to create interface");
        payload.url = draft.input.destination.url;
      }

      const result = await this.createInput(payload);
      if (result?.error) throw new Error(result.message || "Failed to create input");

      await Promise.all(this.getSelectedAccountsByIds(draft.accountIds).map((account) => this.createInputAccountMap({
          claimsCanAccess,
          claimsCanEdit,
          inputAccountMapAccountsId: account.id,
          inputAccountMapLastUpdatedById: this.userId,
          inputAccountMapInputId: result.id,
        })));

      await this.listInputs();
      this.select(this.inputs, "input");
      return result;
    },
    async createLocationFromModal() {
      const draft = cloneDeep(this.permissionModalDraft);
      const payload = {
        name: String(draft.name || "").trim(),
        code: String(draft.location?.code || "").trim(),
        type: String(draft.location?.type || "").trim(),
      };

      if (draft.id) payload.id = draft.id;
      if (draft.description) payload.description = draft.description;

      const result = await this.addLocation(payload);
      this.ensureMutationSucceeded(result, "Failed to create location");

      this.select(this.locations || [], "locations");
      return result;
    },
    async updateInputFromModal() {
      const draft = cloneDeep(this.permissionModalDraft);
      const { payload } = this.buildPermissionPayloadBase(draft, {
        includeVersion: true,
      });

      payload.id = draft.id;
      payload.streamFileBaseName = draft.input.streamFileBaseName;
      payload.type = draft.input.type;
      payload.url = draft.input.url;
      payload.inputDownlinkConfigId = draft.input.inputDownlinkConfigId;
      payload.frcAvailable = draft.input.frcAvailable;
      payload.requireDetails = draft.input.requireDetails;
      payload.location = draft.input.locationArray?.length
        ? draft.input.locationArray.join(", ")
        : draft.input.location;

      const result = await this.updateInput(payload);
      if (result?.error) throw new Error(result.message || "Failed to update input");

      await this.listInputs();
      this.select(this.inputs, "input");
      return result;
    },
    async createOutputFromModal() {
      const draft = cloneDeep(this.permissionModalDraft);
      const { payload, claimsCanAccess, claimsCanEdit } = this.buildPermissionPayloadBase(draft, {
        lastUpdatedField: "outputLastUpdatedById",
      });

      draft.output.ottServer = draft.output.wowzaServerId || draft.output.ottServer;
      draft.output.ottApplication = draft.output.wowzaApplicationId || draft.output.ottApplication;
      draft.output.location = this.getPreferredOutputLocation(
        draft.output.outputType,
        draft.output.location
      );

      if (draft.output.outputType === "ROUTE") {
        draft.output.smEndpoints = this.sanitizeRouteEndpoints(draft.output.smEndpoints, {
          interfaceId: draft.output.interfaceId,
          interfaceName: draft.output.interfaceName,
          streamManagerId: draft.output.streamRouterId,
          interfaceDescription: draft.output.interfaceDescription,
        });
      }

      if (draft.output.outputType === "OTT" && draft.output.createWowzaTarget) {
        const wowzaResult = await this.createWowzaTargetForOutput(draft.output);
        if (!wowzaResult) throw new Error("Failed to create Wowza target");
      }

      if (draft.output.outputType === "MEDIA_CONNECT" && draft.output.allowExternalConfigUpdate) {
        const mediaConnectResult = await this.createMediaConnectOutputForOutput(draft.output);
        if (!mediaConnectResult) throw new Error("Failed to create MediaConnect output");
      }

      Object.assign(payload, this.buildOutputPayload({
        ...draft.output,
        name: draft.name,
      }));

      const result = await this.createOutput(payload);
      if (result?.error) throw new Error(result.message || "Failed to create output");

      await Promise.all(this.getSelectedAccountsByIds(draft.accountIds).map((account) => this.createOutputAccountMap({
          claimsCanAccess,
          claimsCanEdit,
          outputAccountMapAccountsId: account.id,
          outputAccountMapLastUpdatedById: this.userId,
          outputAccountMapOutputId: result.id,
        })));

      await this.listOutputs();
      this.select(this.outputs, "output");
      return result;
    },
    async updateOutputFromModal() {
      const draft = cloneDeep(this.permissionModalDraft);
      const { payload } = this.buildPermissionPayloadBase(draft, {
        includeVersion: true,
      });

      payload.id = draft.id;
      draft.output.ottServer = draft.output.wowzaServerId || draft.output.ottServer;
      draft.output.ottApplication = draft.output.wowzaApplicationId || draft.output.ottApplication;
      draft.output.location = this.getPreferredOutputLocation(
        draft.output.outputType,
        draft.output.location
      );

      if (draft.output.outputType === "ROUTE") {
        draft.output.smEndpoints = this.sanitizeRouteEndpoints(draft.output.smEndpoints, {
          interfaceId: draft.output.interfaceId,
          interfaceName: draft.output.interfaceName,
          streamManagerId: draft.output.streamRouterId,
          interfaceDescription: draft.output.interfaceDescription,
        });
      }

      if (
        draft.output.outputType === "OTT" &&
        draft.output.allowExternalConfigUpdate &&
        draft.output.wowzaTargetConfig
      ) {
        const wowzaUpdateResult = await this.updateWowzaTargetForOutput(draft.output);
        if (draft.output.wowzaTargetId && !wowzaUpdateResult) {
          throw new Error("Failed to update Wowza target");
        }
      }

      if (draft.output.outputType === "MEDIA_CONNECT" && draft.output.allowExternalConfigUpdate) {
        const mediaConnectUpdateResult = await this.updateMediaConnectOutputForOutput(draft.output);
        if (!mediaConnectUpdateResult) throw new Error("Failed to update MediaConnect output");
      }

      Object.assign(payload, this.buildOutputPayload({
        ...draft.output,
        name: draft.name,
      }));

      const result = await this.updateOutput(payload);
      if (result?.error) throw new Error(result.message || "Failed to update output");

      await this.listOutputs();
      this.select(this.outputs, "output");
      return result;
    },
    async createOutputProfileFromModal() {
      const draft = cloneDeep(this.permissionModalDraft);
      const { payload, claimsCanAccess, claimsCanEdit } = this.buildPermissionPayloadBase(draft, {
        lastUpdatedField: "outputProfileLastUpdatedById",
      });

      const result = await this.createOutputProfile(payload);
      if (result?.error) throw new Error(result.message || "Failed to create output profile");

      await Promise.all(draft.outputIds.map((outputId) => this.createOutputProfileOutputMap({
          claimsCanAccess,
          claimsCanEdit,
          outputProfileOutputMapOutputId: outputId,
          outputProfileOutputMapOutputProfileId: result.id,
          outputProfileOutputMapLastUpdatedById: this.userId,
        })));

      await this.listOutputProfiles();
      this.select(this.outputProfiles, "outputProfile");
      return result;
    },
    async updateOutputProfileFromModal() {
      const draft = cloneDeep(this.permissionModalDraft);
      const { payload, claimsCanAccess, claimsCanEdit } = this.buildPermissionPayloadBase(draft, {
        includeVersion: true,
      });

      payload.id = draft.id;
      const result = await this.updateOutputProfile(payload);
      if (result?.error) throw new Error(result.message || "Failed to update output profile");

      const outputsToMap = draft.outputIds.filter((outputId) => !draft.originalOutputs.includes(outputId));
      const mappingsToDelete = draft.outputMapping.filter(
        (map) => !draft.outputIds.includes(map.output.id)
      );

      await Promise.all(outputsToMap.map((outputId) => this.createOutputProfileOutputMap({
          claimsCanAccess,
          claimsCanEdit,
          outputProfileOutputMapOutputId: outputId,
          outputProfileOutputMapOutputProfileId: draft.id,
          outputProfileOutputMapLastUpdatedById: this.userId,
        })));

      await Promise.all(mappingsToDelete.map((map) => this.deleteOutputProfileOutputMap({ id: map.id })));

      await this.listOutputProfiles();
      this.select(this.outputProfiles, "outputProfile");
      return result;
    },
    buildInputProfilePayloadFields(payload, draft) {
      payload.config = draft.inputProfile.config || "{}";
      payload.location = draft.inputProfile.location;
      payload.supportedTypes = draft.inputProfile.supportedTypes;
      payload.inputProfileProviderId = draft.inputProfile.inputProfileProviderId || null;
      return payload;
    },
    async createInputProfileFromModal() {
      const draft = cloneDeep(this.permissionModalDraft);
      const { payload, claimsCanAccess, claimsCanEdit } = this.buildPermissionPayloadBase(draft, {
        lastUpdatedField: "inputProfileLastUpdatedById",
      });
      this.buildInputProfilePayloadFields(payload, draft);

      const result = await this.createInputProfile(payload);
      if (result?.error) throw new Error(result.message || "Failed to create input profile");

      await Promise.all(draft.inputProfile.inputIds.map((inputId) => this.createInputProfileInputMap({
        claimsCanAccess,
        claimsCanEdit,
        inputProfileInputMapInputId: inputId,
        inputProfileInputMapInputProfileId: result.id,
        inputProfileInputMapLastUpdatedById: this.userId,
      })));

      await this.listInputProfiles();
      this.select(this.inputProfiles, "inputProfile");
      return result;
    },
    async updateInputProfileFromModal() {
      const draft = cloneDeep(this.permissionModalDraft);
      const { payload, claimsCanAccess, claimsCanEdit } = this.buildPermissionPayloadBase(draft, {
        includeVersion: true,
      });

      payload.id = draft.id;
      this.buildInputProfilePayloadFields(payload, draft);

      const result = await this.updateInputProfile(payload);
      if (result?.error) throw new Error(result.message || "Failed to update input profile");

      const { inputIds } = draft.inputProfile;
      const inputsToMap = inputIds.filter((inputId) => !draft.originalInputs.includes(inputId));
      const mappingsToDelete = draft.inputMapping.filter((map) => !inputIds.includes(map.input.id));

      await Promise.all(inputsToMap.map((inputId) => this.createInputProfileInputMap({
        claimsCanAccess,
        claimsCanEdit,
        inputProfileInputMapInputId: inputId,
        inputProfileInputMapInputProfileId: draft.id,
        inputProfileInputMapLastUpdatedById: this.userId,
      })));

      await Promise.all(mappingsToDelete.map((map) => this.deleteInputProfileInputMap({ id: map.id })));

      await this.listInputProfiles();
      this.select(this.inputProfiles, "inputProfile");
      return result;
    },
    async createProviderFromModal() {
      const draft = cloneDeep(this.permissionModalDraft);
      const { payload } = this.buildPermissionPayloadBase(draft, {
        lastUpdatedField: "providerLastUpdatedById",
      });
      // Provider has no description field in the schema
      delete payload.description;
      payload.contactDetails = draft.provider.contactDetails;
      payload.instructions = draft.provider.instructions;

      const result = await this.createProvider(payload);
      if (result?.error) throw new Error(result.message || "Failed to create provider");

      await this.listProviders();
      this.select(this.providers, "provider");
      return result;
    },
    async updateProviderFromModal() {
      const draft = cloneDeep(this.permissionModalDraft);
      const { payload } = this.buildPermissionPayloadBase(draft, {
        includeVersion: true,
      });

      delete payload.description;
      payload.id = draft.id;
      payload.contactDetails = draft.provider.contactDetails;
      payload.instructions = draft.provider.instructions;

      const result = await this.updateProvider(payload);
      if (result?.error) throw new Error(result.message || "Failed to update provider");

      await this.listProviders();
      this.select(this.providers, "provider");
      return result;
    },
    async createTranscodingProfileFromModal() {
      const draft = cloneDeep(this.permissionModalDraft);
      const { payload } = this.buildPermissionPayloadBase(draft, {
        lastUpdatedField: "transcodingProfileLastUpdatedById",
      });

      payload.type = draft.transcoding.type;
      payload.config = draft.transcoding.config;

      const result = this.ensureMutationSucceeded(
        await this.createTranscodingProfile(payload),
        "Failed to create transcoding Channel"
      );

      await this.listTranscodingProfiles();
      this.select(this.transcodingProfiles, "transcodingProfile");
      return result;
    },
    async updateTranscodingProfileFromModal() {
      const draft = cloneDeep(this.permissionModalDraft);
      const { payload } = this.buildPermissionPayloadBase(draft, {
        includeVersion: true,
      });

      payload.id = draft.id;
      payload.type = draft.transcoding.type;
      payload.config = draft.transcoding.config;

      const result = this.ensureMutationSucceeded(
        await this.updateTranscodingProfile(payload),
        "Failed to update transcoding Channel"
      );

      await this.listTranscodingProfiles();
      this.select(this.transcodingProfiles, "transcodingProfile");
      return result;
    },
    async createTranscodingOutputFromModal() {
      if (!this.transcodingOutputValid) {
        throw new Error("Please fill in all required fields in the Transcoding Output Configuration.");
      }

      const draft = cloneDeep(this.permissionModalDraft);
      const { payload } = this.buildPermissionPayloadBase(draft, {
        lastUpdatedField: "transcodingOutputLastUpdatedById",
      });

      payload.type = draft.transcoding.type;
      payload.config = draft.transcoding.config;

      const result = this.ensureMutationSucceeded(
        await this.createTranscodingOutput(payload),
        "Failed to create transcoding output"
      );

      await this.listTranscodingOutputs();
      this.select(this.transcodingOutputs, "transcodingOutput");
      return result;
    },
    async updateTranscodingOutputFromModal() {
      if (!this.transcodingOutputValid) {
        throw new Error("Please fill in all required fields in the Transcoding Output Configuration.");
      }

      const draft = cloneDeep(this.permissionModalDraft);
      const { payload } = this.buildPermissionPayloadBase(draft, {
        includeVersion: true,
      });

      payload.id = draft.id;
      payload.type = draft.transcoding.type;
      payload.config = draft.transcoding.config;

      const result = this.ensureMutationSucceeded(
        await this.updateTranscodingOutput(payload),
        "Failed to update transcoding output"
      );

      await this.listTranscodingOutputs();
      this.select(this.transcodingOutputs, "transcodingOutput");
      return result;
    },
    togglePermission(claim, object) {
      const hasClaim = object.indexOf(claim) > -1;
      if (hasClaim) object.splice(object.indexOf(claim), 1);
      if (!hasClaim) object.push(claim);
    },

    async deleteItem(item, index, type) {
      const newItem = {
        id: item.id,
        expectedVersion: item.version,
      };

      let result = null;
      switch (type) {
        case "transcoderProfiles":
          result = await this.deleteTranscoderProfile(newItem);
          break;
        case "transcodingProfile":
          result = await this.deleteTranscodingProfile(newItem);
          break;
        case "transcodingOutput":
          result = await this.deleteTranscodingOutput(newItem);
          break;
        case "routers": {
          let sources = [];
          let destinations = [];
          const groups = [];
          item.routerGroups.forEach(async (el) => {
            sources = el.sources.items.map((map) => map.id);
            destinations = el.destinations.items.map((map) => map.id);
            groups.push(el.id);
          });

          sources.forEach(async (el) => {
            await this.deleteRouterSourceGroupMap({ id: el });
          });

          destinations.forEach(async (el) => {
            await this.deleteRouterDestinationGroupMap({ id: el });
          });

          groups.forEach(async (el) => {
            await this.deleteRouterGroup({ id: el });
          });
          result = await this.deleteRouter(newItem);
          break;
        }
        case "multiviewer":
          item.originalStreamSources.forEach(async (el) => {
            await this.deleteStreamSourceMultiviewerMap({ id: el.id });
          });
          result = await this.deleteMultiviewer(newItem);
          break;
        case "input":
          item.accounts.items.forEach(async (el) => {
            await this.deleteInputAccountMap({ id: el.id });
          });
          item.broadcastSources.items.forEach(async (el) => {
            await this.deleteInputRouterSourceMap({ id: el.id });
          });
          // item.equipment.items.forEach(async (el) => {
          //   await this.deleteInputEquipmentMap({ id: el.id });
          // });
          result = await this.deleteInput(newItem);
          break;
        case "output":
          // Check if already marked as DELETED - if so, permanently delete
          if (item.status === "DELETED") {
            item.accounts.items.forEach(async (el) => {
              await this.deleteOutputAccountMap({ id: el.id });
            });
            // item.equipment.items.forEach(async (el) => {
            //   await this.deleteOutputEquipmentMap({ id: el.id });
            // });
            item.broadcastDestinations.items.forEach(async (el) => {
              await this.deleteOutputRouterDestinationMap({ id: el.id });
            });
            item.events.items.forEach(async (el) => {
              await this.deleteEventOutputMap({ id: el.id });
            });
            item.outputProfiles.items.forEach(async (el) => {
              await this.deleteOutputProfileOutputMap({ id: el.id });
            });

            // Permanently delete the output
            result = await this.deleteOutput(newItem);

            // Remove from sorted list
            this.sortedList = this.sortedList.filter((el) => el.id !== item.id);
          } else {
            // First deletion - just mark as DELETED
            const newOutput = {
              id: item.id,
              name: item.name,
              description: item.description,
              expectedVersion: item.version,
              claimsCanAccess: item.claimsCanAccess,
              claimsCanEdit: item.claimsCanEdit,
              outputType: item.outputType,
              status: "DELETED",
              url: item.url,
              ottApplication: item.ottApplication,
              ottNoStremKeyRequired: item.ottNoStremKeyRequired,
              ottPlatform: item.ottPlatform,
              ottServer: item.ottServer,
              displayName: item.displayName,
              ottDefaultTranscoderProfile: item.ottDefaultTranscoderProfile,
            };

            result = await this.updateOutput(newOutput);

            // Don't remove from list - keep it visible with DELETED status
          }

          await this.listOutputs();
          this.select(this.outputs, "output");
          break;
        case "outputProfile":
          item.outputMapping.forEach(async (el) => {
            await this.deleteOutputProfileOutputMap({ id: el.id });
          });
          result = await this.deleteOutputProfile(newItem);
          break;
        case "inputProfile":
          await Promise.all(item.inputMapping
            .map((el) => this.deleteInputProfileInputMap({ id: el.id })));
          result = await this.deleteInputProfile(newItem);
          await this.listInputProfiles();
          this.select(this.inputProfiles, "inputProfile");
          break;
        case "provider":
          result = await this.deleteProvider(newItem);
          await this.listProviders();
          this.select(this.providers, "provider");
          break;
        case "locations":
          result = await this.removeLocation(item.id);
          if (!result?.error) {
            await this.listLocationss();
            this.select(this.locations || [], "locations");
          }
          break;
        case "routerGroups":
          item.originalDestinations.forEach(async (el) => {
            await this.deleteRouterDestinationGroupMap({ id: el.id });
          });
          item.originalSources.forEach(async (el) => {
            await this.deleteRouterSourceGroupMap({ id: el.id });
          });
          result = await this.deleteRouterGroup(newItem);
          break;
        case "sources":
          item.originalRouterGroups.forEach(async (el) => {
            await this.deleteRouterSourceGroupMap({ id: el.id });
          });
          item.originalMappedInputs.forEach(async (el) => {
            await this.deleteInputRouterSourceMap({ id: el.id });
          });
          result = await this.deleteRouterSource(newItem);
          break;
        case "destinations":
          item.originalRouterGroups.forEach(async (el) => {
            await this.deleteRouterDestinationGroupMap({ id: el.id });
          });
          item.originalMappedOutputs.forEach(async (el) => {
            await this.deleteOutputRouterDestinationMap({ id: el.id });
          });
          result = await this.deleteRouterDestination(newItem);
          break;
        case "streamSources":
          result = await this.deleteStreamSource(newItem);
          break;
        case "streamDestinations":
          result = await this.deleteStreamDestination(newItem);
          break;
        default:
          break;
      }
      if (result.error) this.$message.error("Failed to delete item");
      
      // Only filter out items for non-output types (outputs handle their own removal)
      if (type !== "output") {
        this.sortedList = this.sortedList.filter((el) => el.id !== item.id);
      }

      console.log("sadads", this.activeList);
      this.$forceUpdate();
    },

    async addItem(item) {
      if (this.formType === 'transcodingOutput' && !this.transcodingOutputValid) {
        const errors = this.transcodingOutputErrors || [];
        const msg = errors.length > 0
          ? `Please fix the following validation errors:\n- ${errors.slice(0, 3).join('\n- ')}${errors.length > 3 ? '\n... and more' : ''}`
          : "Please fill in all required fields in the Transcoding Output Configuration.";

        try {
          await this.$confirm(msg, 'Validation Error', {
            confirmButtonText: 'OK',
            showCancelButton: false,
            type: 'error'
          });
        } catch (e) {
          // Ignore cancel error from $confirm
        }
        return;
      }
      const isFormValid = await this.$refs.addItemForm.validate();
      if (!isFormValid) return;
      this.addItemLoading = true;

      const newClaimsCanEdit = item.claimsCanEdit.map((claim) => claim[claim.length - 1]);
      const newClaimsCanAccess = item.claimsCanAccess.map((claim) => claim[claim.length - 1]);
      const newItem = {
        name: item.name,
        claimsCanAccess: newClaimsCanAccess,
        claimsCanEdit: newClaimsCanEdit,
      };

      // check if description is provided
      const hasDescription = !!item.description;
      if (hasDescription) newItem.description = item.description;
      // assign id if specified
      const hasId = !!item.id;
      if (hasId) newItem.id = item.id;

      newItem[`${this.formType}LastUpdatedById`] = this.userId;

      let result = null;
      switch (this.formType) {
        case "transcoderProfile":
          newItem.transcoderProfile = item.transcoderProfile.transcoderProfile;
          result = await this.createTranscoderProfile(newItem);

          if (result.error) return;
          await this.listTranscoderProfiles();
          if (this.listType === this.formType)
            this.select(this.transcoderProfiles, "transcoderProfiles");
          break;

        case "multiviewer":
          newItem.grid = item.multiviewer.grid;
          newItem.type = item.multiviewer.type;
          newItem.audioControlId = item.multiviewer.audioControlId;
          newItem.routableDestinationId = item.multiviewer.routableDestinationId;

          result = await this.createMultiviewer(newItem);

          if (result.error) return;
          // mapping sources
          item.multiviewer.streamSources.forEach(async (source, index) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              sortOrder: index,
              name: newItem.name,
              streamSourceMultiviewerMapStreamSourceId: source,
              streamSourceMultiviewerMapMultiviewerId: result.id,
              streamSourceMultiviewerMapLastUpdatedById: this.userId,
            };
            await this.createStreamSourceMultiviewerMap(newMapping);
          });

          await this.listMultiviewers();
          if (this.listType === this.formType) this.select(this.multiviewers, "multiviewers");
          break;

        case "transcodingProfile":
          newItem.type = item.transcoding.type;
          newItem.config = item.transcoding.config;
          result = await this.createTranscodingProfile(newItem);
          if (this.extractMutationErrorMessage(result, "Failed to create transcoding Channel")) {
            this.addItemLoading = false;
            return;
          }
          await this.listTranscodingProfiles();
          if (this.listType === this.formType) this.select(this.transcodingProfiles, "transcodingProfile");
          break;

        case "transcodingOutput":
          if (!this.transcodingOutputValid) {
            this.$message.error("Please fill in all required fields in the Transcoding Output Configuration.");
            return;
          }
          newItem.type = item.transcoding.type;
          newItem.config = item.transcoding.config;
          result = await this.createTranscodingOutput(newItem);
          if (this.extractMutationErrorMessage(result, "Failed to create transcoding output")) {
            this.addItemLoading = false;
            return;
          }
          await this.listTranscodingOutputs();
          if (this.listType === this.formType) this.select(this.transcodingOutputs, "transcodingOutput");
          break;

        case "input":
          newItem.streamFileBaseName = item.input.streamFileBaseName;
          newItem.type = item.input.type;
          newItem.url = item.input.url;
          newItem.inputDownlinkConfigId = item.input.inputDownlinkConfigId;
          newItem.frcAvailable = item.input.frcAvailable;
          newItem.requireDetails = item.input.requireDetails;
          // Convert locationArray to comma-separated string
          newItem.location = item.input.locationArray && item.input.locationArray.length > 0
            ? item.input.locationArray.join(', ')
            : item.input.location;

          // Handle Stream Router Interface creation
          if (item.input.type === 'MEDIA_CONNECT') {
            // Sanitize name: only letters, numbers, dashes, underscores allowed; first/last must be alphanumeric
            const rawName = (item.input.mcInputName || item.name || '').replace(/[^a-zA-Z0-9_-]/g, '-').replace(/^[^a-zA-Z0-9]+/, '').replace(/[^a-zA-Z0-9]+$/, '').slice(0, 128);
            const mcConfig = {
              Name: rawName,
              MaximumBitrate: Number(item.input.mcInputBitrate),
              RoutingScope: item.input.mcInputRoutingScope,
              Tier: item.input.mcInputTier,
              Configuration: {
                Standard: {
                  NetworkInterfaceArn: item.input.mcInputNetworkInterfaceArn,
                  Protocol: item.input.mcInputProtocol,
                  ProtocolConfiguration: {}
                }
              }
            };
            if (item.input.mcInputProtocol === 'SRT_LISTENER') {
              mcConfig.Configuration.Standard.ProtocolConfiguration.SrtListener = {
                Port: Number(item.input.mcInputPort),
                MinimumLatencyMilliseconds: Number(item.input.mcInputLatency)
              };
            } else if (item.input.mcInputProtocol === 'SRT_CALLER') {
              mcConfig.Configuration.Standard.ProtocolConfiguration.SrtCaller = {
                SourceAddress: item.input.mcInputSourceAddress,
                SourcePort: Number(item.input.mcInputSourcePort),
                MinimumLatencyMilliseconds: Number(item.input.mcInputLatency)
              };
            } else if (item.input.mcInputProtocol === 'RTP') {
              mcConfig.Configuration.Standard.ProtocolConfiguration.Rtp = {
                Port: Number(item.input.mcInputPort)
              };
            } else if (item.input.mcInputProtocol === 'RIST') {
              mcConfig.Configuration.Standard.ProtocolConfiguration.Rist = {
                Port: Number(item.input.mcInputPort),
                RecoveryLatencyMilliseconds: Number(item.input.mcInputRecoveryLatency)
              };
            }

            try {
              const result = await this.createMediaConnectInputInStore(mcConfig);
              if (!result?.success) {
                throw new Error(result?.message || result?.error || 'Unknown error');
              }
              const resultData = result.data || {};
              newItem.config = JSON.stringify({
                routerInputArn: resultData.Arn || null,
                inputArn: resultData.Arn || null,
                inputId: resultData.Id || null,
                inputName: resultData.Name || null,
                inputState: resultData.State || null,
                inputType: resultData.InputType || null,
                ipAddress: resultData.IpAddress || null,
                regionName: resultData.RegionName || null,
                availabilityZone: resultData.AvailabilityZone || null,
              });
            } catch (e) {
              console.error(e);
              this.$message({ message: e.message || String(e), type: 'error', duration: 10000, showClose: true });
              this.addItemLoading = false;
              return;
            }
          } else if (item.input.createInterface) {
            const interfaceResult = await this.createStreamRouterInterfaceForInput(item.input);
            if (interfaceResult) {
              // Update the URL from the interface destination
              newItem.url = item.input.destination.url;
            } else {
              // If interface creation failed, don't continue with input creation
              return;
            }
          }

          result = await this.createInput(newItem);

          if (result.error) return;

          item.accounts.forEach(async (account) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              inputAccountMapAccountsId: account.id,
              inputAccountMapLastUpdatedById: this.userId,
              inputAccountMapInputId: result.id,
            };

            await this.createInputAccountMap(newMapping);
          });
          await this.listInputs();
          if (this.listType === this.formType) this.select(this.inputs, "input");
          break;
        case "output":
          item.output.ottServer = item.output.wowzaServerId || item.output.ottServer;
          item.output.ottApplication = item.output.wowzaApplicationId || item.output.ottApplication;
          item.output.location = this.getPreferredOutputLocation(
            item.output.outputType,
            item.output.location
          );

          if (item.output.outputType === "ROUTE") {
            item.output.smEndpoints = this.sanitizeRouteEndpoints(item.output.smEndpoints, {
              interfaceId: item.output.interfaceId,
              interfaceName: item.output.interfaceName,
              streamManagerId: item.output.streamRouterId,
              interfaceDescription: item.output.interfaceDescription,
            });
          }

          if (item.output.outputType === "OTT" && item.output.createWowzaTarget) {
            const targetResult = await this.createWowzaTargetForOutput(item.output);
            if (!targetResult) {
              this.addItemLoading = false;
              return;
            }
          }

          if (item.output.outputType === "MEDIA_CONNECT" && item.output.allowExternalConfigUpdate) {
            const mediaConnectResult = await this.createMediaConnectOutputForOutput(item.output);
            if (!mediaConnectResult) {
              this.addItemLoading = false;
              return;
            }
          }

          Object.assign(newItem, this.buildOutputPayload({
            ...item.output,
            name: newItem.name,
          }));

          result = await this.createOutput(newItem);

          if (result.error) return;

          item.accounts.forEach(async (account) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              outputAccountMapAccountsId: account.id,
              outputAccountMapLastUpdatedById: this.userId,
              outputAccountMapOutputId: result.id,
            };

            await this.createOutputAccountMap(newMapping);
          });

          await this.listOutputs();
          if (this.listType === this.formType) this.select(this.outputs, "output");
          break;
        case "outputProfile":
          result = await this.createOutputProfile(newItem);
          if (result.error) return;
          // mapping outputs
          item.outputProfile.outputs.forEach(async (output) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              outputProfileOutputMapOutputId: output,
              outputProfileOutputMapOutputProfileId: result.id,
              outputProfileOutputMapLastUpdatedById: this.userId,
            };
            await this.createOutputProfileOutputMap(newMapping);
          });

          await this.listOutputProfiles();
          if (this.listType === this.formType) this.select(this.outputProfiles, "outputProfile");
          break;
        case "router":
          newItem.routerAccountId = item.router.routerAccountId.id;
          result = await this.createRouter(newItem);
          await this.listRouters();
          await this.listRouterGroups();
          break;
        case "routerGroup": {
          const { routerGroup } = item;
          newItem.routerGroupRouterId = routerGroup.routerGroupRouterId;
          result = await this.createRouterGroup(newItem);
          if (result.error) return;

          routerGroup.destinations.forEach(async (dest) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              routerDestinationGroupMapRouterDestinationId: dest.id,
              routerDestinationGroupMapRouterGroupId: result.id,
              routerDestinationGroupMapLastUpdatedById: this.userId,
            };
            await this.createRouterDestinationGroupMap(newMapping);
          });

          routerGroup.sources.forEach(async (source) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              routerSourceGroupMapRouterSourceId: source.id,
              routerSourceGroupMapRouterGroupId: result.id,
              routerSourceGroupMapLastUpdatedById: this.userId,
            };
            await this.createRouterSourceGroupMap(newMapping);
          });
          await this.listRouterGroups();
          await this.listRouters();
          break;
        }
        case "routerSource": {
          const { routerSource } = item;
          newItem.originRouterGroup = routerSource.originRouterGroup;
          newItem.originRouterId = routerSource.originRouterId;
          newItem.originRouterSourceId = routerSource.originRouterSourceId;
          result = await this.createRouterSource(newItem);
          if (result.error) return;

          routerSource.mappedInputs.forEach(async (input) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              inputRouterSourceMapInputId: input.id,
              inputRouterSourceMapRouterSourceId: result.id,
              inputRouterSourceMapLastUpdatedById: this.userId,
            };
            await this.createInputRouterSourceMap(newMapping);
          });

          await this.listRouterSources();
          break;
        }
        case "routerDestination": {
          const { routerDestination } = item;
          newItem.originRouterDestinationId = routerDestination.originRouterDestinationId;
          newItem.originRouterGroup = routerDestination.originRouterGroup;
          newItem.originRouterId = routerDestination.originRouterId;

          if (routerDestination.routerDestinationRoutedSourceId) {
            const { routerDestinationRoutedSourceId } = routerDestination;
            newItem.routerDestinationRoutedSourceId = routerDestinationRoutedSourceId;
          }
          if (routerDestination.routerDestinationDefaultSourceId) {
            const { routerDestinationDefaultSourceId } = routerDestination;
            newItem.routerDestinationDefaultSourceId = routerDestinationDefaultSourceId.id;
          }
          result = await this.createRouterDestination(newItem);
          if (result.error) return;

          routerDestination.mappedOutputs.forEach(async (output) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              outputRouterDestinationMapOutputId: output.id,
              outputRouterDestinationMapRouterDestinationId: result.id,
              outputRouterDestinationMapLastUpdatedById: this.userId,
            };
            await this.createOutputRouterDestinationMap(newMapping);
          });
          await this.listRouterDestinations();
          break;
        }
        case "streamSource": {
          const { streamSource } = item;
          if (streamSource.type) newItem.type = streamSource.type;
          if (streamSource.port) newItem.port = streamSource.port;
          if (streamSource.address) newItem.address = streamSource.address;
          if (streamSource.talkbackAddress) newItem.talkbackAddress = streamSource.talkbackAddress;
          if (streamSource.talkbackPort) newItem.talkbackPort = streamSource.talkbackPort;
          if (streamSource.latencyMs) newItem.latencyMs = streamSource.latencyMs;

          if (streamSource.bufferMaxMs) newItem.bufferMaxMs = streamSource.bufferMaxMs;
          if (streamSource.bufferMinMs) newItem.bufferMinMs = streamSource.bufferMinMs;

          if (streamSource.encPassphrase) newItem.encPassphrase = streamSource.encPassphrase;
          if (streamSource.encKeyLen) newItem.encKeyLen = streamSource.encKeyLen;
          if (streamSource.encType) newItem.encType = streamSource.encType;
          if (streamSource.udpAddress) newItem.udpAddress = streamSource.udpAddress;
          if (streamSource.udpPort) newItem.udpPort = streamSource.udpPort;

          result = await this.createStreamSource(newItem);
          if (result.error) return;
          await this.listStreamSources();
          break;
        }
        case "streamDestination": {
          const { streamDestination } = item;
          newItem.streamDestinationRouterDestinationId =
            streamDestination.streamDestinationRouterDestinationId;

          if (streamDestination.type) newItem.type = streamDestination.type;
          if (streamDestination.address) newItem.address = streamDestination.address;

          if (streamDestination.port) newItem.port = streamDestination.port;
          if (streamDestination.talkbackAddress)
            newItem.talkbackAddress = streamDestination.talkbackAddress;
          if (streamDestination.talkbackPort) newItem.talkbackPort = streamDestination.talkbackPort;
          if (streamDestination.latencyMs) newItem.latencyMs = streamDestination.latencyMs;

          if (streamDestination.bufferMaxMs) newItem.bufferMaxMs = streamDestination.bufferMaxMs;
          if (streamDestination.bufferMinMs) newItem.bufferMinMs = streamDestination.bufferMinMs;
          if (streamDestination.encPassphrase)
            newItem.encPassphrase = streamDestination.encPassphrase;
          if (streamDestination.encKeyLen) newItem.encKeyLen = streamDestination.encKeyLen;
          if (streamDestination.encType) newItem.encType = streamDestination.encType;
          if (streamDestination.udpAddress) newItem.udpAddress = streamDestination.udpAddress;
          if (streamDestination.udpPort) newItem.udpPort = streamDestination.udpPort;
          if (streamDestination.udpRtt) newItem.udpRtt = streamDestination.udpRtt;

          result = await this.createStreamDestination(newItem);
          if (result.error) return;

          await this.listStreamDestinations();
          break;
        }
        default:
          break;
      }

      this.showAddDialog = false;
      this.addItemLoading = false;
      this.resetForm();
      this.$forceUpdate();
    },

    resetForm() {
      this.form = {
        name: "",
        description: null,
        claimsCanAccess: [],
        claimsCanEdit: [],
        accounts: [],
        transcoderProfile: {
          transcoderProfile: null,
        },
        input: {
          streamFileBaseName: null,
          type: null,
          inputDownlinkConfigId: null,
          url: null,
          frcAvailable: null,
          requireDetails: null,
          probeProjectId: null,
          probeTaskId: null,
          location: null,
          locationArray: [],
          // Stream Router Interface fields
          createInterface: false,
          streamRouterId: null,
          interfaceName: null,
          source: { url: null, type: 'SRT', max_connections: null, latency: null, ttl: null, passphrase: null, stream_id: null, max_bw: null },
          destination: { url: null, type: 'SRT', max_connections: null, latency: null, ttl: null, passphrase: null, stream_id: null, max_bw: null },
          processors: [],
          tags: [],
          whitelist: [],
          autostart: false,
          // AWS MediaConnect fields
          mcInputName: null,
          mcInputBitrate: null,
          mcInputRoutingScope: 'REGIONAL',
          mcInputTier: 'INPUT_50',
          mcInputNetworkInterfaceArn: null,
          mcInputProtocol: null,
          mcInputPort: null,
          mcInputLatency: null,
          mcInputSourceAddress: null,
          mcInputSourcePort: null,
          mcInputRecoveryLatency: null,
        },
        output: {
          ...createDefaultOutputForm(),
        },
        multiviewer: {
          grid: 1,
          streamSources: [],
          routableDestinationId: null,
          type: null,
        },
        outputProfile: {
          outputs: [],
        },
        location: {
          code: null,
          type: "DEFAULT",
        },
        router: {
          routerAccountId: null,
          routerGroups: [],
        },
        routerSource: {
          originRouterGroup: null,
          originRouterId: null,
          originRouterSourceId: null,
          routerGroups: [],
          mappedInputs: [],
        },
        routerDestination: {
          originRouterDestinationId: null,
          originRouterGroup: null,
          originRouterId: null,
          routerDestinationRoutedSourceId: null,
          routerGroups: [],
          inputs: [],
          outputs: [],
        },
        routerGroup: {
          routerGroupRouterId: null,
          sources: [],
          destinations: [],
        },
        streamSource: {
          type: null,
          port: null,
          address: null,
          talkbackAddress: null,
          talkbackPort: null,

          latencyMs: null,
          bufferMaxMs: null,
          bufferMinMs: null,
          encPassphrase: null,
          encKeyLen: null,
          encType: null,
          udpAddress: null,
          udpPort: null,
        },
        streamDestination: {
          type: null,
          streamDestinationRouterDestinationId: null,
          port: null,
          address: null,
          talkbackAddress: null,
          talkbackPort: null,

          latencyMs: null,
          bufferMaxMs: null,
          bufferMinMs: null,
          encPassphrase: null,
          encKeyLen: null,
          encType: null,
          udpAddress: null,
          udpPort: null,
          udpRtt: null,
        },
      };
    },

    async save(item, itemIndex) {
      if (this.listType === 'transcodingOutput' && !this.transcodingOutputValid) {
        const errors = this.transcodingOutputErrors || [];
        const msg = errors.length > 0
          ? `Please fix the following validation errors:\n- ${errors.slice(0, 3).join('\n- ')}${errors.length > 3 ? '\n... and more' : ''}`
          : "Please fill in all required fields in the Transcoding Output Configuration.";

        try {
          await this.$confirm(msg, 'Validation Error', {
            confirmButtonText: 'OK',
            showCancelButton: false,
            type: 'error'
          });
        } catch (e) {
          // Ignore cancel error
        }
        return;
      }
      const index = this.sortedList.findIndex((el) => el.id === item.id);
      this.sortedList[index].saving = true;
      const newClaimsCanEdit = serializeClaimSelections(item.edit);
      const newClaimsCanAccess = serializeClaimSelections(item.access);
      const newItem = {
        id: item.id,
        name: item.name,
        description: item.description,
        expectedVersion: item.version,
        claimsCanAccess: newClaimsCanAccess,
        claimsCanEdit: newClaimsCanEdit,
      };
      let result = null;
      switch (this.listType) {
        case "transcoderProfiles":
          newItem.transcoderProfile = item.transcoderProfile;
          result = await this.updateTranscoderProfile(newItem);
          await this.listTranscoderProfiles();
          this.select(this.transcoderProfiles, "transcoderProfiles");
          // await this.listInputs();
          break;
        case "multiviewer":
          newItem.grid = item.grid;
          newItem.type = item.type;
          newItem.audioControlId = item.audioControlId;
          newItem.routableDestinationId = item.routableDestinationId;
          result = await this.updateMultiviewer(newItem);

          // mapping outputs
          const { originalStreamSources, streamSources } = item;
          const originalStreamSourcesMapings = originalStreamSources.map(
            (map) => map.streamSource.id
          );
          const originalStreamSourcesToMap = streamSources.filter(
            (streamSource) => originalStreamSourcesMapings.indexOf(streamSource.id) === -1
          );
          //  const outputsToMap = item.outputs.filter(
          //   (output) => originalOutputs.indexOf(output.id) === -1,
          // );
          const currentStreamSourcesByMapId = streamSources.map(
            (streamSource) => streamSource.mapId
          );

          originalStreamSources.forEach(async (source, index) => {
            const newSourceIndex = currentStreamSourcesByMapId.indexOf(source.id);
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              sortOrder: newSourceIndex || 0,
              id: source.id,
            };
            await this.updateStreamSourceMultiviewerMap(newMapping);
          });

          const currentStreamSources = streamSources.map((streamSource) => streamSource.id);
          const mappingsToDelete = originalStreamSources.filter(
            (map) => currentStreamSources.indexOf(map.streamSource.id) === -1
          );
          originalStreamSourcesToMap.forEach(async (source) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              sortOrder: index,
              name: newItem.name,
              streamSourceMultiviewerMapStreamSourceId: source.id,
              streamSourceMultiviewerMapMultiviewerId: result.id,
              streamSourceMultiviewerMapLastUpdatedById: this.userId,
            };
            await this.createStreamSourceMultiviewerMap(newMapping);
          });

          mappingsToDelete.forEach(async (map) => {
            const newMap = {
              id: map.id,
            };
            await this.deleteStreamSourceMultiviewerMap(newMap);
          });

          await this.listMultiviewers();
          this.select(this.multiviewers, "multiviewer");
          await this.listMultiviewers();
          break;

        case "transcodingProfile":
          newItem.type = item.type;
          newItem.config = item.config;
          result = await this.updateTranscodingProfile(newItem);
          if (this.extractMutationErrorMessage(result, "Failed to update transcoding Channel")) {
            this.sortedList[index].saving = false;
            return;
          }
          await this.listTranscodingProfiles();
          this.select(this.transcodingProfiles, "transcodingProfile");
          break;

        case "transcodingOutput":
          newItem.type = item.type;
          newItem.config = item.config;
          result = await this.updateTranscodingOutput(newItem);
          if (this.extractMutationErrorMessage(result, "Failed to update transcoding output")) {
            this.sortedList[index].saving = false;
            return;
          }
          await this.listTranscodingOutputs();
          this.select(this.transcodingOutputs, "transcodingOutput");
          break;

        case "input":
          newItem.streamFileBaseName = item.streamFileBaseName;
          newItem.type = item.type;
          newItem.url = item.url;
          newItem.inputDownlinkConfigId = item.inputDownlinkConfigId;
          newItem.frcAvailable = item.frcAvailable;
          newItem.requireDetails = item.requireDetails;
          // Convert locationArray to comma-separated string
          newItem.location = item.locationArray && item.locationArray.length > 0
            ? item.locationArray.join(', ')
            : item.location;
          if (item.probe && item.probe.id) {
            newItem.probeProjectId = item.probe.id;
            newItem.probeTaskId = item.probe.key;
          }
          result = await this.updateInput(newItem);
          await this.listInputs();
          this.select(this.inputs, "input");
          // await this.listInputs();
          break;
        case "output":
          item.ottServer = item.wowzaServerId || item.ottServer;
          item.ottApplication = item.wowzaApplicationId || item.ottApplication;
          item.location = this.getPreferredOutputLocation(item.outputType, item.location);

          if (item.outputType === "ROUTE") {
            item.smEndpoints = this.sanitizeRouteEndpoints(item.smEndpoints, {
              interfaceId: item.interfaceId,
              interfaceName: item.interfaceName,
              streamManagerId: item.streamRouterId,
              interfaceDescription: item.interfaceDescription,
            });
          }

          if (item.outputType === "OTT" && item.allowExternalConfigUpdate && item.wowzaTargetConfig) {
            const wowzaUpdateResult = await this.updateWowzaTargetForOutput(item);
            if (item.wowzaTargetId && !wowzaUpdateResult) {
              this.sortedList[index].saving = false;
              return;
            }
          }

          if (item.outputType === "MEDIA_CONNECT" && item.allowExternalConfigUpdate) {
            const mediaConnectUpdateResult = await this.updateMediaConnectOutputForOutput(item);
            if (!mediaConnectUpdateResult) {
              this.sortedList[index].saving = false;
              return;
            }
          }

          Object.assign(newItem, this.buildOutputPayload(item));
          result = await this.updateOutput(newItem);
          await this.listOutputs();
          this.select(this.outputs, "output");
          break;
        case "outputProfile": {
          result = await this.updateOutputProfile(newItem);
          if (result.error) return;

          // mapping outputs
          const { originalOutputs } = item;
          const outputsToMap = item.outputs.filter(
            (output) => originalOutputs.indexOf(output.id) === -1
          );

          const currentOutputs = item.outputs.map((output) => output.id);
          const mappingsToDelete = item.outputMapping.filter(
            (map) => currentOutputs.indexOf(map.output.id) === -1
          );

          outputsToMap.forEach(async (output) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              outputProfileOutputMapOutputId: output.id,
              outputProfileOutputMapOutputProfileId: item.id,
              outputProfileOutputMapLastUpdatedById: this.userId,
            };
            await this.createOutputProfileOutputMap(newMapping);
          });

          mappingsToDelete.forEach(async (map) => {
            const newMap = {
              id: map.id,
            };
            await this.deleteOutputProfileOutputMap(newMap);
          });

          await this.listOutputProfiles();
          this.select(this.outputProfiles, "outputProfile");
          break;
        }
        case "routers":
          newItem.routerAccountId = item.account.id;
          result = await this.updateRouter(newItem);
          await this.listRouters();
          await this.listRouterGroups();
          this.select(this.routers, "routers");
          this.select(this.routerGroups, "routers");
          // await this.listInputs();
          break;
        case "routerGroups": {
          newItem.routerGroupRouterId = item.router.id;
          result = await this.updateRouterGroup(newItem);
          // mapping outputs
          const { originalDestinations, originalSources, destinations, sources } = item;

          // DESTINATION MAPS
          const originalDestinationsIds = originalDestinations.map((el) => el.routerDestination.id);
          const destsToMap = destinations.filter(
            (el) => originalDestinationsIds.indexOf(el.id) === -1
          );

          const currentDests = item.destinations.map((el) => el.id);
          const destMappingsToDelete = item.originalDestinations.filter(
            (map) => currentDests.indexOf(map.routerDestination.id) === -1
          );

          destsToMap.forEach(async (destination) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              routerDestinationGroupMapRouterDestinationId: destination.id,
              routerDestinationGroupMapRouterGroupId: item.id,
              routerDestinationGroupMapLastUpdatedById: this.userId,
            };
            await this.createRouterDestinationGroupMap(newMapping);
          });

          destMappingsToDelete.forEach(async (map) => {
            const newMap = {
              id: map.id,
            };
            await this.deleteRouterDestinationGroupMap(newMap);
          });

          // SOURCE MAPS
          const originalSourcesIds = originalSources.map((el) => el.routerSource.id);
          const sourcesToMap = sources.filter((el) => originalSourcesIds.indexOf(el.id) === -1);

          const currentSources = sources.map((el) => el.id);
          const sourceMappingsToDelete = originalSources.filter(
            (map) => currentSources.indexOf(map.routerSource.id) === -1
          );

          sourcesToMap.forEach(async (source) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              routerSourceGroupMapRouterSourceId: source.id,
              routerSourceGroupMapRouterGroupId: item.id,
              routerSourceGroupMapLastUpdatedById: this.userId,
            };
            await this.createRouterSourceGroupMap(newMapping);
          });

          sourceMappingsToDelete.forEach(async (map) => {
            const newMap = {
              id: map.id,
            };
            await this.deleteRouterSourceGroupMap(newMap);
          });

          await this.listRouterGroups();
          this.select(this.routerGroups, "routerGroups");
          break;
        }
        case "sources": {
          const { originalMappedInputs } = item;
          newItem.originRouterGroup = item.originRouterGroup;
          newItem.originRouterId = item.originRouterId;
          newItem.originRouterSourceId = item.originRouterSourceId;

          await this.updateRouterSource(newItem);
          // INPUT MAPS
          const inputsToMap = item.mappedInputs.filter(
            (el) => originalMappedInputs.indexOf(el.id) === -1
          );

          const currentInputIds = item.mappedInputs.map((el) => el.id);
          const inputMappingsToDelete = originalMappedInputs.filter(
            (map) => currentInputIds.indexOf(map.input.id) === -1
          );

          inputsToMap.forEach(async (input) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              inputRouterSourceMapInputId: input.id,
              inputRouterSourceMapRouterSourceId: item.id,
              inputRouterSourceMapLastUpdatedById: this.userId,
            };
            await this.createInputRouterSourceMap(newMapping);
          });

          inputMappingsToDelete.forEach(async (map) => {
            const newMap = {
              id: map.id,
            };
            await this.deleteInputRouterSourceMap(newMap);
          });
          await this.listRouterSources();
          this.select(this.routerSources, "sources");
          break;
        }
        case "destinations": {
          const { originalMappedOutputs, mappedOutputs } = item;
          newItem.originRouterDestinationId = item.originRouterDestinationId;
          if (item.routerDestinationDefaultSourceId)
            newItem.routerDestinationDefaultSourceId = item.routerDestinationDefaultSourceId.id;
          newItem.originRouterGroup = item.originRouterGroup;
          newItem.originRouterId = item.originRouterId;

          await this.updateRouterDestination(newItem);
          // INPUT MAPS
          const originalMappedOutputsIds = originalMappedOutputs.map((el) => el.output.id);
          const outputsToMap = mappedOutputs.filter(
            (el) => originalMappedOutputsIds.indexOf(el.id) === -1
          );

          const currentOutputsIds = mappedOutputs.map((el) => el.id);
          const outputMappingsToDelete = originalMappedOutputs.filter(
            (map) => currentOutputsIds.indexOf(map.output.id) === -1
          );

          outputsToMap.forEach(async (output) => {
            const newMapping = {
              claimsCanAccess: newClaimsCanAccess,
              claimsCanEdit: newClaimsCanEdit,
              outputRouterDestinationMapOutputId: output.id,
              outputRouterDestinationMapRouterDestinationId: item.id,
              outputRouterDestinationMapLastUpdatedById: this.userId,
            };
            await this.createOutputRouterDestinationMap(newMapping);
          });
          outputMappingsToDelete.forEach(async (map) => {
            const newMap = {
              id: map.id,
            };
            await this.deleteOutputRouterDestinationMap(newMap);
          });
          await this.listRouterDestinations();
          this.select(this.routerDestinations, "destinations");
          break;
        }
        case "streamSources": {
          if (item.type) newItem.type = item.type;
          if (item.port) newItem.port = item.port;
          if (item.address) newItem.address = item.address;
          if (item.talkbackAddress) newItem.talkbackAddress = item.talkbackAddress;
          if (item.talkbackPort) newItem.talkbackPort = item.talkbackPort;
          if (item.latencyMs) newItem.latencyMs = item.latencyMs;

          if (item.bufferMaxMs) newItem.bufferMaxMs = item.bufferMaxMs;
          if (item.bufferMinMs) newItem.bufferMinMs = item.bufferMinMs;

          if (item.encPassphrase) newItem.encPassphrase = item.encPassphrase;
          if (item.encKeyLen) newItem.encKeyLen = item.encKeyLen;
          if (item.encType) newItem.encType = item.encType;
          if (item.udpAddress) newItem.udpAddress = item.udpAddress;
          if (item.udpPort) newItem.udpPort = item.udpPort;

          await this.updateStreamSource(newItem);
          await this.listStreamSources();
          this.select(this.streamSources, "streamSources");

          break;
        }
        case "streamDestinations": {
          newItem.streamDestinationRouterDestinationId = item.itemRouterDestinationId;

          if (item.type) newItem.type = item.type;
          if (item.address) newItem.address = item.address;

          if (item.port) newItem.port = item.port;
          if (item.talkbackAddress) newItem.talkbackAddress = item.talkbackAddress;
          if (item.talkbackPort) newItem.talkbackPort = item.talkbackPort;
          if (item.latencyMs) newItem.latencyMs = item.latencyMs;

          if (item.bufferMaxMs) newItem.bufferMaxMs = item.bufferMaxMs;
          if (item.bufferMinMs) newItem.bufferMinMs = item.bufferMinMs;
          if (item.encPassphrase) newItem.encPassphrase = item.encPassphrase;
          if (item.encKeyLen) newItem.encKeyLen = item.encKeyLen;
          if (item.encType) newItem.encType = item.encType;
          if (item.udpAddress) newItem.udpAddress = item.udpAddress;
          if (item.udpPort) newItem.udpPort = item.udpPort;
          if (item.udpRtt) newItem.udpRtt = item.udpRtt;

          await this.updateStreamDestination(newItem);
          await this.listStreamDestinations();
          this.select(this.streamDestinations, "streamDestinations");
          break;
        }
        default:
          break;
      }
      this.sortedList[index].saving = false;
      this.inEditMode = false;
    },

    editItem(item) {
      this.editedItem = JSON.parse(JSON.stringify(item));

      // Convert location string to array for inputs (multiple selection) - add to both item and editedItem
      if (this.listType === "input" && item.location && typeof item.location === 'string') {
        const locationArray = item.location.split(',').map(code => code.trim()).filter(code => code.length > 0);
        this.$set(item, 'locationArray', locationArray);
        this.editedItem.locationArray = locationArray;
      } else if (this.listType === "input") {
        this.$set(item, 'locationArray', []);
        this.editedItem.locationArray = [];
      }

      if (this.listType === "output") {
        this.normalizeOutputForEdit(this.editedItem);
        this.normalizeOutputForEdit(item);
        this.editedItem.smEndpoints = this.getEditSmEndpointsArray(this.editedItem);
        item.smEndpoints = this.getEditSmEndpointsArray(item);
        if (this.editedItem.outputType === "ROUTE" && this.editedItem.streamRouterId) {
          this.loadStreamRouterInterfacesForTarget(this.editedItem.streamRouterId)
            .then((interfaces) => {
              this.$set(this.editedItem, "_availableInterfaces", interfaces);
            })
            .catch(() => {
              this.$set(this.editedItem, "_availableInterfaces", []);
            });
        }
        if (
          this.editedItem.outputType === "OTT" &&
          this.editedItem.wowzaServerId &&
          this.editedItem.wowzaApplicationId
        ) {
          this.loadWowzaTargetsAndTemplates({
            serverId: this.editedItem.wowzaServerId,
            applicationId: this.editedItem.wowzaApplicationId,
          }).then(() => {
            const selectedTarget = this.wowzaTargetsFromStore.find(
              (target) =>
                target.id === this.editedItem.wowzaTargetId ||
                target.name === this.editedItem.wowzaTargetId
            );
            if (selectedTarget) {
              this.editedItem.wowzaTargetConfig = this.normalizeWowzaTargetConfig(selectedTarget);
            }
          });
        }
        if (this.editedItem.outputType === "MEDIA_CONNECT") {
          this.hydrateMediaConnectOutputDetails(this.editedItem);
        }
      }

      this.inEditMode = true;
    },
    cancelEdit(item, index) {
      this.inEditMode = false;
      const itemIndex = this.sortedList.findIndex((el) => el.id === item.id);
      this.sortedList[itemIndex].id = this.editedItem.id;
      this.sortedList[itemIndex].name = this.editedItem.name;
      this.sortedList[itemIndex].description = this.editedItem.description;
      this.sortedList[itemIndex].expectedVersion = this.editedItem.version;
      this.sortedList[itemIndex].claimsCanAccess = this.editedItem.claimsCanAccess;
      this.sortedList[itemIndex].claimsCanEdit = this.editedItem.edit;

      switch (this.listType) {
        case "input":
          this.sortedList[itemIndex].streamFileBaseName = this.editedItem.streamFileBaseName;
          this.sortedList[itemIndex].type = this.editedItem.type;
          this.sortedList[itemIndex].inputDownlinkConfigId = this.editedItem.inputDownlinkConfigId;
          this.sortedList[itemIndex].frcAvailable = this.editedItem.frcAvailable;
          this.sortedList[itemIndex].requireDetails = this.editedItem.requireDetails;
          break;
        case "output":
          this.sortedList[itemIndex].outputType = this.editedItem.outputType;
          this.sortedList[itemIndex].status = this.editedItem.status;
          this.sortedList[itemIndex].url = this.editedItem.url;
          this.sortedList[itemIndex].location = this.editedItem.location;
          this.sortedList[itemIndex].allowExternalConfigUpdate =
            this.editedItem.allowExternalConfigUpdate;
          this.sortedList[itemIndex].ottApplication = this.editedItem.ottApplication;
          this.sortedList[itemIndex].ottNoStremKeyRequired = this.editedItem.ottNoStremKeyRequired;
          this.sortedList[itemIndex].ottPlatform = this.editedItem.ottPlatform;
          this.sortedList[itemIndex].ottServer = this.editedItem.ottServer;
          this.sortedList[itemIndex].displayName = this.editedItem.displayName;
          this.sortedList[itemIndex].ottDefaultTranscoderProfile = this.editedItem.ottDefaultTranscoderProfile;
          this.sortedList[itemIndex].streamRouterId = this.editedItem.streamRouterId;
          this.sortedList[itemIndex].interfaceId = this.editedItem.interfaceId;
          this.sortedList[itemIndex].interfaceName = this.editedItem.interfaceName;
          this.sortedList[itemIndex].interfaceDescription = this.editedItem.interfaceDescription;
          this.sortedList[itemIndex].routeType = this.editedItem.routeType;
          this.sortedList[itemIndex].smEndpoints = this.getEditSmEndpointsArray(this.editedItem);
          this.sortedList[itemIndex].routeInterfaceConflict = this.editedItem.routeInterfaceConflict;
          this.sortedList[itemIndex].techexOutputId = this.editedItem.techexOutputId;
          this.sortedList[itemIndex].techexEdgeId = this.editedItem.techexEdgeId;
          this.sortedList[itemIndex].techexBlankStreamId = this.editedItem.techexBlankStreamId;
          this.sortedList[itemIndex].routerOutputArn = this.editedItem.routerOutputArn;
          this.sortedList[itemIndex].routingScope = this.editedItem.routingScope;
          break;
        case "outputProfile": {
          break;
        }
        case "routers":
          this.sortedList[itemIndex].routerAccountId = this.editedItem.account.id;
          break;
        case "routerGroups": {
          this.sortedList[itemIndex].routerGroupRouterId = this.editedItem.router.id;
          break;
        }
        case "sources": {
          this.sortedList[itemIndex].originRouterGroup = this.editedItem.originRouterGroup;
          this.sortedList[itemIndex].originRouterId = this.editedItem.originRouterId;
          this.sortedList[itemIndex].originRouterSourceId = this.editedItem.originRouterSourceId;
          break;
        }
        case "destinations": {
          this.sortedList[itemIndex].originRouterDestinationId =
            this.editedItem.originRouterDestinationId;
          this.sortedList[itemIndex].routerDestinationDefaultSourceId =
            this.editedItem.routerDestinationDefaultSourceId;
          this.sortedList[itemIndex].originRouterGroup = this.editedItem.originRouterGroup;
          this.sortedList[itemIndex].originRouterId = this.editedItem.originRouterId;
          break;
        }
        case "streamSources": {
          if (this.editedItem.type) this.sortedList[itemIndex].type = this.editedItem.type;
          if (this.editedItem.port) this.sortedList[itemIndex].port = this.editedItem.port;
          if (this.editedItem.address) this.sortedList[itemIndex].address = this.editedItem.address;
          if (this.editedItem.talkbackAddress)
            this.sortedList[itemIndex].talkbackAddress = this.editedItem.talkbackAddress;
          if (this.editedItem.talkbackPort)
            this.sortedList[itemIndex].talkbackPort = this.editedItem.talkbackPort;
          if (this.editedItem.latencyMs)
            this.sortedList[itemIndex].latencyMs = this.editedItem.latencyMs;

          if (this.editedItem.bufferMaxMs)
            this.sortedList[itemIndex].bufferMaxMs = this.editedItem.bufferMaxMs;
          if (this.editedItem.bufferMinMs)
            this.sortedList[itemIndex].bufferMinMs = this.editedItem.bufferMinMs;

          if (this.editedItem.encPassphrase)
            this.sortedList[itemIndex].encPassphrase = this.editedItem.encPassphrase;
          if (this.editedItem.encKeyLen)
            this.sortedList[itemIndex].encKeyLen = this.editedItem.encKeyLen;
          if (this.editedItem.encType) this.sortedList[itemIndex].encType = this.editedItem.encType;
          if (this.editedItem.udpAddress)
            this.sortedList[itemIndex].udpAddress = this.editedItem.udpAddress;
          if (this.editedItem.udpPort) this.sortedList[itemIndex].udpPort = this.editedItem.udpPort;
          break;
        }
        case "streamDestinations": {
          this.sortedList[itemIndex].streamDestinationRouterDestinationId =
            this.editedItem.itemRouterDestinationId;

          if (this.editedItem.type) this.sortedList[itemIndex].type = this.editedItem.type;
          if (this.editedItem.address) this.sortedList[itemIndex].address = this.editedItem.address;

          if (this.editedItem.port) this.sortedList[itemIndex].port = this.editedItem.port;
          if (this.editedItem.talkbackAddress)
            this.sortedList[itemIndex].talkbackAddress = this.editedItem.talkbackAddress;
          if (this.editedItem.talkbackPort)
            this.sortedList[itemIndex].talkbackPort = this.editedItem.talkbackPort;
          if (this.editedItem.latencyMs)
            this.sortedList[itemIndex].latencyMs = this.editedItem.latencyMs;

          if (this.editedItem.bufferMaxMs)
            this.sortedList[itemIndex].bufferMaxMs = this.editedItem.bufferMaxMs;
          if (this.editedItem.bufferMinMs)
            this.sortedList[itemIndex].bufferMinMs = this.editedItem.bufferMinMs;
          if (this.editedItem.encPassphrase)
            this.sortedList[itemIndex].encPassphrase = this.editedItem.encPassphrase;
          if (this.editedItem.encKeyLen)
            this.sortedList[itemIndex].encKeyLen = this.editedItem.encKeyLen;
          if (this.editedItem.encType) this.sortedList[itemIndex].encType = this.editedItem.encType;
          if (this.editedItem.udpAddress)
            this.sortedList[itemIndex].udpAddress = this.editedItem.udpAddress;
          if (this.editedItem.udpPort) this.sortedList[itemIndex].udpPort = this.editedItem.udpPort;
          if (this.editedItem.udpRtt) this.sortedList[itemIndex].udpRtt = this.editedItem.udpRtt;
          break;
        }
        default:
          break;
      }
    },
    copy(str) {
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$message({ message: "ID copied to clipboard" });
    },
    loadPage(page) {
      this.page = page;
    },

    // Validate smEndpoints JSON format for ROUTE-type outputs
    validateSmEndpoints(item) {
      // Clear any existing error
      this.$set(item, "smEndpointsError", null);

      // Skip validation if not a ROUTE type or if empty
      if (item.outputType !== "ROUTE" || !item.smEndpoints) {
        return;
      }

      try {
        const endpoints = JSON.parse(item.smEndpoints);

        // Ensure it's an array
        if (!Array.isArray(endpoints)) {
          this.$set(item, "smEndpointsError", "smEndpoints must be a JSON array");
          return;
        }

        // Validate each endpoint has required fields
        const invalidEndpoints = endpoints.filter((endpoint) => {
          const hasInterfaceId = endpoint.interfaceId && typeof endpoint.interfaceId === "string";
          const hasInterfaceName =
            endpoint.interfaceName && typeof endpoint.interfaceName === "string";
          const hasStreamManagerId =
            endpoint.streamManagerId && typeof endpoint.streamManagerId === "string";
          const hasCorrectType = String(endpoint.type || "").toUpperCase() === "SR";

          if (!hasInterfaceId || !hasInterfaceName || !hasStreamManagerId || !hasCorrectType) {
            return true;
          }
          return false;
        });

        if (invalidEndpoints.length > 0) {
          this.$set(
            item,
            "smEndpointsError",
            'Each endpoint must have interfaceId, interfaceName, streamManagerId, and type="SR"'
          );
          return;
        }

        // Auto-format the JSON for better readability
        item.smEndpoints = JSON.stringify(
          endpoints.map((endpoint) => ({
            ...endpoint,
            type: "SR",
          })),
          null,
          2
        );
      } catch (error) {
        this.$set(item, "smEndpointsError", "Invalid JSON format");
      }
    },

    // Stream Manager Endpoints management methods
    addSmEndpoint() {
      if (!this.form.output.smEndpoints) {
        this.$set(this.form.output, "smEndpoints", []);
      }

      this.form.output.smEndpoints.push({
        ...this.normalizeRouteEndpoint(),
        _validationErrors: [],
      });
    },

    removeSmEndpoint(index) {
      this.form.output.smEndpoints.splice(index, 1);
    },

    validateSmEndpointField(endpoint, fieldName) {
      // Clear existing validation errors for this field
      if (!Array.isArray(endpoint._validationErrors)) {
        endpoint._validationErrors = [];
      }
      endpoint._validationErrors = endpoint._validationErrors.filter((error) => !error.includes(fieldName));

      // Validate required fields
      const requiredFields = ["interfaceId", "interfaceName", "streamManagerId", "type"];

      if (requiredFields.includes(fieldName)) {
        if (!endpoint[fieldName] || endpoint[fieldName].trim() === "") {
          endpoint._validationErrors.push(`${fieldName} is required`);
        }
      }

      // Validate type field specifically
      if (fieldName === "type" && String(endpoint.type || "").toUpperCase() !== "SR") {
        endpoint._validationErrors.push('Type must be "SR"');
      }

      // Validate interfaceId format (should be UUID-like)
      if (fieldName === "interfaceId" && endpoint.interfaceId) {
        const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        if (!uuidRegex.test(endpoint.interfaceId)) {
          endpoint._validationErrors.push("Interface ID should be a valid UUID format");
        }
      }

      this.$forceUpdate(); // Trigger reactivity for validation errors
    },

    // Edit-specific smEndpoints methods for inline editing
    getEditSmEndpointsArray(item) {
      return this.sanitizeRouteEndpoints(item.smEndpoints, {
        interfaceId: item.interfaceId,
        interfaceName: item.interfaceName,
        streamManagerId: item.streamRouterId,
        interfaceDescription: item.interfaceDescription,
      });
    },

    addEditSmEndpoint(item) {
      // Ensure smEndpoints is converted to array format
      this.ensureEditSmEndpointsIsArray(item);

      item.smEndpoints.push(this.normalizeRouteEndpoint());
      this.updateEditJsonString(item);
    },

    ensureEditSmEndpointsIsArray(item) {
      if (!item.smEndpoints) {
        this.$set(item, "smEndpoints", []);
        return;
      }

      // If it's already an array, nothing to do
      if (Array.isArray(item.smEndpoints)) {
        this.$set(
          item,
          "smEndpoints",
          item.smEndpoints.map((endpoint) => this.normalizeRouteEndpoint(endpoint))
        );
        return;
      }

      // If it's a string, parse it
      if (typeof item.smEndpoints === "string") {
        try {
          const parsed = JSON.parse(item.smEndpoints);
          const validatedEndpoints = Array.isArray(parsed)
            ? parsed.map((endpoint) => this.normalizeRouteEndpoint(endpoint))
            : [];

          this.$set(item, "smEndpoints", validatedEndpoints);
        } catch (error) {
          console.warn("Failed to parse smEndpoints JSON, initializing empty array:", error);
          this.$set(item, "smEndpoints", []);
        }
      }
    },

    removeEditSmEndpoint(item, index) {
      // Ensure smEndpoints is an array
      this.ensureEditSmEndpointsIsArray(item);

      if (item.smEndpoints && index >= 0 && index < item.smEndpoints.length) {
        item.smEndpoints.splice(index, 1);
        this.updateEditJsonString(item);
      }
    },

    validateEditSmEndpoint(item, endpoint) {
      // Ensure smEndpoints is an array first
      this.ensureEditSmEndpointsIsArray(item);

      if (!endpoint._validationErrors) {
        this.$set(endpoint, "_validationErrors", {});
      }

      // Clear previous errors
      endpoint._validationErrors = {};

      // Validate required fields
      if (!endpoint.interfaceId || endpoint.interfaceId.trim() === "") {
        endpoint._validationErrors.interfaceId = "Interface ID is required";
      }

      if (!endpoint.interfaceName || endpoint.interfaceName.trim() === "") {
        endpoint._validationErrors.interfaceName = "Interface Name is required";
      }

      if (!endpoint.streamManagerId || endpoint.streamManagerId.trim() === "") {
        endpoint._validationErrors.streamManagerId = "Stream Manager ID is required";
      }

      if (String(endpoint.type || "").toUpperCase() !== "SR") {
        endpoint._validationErrors.type = 'Type must be "SR"';
      }

      this.updateEditJsonString(item);
      this.$forceUpdate();
    },

    updateEditJsonString(item) {
      // Ensure smEndpoints is an array
      this.ensureEditSmEndpointsIsArray(item);

      if (!item.smEndpoints || item.smEndpoints.length === 0) {
        this.$set(item, "_jsonEditValue", "[]");
        return;
      }

      // Remove validation errors before serializing
      const cleanEndpoints = item.smEndpoints.map((endpoint) => {
        const { _validationErrors, ...cleanEndpoint } = endpoint;
        return cleanEndpoint;
      });

      this.$set(item, "_jsonEditValue", JSON.stringify(cleanEndpoints, null, 2));
    },

    getEditSmEndpointsJson(item) {
      // Ensure smEndpoints is an array
      this.ensureEditSmEndpointsIsArray(item);

      if (!item.smEndpoints || item.smEndpoints.length === 0) {
        return "[]";
      }

      // Remove validation errors before displaying
      const cleanEndpoints = item.smEndpoints.map((endpoint) => {
        const { _validationErrors, ...cleanEndpoint } = endpoint;
        return cleanEndpoint;
      });

      return JSON.stringify(cleanEndpoints, null, 2);
    },

    parseEditSmEndpointsFromJson(item) {
      if (!item._jsonEditValue || !item._jsonEditValue.trim()) {
        this.$set(item, "smEndpoints", []);
        return;
      }

      try {
        const parsed = JSON.parse(item._jsonEditValue);

        if (!Array.isArray(parsed)) {
          this.$message.error("JSON must be an array");
          return;
        }

        // Validate structure and add validation errors property
        const validatedEndpoints = parsed.map((endpoint) => {
          return this.normalizeRouteEndpoint(endpoint);
        });

        this.$set(item, "smEndpoints", validatedEndpoints);

        // Validate all endpoints
        validatedEndpoints.forEach((endpoint) => {
          this.validateEditSmEndpoint(item, endpoint);
        });
      } catch (error) {
        this.$message.error(`Invalid JSON: ${error.message}`);
      }
    },

    // Stream Router Interface management methods
    async loadStreamRouterInterfacesForTarget(streamRouterId) {
      if (!streamRouterId) return [];

      const result = await this.listStreamRouterInterfaces({
        streamRouterId,
      });

      if (result.success && result.interfaces) {
        return result.interfaces.map((routerInterface) => ({
          id: routerInterface.uuid,
          name: routerInterface.name,
          uuid: routerInterface.uuid,
          status: routerInterface.status,
          description: routerInterface.description || "",
          tags: routerInterface.tags || [],
        }));
      }

      if (result.success && result.dataJson) {
        const parsedData = this.safeJsonParse(result.dataJson, {});
        return (parsedData.interfaces || []).map((routerInterface) => ({
          id: routerInterface.uuid,
          name: routerInterface.name,
          uuid: routerInterface.uuid,
          status: routerInterface.status,
          description: routerInterface.description || "",
          tags: routerInterface.tags || [],
        }));
      }

      return [];
    },

    async loadRouteInterfaceDetails(streamRouterId, interfaceId) {
      const result = await this.getStreamRouterInterface({
        streamRouterId,
        interfaceId,
      });
      if (!result.success || !result.dataJson) {
        throw new Error(result.message || "Failed to load interface details");
      }

      const parsedData = this.safeJsonParse(result.dataJson, null);
      if (!parsedData) {
        throw new Error("Failed to parse interface details");
      }
      if (parsedData.error) {
        throw new Error(parsedData.error);
      }

      const details = parsedData.interface || parsedData;
      return {
        interfaceName: details.name || details.interfaceName || "",
        interfaceDescription: details.description || "",
        streamManagerId: details.streamManagerId || streamRouterId,
      };
    },

    async onStreamRouterChange() {
      if (!this.form.output.streamRouterId) {
        this.streamRouterInterfaces = [];
        this.form.output.interfaceId = null;
        this.form.output.interfaceName = null;
        this.form.output.interfaceDescription = "";
        this.form.output.smEndpoints = [];
        this.form.output.routeInterfaceConflict = null;
        return;
      }

      this.loadingStreamRouterInterfaces = true;
      try {
        this.streamRouterInterfaces = await this.loadStreamRouterInterfacesForTarget(
          this.form.output.streamRouterId
        );
      } catch (error) {
        console.error("Error loading stream router interfaces:", error);
        this.streamRouterInterfaces = [];
        this.$message.error("Failed to load stream router interfaces");
      } finally {
        this.loadingStreamRouterInterfaces = false;
      }

      this.form.output.interfaceId = null;
      this.form.output.interfaceName = null;
      this.form.output.interfaceDescription = "";
      this.form.output.smEndpoints = [];
      this.form.output.routeInterfaceConflict = null;
    },

    async onInterfaceChange() {
      if (!this.form.output.streamRouterId || !this.form.output.interfaceId) return;

      this.loadingInterfaceDetails = true;
      try {
        const interfaceDetails = await this.loadRouteInterfaceDetails(
          this.form.output.streamRouterId,
          this.form.output.interfaceId
        );
        this.form.output.interfaceName = interfaceDetails.interfaceName;
        this.form.output.interfaceDescription = interfaceDetails.interfaceDescription;
        this.form.output.smEndpoints = this.sanitizeRouteEndpoints([], {
          interfaceId: this.form.output.interfaceId,
          interfaceName: interfaceDetails.interfaceName,
          streamManagerId: interfaceDetails.streamManagerId,
          interfaceDescription: interfaceDetails.interfaceDescription,
        }).map((endpoint) => ({
          ...endpoint,
          _validationErrors: [],
        }));
        this.updateRouteConflictState(this.form.output);
      } catch (error) {
        console.error("Error loading interface details:", error);
        this.$message.error(error.message || "Failed to load interface details");
        this.form.output.interfaceName = "";
        this.form.output.interfaceDescription = "";
      } finally {
        this.loadingInterfaceDetails = false;
      }
    },

    async onEditStreamRouterChange(item) {
      if (!item.streamRouterId) {
        this.$set(item, "_availableInterfaces", []);
        item.interfaceId = null;
        item.interfaceName = null;
        item.interfaceDescription = "";
        item.smEndpoints = [];
        item.routeInterfaceConflict = null;
        return;
      }

      try {
        const interfaces = await this.loadStreamRouterInterfacesForTarget(item.streamRouterId);
        this.$set(item, "_availableInterfaces", interfaces);
      } catch (error) {
        console.error("Error loading stream router interfaces for inline edit:", error);
        this.$set(item, "_availableInterfaces", []);
        this.$message.error("Failed to load stream router interfaces");
      }

      item.interfaceId = null;
      item.interfaceName = null;
      item.interfaceDescription = "";
      item.smEndpoints = [];
      item.routeInterfaceConflict = null;
    },

    async onEditInterfaceChange(item) {
      if (!item.streamRouterId || !item.interfaceId) return;

      this.loadingInterfaceDetails = true;
      try {
        const interfaceDetails = await this.loadRouteInterfaceDetails(
          item.streamRouterId,
          item.interfaceId
        );
        item.interfaceName = interfaceDetails.interfaceName;
        item.interfaceDescription = interfaceDetails.interfaceDescription;
        item.smEndpoints = this.sanitizeRouteEndpoints([], {
          interfaceId: item.interfaceId,
          interfaceName: interfaceDetails.interfaceName,
          streamManagerId: interfaceDetails.streamManagerId,
          interfaceDescription: interfaceDetails.interfaceDescription,
        });
        this.updateRouteConflictState(item);
      } catch (error) {
        console.error("Error loading interface details for inline edit:", error);
        this.$message.error(error.message || "Failed to load interface details");
        item.interfaceName = "";
        item.interfaceDescription = "";
      } finally {
        this.loadingInterfaceDetails = false;
      }
    },

    generateOutputConfig(outputData) {
      return this.buildOutputConfigByType(outputData);
    },

    parseOutputConfig(outputData) {
      return this.parseOutputConfigByType(outputData);
    },

    // Handle changes in location array for inline editing
    onLocationArrayChange(item) {
      if (item.locationArray && Array.isArray(item.locationArray)) {
        // Convert array back to comma-separated string
        item.location = item.locationArray.join(', ');
      }
    },

  },
};
</script>
<style>
#permissions-simple .data-content .items .data-list-item {
  cursor: pointer;
  transition: 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.el-loading-spinner svg {
  margin: 0 auto;
}

pre {
  line-height: 13px;
  color: #fff;
}

#permissions-simple {
  padding: 10px 20px;
  overflow-y: hidden;
}
#permissions-simple .data-header {
  margin-bottom: 0;
  display: grid;
  align-items: center;
  background: #13191d;
  position: fixed;
  top: 49px;
  left: 219px;
  right: 20px;
  z-index: 1;
  padding-left: 16px;
}
#permissions-simple .data-header-name {
  font-size: 24px;
  color: #cdd6ee;
  text-transform: capitalize;
}
#permissions-simple .data-header .icon-btn.active {
  color: #00ff80 !important;
}
#permissions-simple .dialog-form .claim-cascade-input i.bi,
#permissions-simple .dialog-form .claim-cascade-input .ma-icon {
  top: 6px;
  padding: 3px 0;
  left: -6px;
  color:#fff;
  background: #13191d;
  z-index: 1;
  position: absolute;
}
#permissions-simple .el-divider {
  margin-top: 35px;
}
#permissions-simple .el-divider .el-divider__text {
  color: #13191d;
}
#permissions-simple .sidebar-item {
  font-size: 14px;
}
#permissions-simple .sidebar-item-actions {
  opacity: 1;
  padding-top: 0px;
}
#permissions-simple .sidebar-item-actions .bi {
  color: #cdd6ee;
}
#permissions-simple .data-content {
  display: grid;
  gap: 16px;
}
#permissions-simple .data-content .btn-group {
  margin-left: 12px;
  display: inline-block;
  border-radius: 2px;
  line-height: 32px;
  padding-left: 8px;
}
#permissions-simple .data-content .btn-group .icon-btn {
  line-height: 32px !important;
}
#permissions-simple .data-content .active-item-details {
  display: grid;
  grid-template-columns: 400px auto;
}
#permissions-simple .data-content .active-item-details .active-item-actions {
  text-align: right;
}
#permissions-simple .data-content .items {
  display: grid;
  gap: 8px;
  margin-top: 40px;
  width: 100%;
}
#permissions-simple .data-content .items input.el-input__inner {
  border: 1px solid #13191d;
  background: #13191d;
  color: #fff;
}
#permissions-simple .data-content .items .item-downlink-config {
  line-height: 18px;
}
#permissions-simple .data-content .items .item-downlink-config div {
  min-width: 100px;
  margin-right: 20px;
}
#permissions-simple .data-content .items .item-downlink-config strong {
  color: #fff;
  font-weight: normal;
}
#permissions-simple .data-content .items .extra-fields {
  grid-column: 1 / span 2;
  padding-left: 16px;
  padding-right: 16px;
}
#permissions-simple .data-content .items .extra-fields .data-item {
  display: grid;
  grid-template-columns: 130px auto;
}
#permissions-simple .data-content .items .extra-fields .data-item-label {
  line-height: 16px;
  display: grid;
  align-content: center;
  padding-right: 3px;
}
#permissions-simple .data-content .items .extra-fields .data-item .el-select {
  width: 100%;
}
#permissions-simple .data-content .items .extra-fields .data-item .el-tag {
  background: #242a33;
  border: 1px solid #13191d;
}
#permissions-simple .data-content .items .claim-cascade {
  display: grid;
  grid-template-columns: 130px auto;
  grid-column: 1 / span 2;
  padding-right: 16px;
  padding-left: 16px;
  line-height: 32px;
  margin-bottom: 0px;
}
#permissions-simple .data-content .items .claim-cascade-input .el-cascader {
  width: 100%;
  background: transparent;
}
#permissions-simple .data-content .items .claim-cascade-input .el-cascader .el-input input {
  background: #13191d;
  border: 1px solid #13191d;
}
#permissions-simple .data-content .items .claim-cascade-input .el-cascader .el-tag {
  background: #242a33;
}
#permissions-simple .data-content .items .vb-content {
  padding: 2px 20px 4px 4px;
}
#permissions-simple .data-content .items .data-list-item {
  cursor: pointer;
}
#permissions-simple .data-content .items .data-list-item .data-list-item-name {
  text-overflow: ellipsis;
  overflow: hidden;
}
#permissions-simple
  .data-content
  .items
  .data-list-item
  .data-list-item-name
  .data-list-item-description {
  display: block;
  line-height: 1;
  position: relative;
  top: -7px;
  opacity: 0.5;
}
#permissions-simple .data-content .items .data-list-item .data-list-item-actions {
  margin-right: 8px;
}
#permissions-simple .data-content .items .data-list-item .data-list-item-actions .el-tag {
  margin-left: 10px;
}
#permissions-simple .data-content .items .data-list-item .claim-cascade-input .el-tag {
  margin-right: 10px;
}
#permissions-simple .data-content .items .data-list-item.active {
  outline: 2px solid #ff9f31;
}
#permissions-simple .data-content .disabled {
  pointer-events: none;
  opacity: 0.3;
}
#permissions-simple .data-content .active-item-details {
  font-size: 18px;
  color: #fff;
  margin-bottom: 24px;
}
#permissions-simple .data-content .icon-btn {
  color: #cdd6ee;
}
#permissions-simple .data-content .client {
  padding: 16px;
  border: 1px solid #242a33;
  border-radius: 2px;
  margin-bottom: 24px;
}
#permissions-simple .data-content .client .active {
  color: #fff;
  background: #ea0d51;
}
#permissions-simple .data-content .client-info {
  display: grid;
  grid-template-columns: 200px auto;
  margin-top: -33px;
  background: #242a33;
  padding: 0 16px;
  line-height: 40px;
  margin: -33px -17px 10px -17px;
  border-radius: 2px 4px 0px 0px;
}
#permissions-simple .data-content .client-info .client-name {
  color: #cdd6ee;
}
#permissions-simple .data-content .client-info .client-claims {
  text-align: right;
}
#permissions-simple .data-content .client .account .account-info {
  display: grid;
  grid-template-columns: 200px auto;
  margin-top: 20px;
  line-height: 40px;
}
#permissions-simple .data-content .client .account .account-info .account-name {
  color: #cdd6ee;
}
#permissions-simple .data-content .client .account .account-info .account-claims {
  text-align: right;
}
#permissions-simple .data-content .account-permissions .claim {
  display: inline-block;
  width: 250px;
  margin-bottom: 6px;
  margin-right: 6px;
  background: #242a33;
  padding: 6px;
  border-radius: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  height: 40px;
}
#permissions-simple .data-content .account-permissions .claim .claim-actions {
  position: absolute;
  top: 0;
  right: 0;
  background: #242a33;
}
#permissions-simple .data-content .account-permissions .claim .claim-actions .active {
  color: #fff;
  background: #ea0d51;
}
#permissions-simple .data-content .account-permissions .claim .claim-name {
  color: #cdd6ee;
}
#permissions-simple .data-content .account-permissions .claim .claim-name span {
  font-size: 12px;
  width: 100%;
  color: #66718d;
  display: block;
}
#permissions-simple .data-content .account-permissions .claim .claim-name small {
  font-size: 10px;
  color: #66718d;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
}
#permissions-simple .el-select .el-input.is-disabled .el-input__inner {
  cursor: not-allowed;
  opacity: 0.7;
}

.el-dialog__wrapper .el-cascader,
.el-dialog__wrapper .el-select {
  width: 100%;
}

#permissions-simple .permissions-modal--transcoding {
  background: #13191d;
  /* border: 1px solid rgba(255, 255, 255, 0.15); */
  border-radius: 12px;
}

#permissions-simple .permissions-modal--transcoding .el-dialog__header {
  background: #13191d;
  /* border-bottom: 1px solid rgba(255, 255, 255, 0.15); */
}

#permissions-simple .permissions-modal--transcoding .el-dialog__title,
#permissions-simple .permissions-modal--transcoding .el-dialog__headerbtn .el-dialog__close {
  color: #cdd6ee;
}

#permissions-simple .permissions-modal--transcoding .el-dialog__body {
  background: #13191d;
}

#permissions-simple .permissions-modal--transcoding .el-dialog__footer {
  background: #13191d;
  /* border-top: 1px solid rgba(255, 255, 255, 0.15); */
}

#permissions-simple .permissions-modal--transcoding .transcoding-create-form {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

#permissions-simple .permissions-modal--transcoding .transcoding-create-form > .el-form-item,
#permissions-simple .permissions-modal--transcoding .transcoding-create-form > div {
  margin-bottom: 0;
}

#permissions-simple .permissions-modal--transcoding .transcoding-create-form > div {
  grid-column: 1 / -1;
}

#permissions-simple .permissions-modal--transcoding .el-form-item__label {
  color: #cdd6ee;
}

#permissions-simple .permissions-modal--transcoding .el-divider {
  margin: 6px 0 10px;
}

#permissions-simple .permissions-modal--transcoding .el-divider__text {
  background: #13191d;
  color: #cdd6ee;
}

#permissions-simple .permissions-modal--transcoding .el-input__inner,
#permissions-simple .permissions-modal--transcoding .el-textarea__inner,
#permissions-simple .permissions-modal--transcoding .el-select .el-input__inner,
#permissions-simple .permissions-modal--transcoding .el-select-dropdown__item {
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #cdd6ee;
}

#permissions-simple .permissions-modal--transcoding .el-input__inner:focus,
#permissions-simple .permissions-modal--transcoding .el-textarea__inner:focus,
#permissions-simple .permissions-modal--transcoding .el-select .el-input.is-focus .el-input__inner {
  border-color: #ffaa00;
}

#permissions-simple .permissions-modal--transcoding .el-button--primary {
  background: #ffaa00;
  border-color: #ffaa00;
  color: #13191d;
}

#permissions-simple .permissions-modal--transcoding .el-button--primary:hover,
#permissions-simple .permissions-modal--transcoding .el-button--primary:focus {
  filter: brightness(1.05);
}

#permissions-simple .permissions-modal--transcoding [class*="bg-slate"] {
  background-color: rgba(0, 0, 0, 0.2) !important;
}

#permissions-simple .permissions-modal--transcoding [class*="border-slate"] {
  border-color: rgba(255, 255, 255, 0.15) !important;
}

#permissions-simple .permissions-modal--transcoding [class*="text-slate"] {
  color: #cdd6ee !important;
}

#permissions-simple .permissions-modal--transcoding [class*="bg-blue"] {
  background-color: rgba(255, 170, 0, 0.16) !important;
}

#permissions-simple .permissions-modal--transcoding [class*="text-blue"] {
  color: #ffaa00 !important;
}

#permissions-simple .permissions-modal--transcoding [class*="border-blue"] {
  border-color: transparent !important;
}

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: all;
}

.list-enter {
  opacity: 0;
}

.list-enter-to {
  opacity: 1;
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform-origin: left top;
}

/* Edit form smEndpoints styling */
.grid {
  display: grid;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.gap-3 {
  gap: 0.75rem;
}

.space-y-2 > * + * {
  margin-top: 0.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-3 {
  margin-bottom: 0.75rem;
}

.mt-1 {
  margin-top: 0.25rem;
}

.mt-4 {
  margin-top: 1rem;
}

.p-3 {
  padding: 0.75rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.border {
  border-width: 1px;
}

.border-2 {
  border-width: 2px;
}

.border-dashed {
  border-style: dashed;
}

.border-gray-300 {
  border-color: #d1d5db;
}

.rounded {
  border-radius: 0.25rem;
}

.bg-gray-50 {
  background-color: #f9fafb;
}

.bg-gray-100 {
  background-color: #f3f4f6;
}

.text-center {
  text-align: center;
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.font-medium {
  font-weight: 500;
}

.text-gray-500 {
  color: #6b7280;
}

.text-red-500 {
  color: #ef4444;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-end {
  justify-content: flex-end;
}

.block {
  display: block;
}

.max-h-32 {
  max-height: 8rem;
}

.overflow-y-auto {
  overflow-y: auto;
}

/* Input error state */
.el-input.is-error .el-input__inner {
  border-color: #f56565 !important;
}

/* Responsive grid for medium screens and up */
@media (min-width: 768px) {
  .md\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\:col-span-2 {
    grid-column: span 2 / span 2;
  }
}
</style>
